/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	__webpack_require__.p = typeof window !== 'undefined' && window.__STATICS_BASE_URL__ || __webpack_require__.p;
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1039);
/******/ })
/************************************************************************/
/******/ ({

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(104)('keys');
var uid = __webpack_require__(88);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ 1039:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _webBiLogger = __webpack_require__(195);

var _webBiLogger2 = _interopRequireDefault(_webBiLogger);

var _jquery = __webpack_require__(144);

var _jquery2 = _interopRequireDefault(_jquery);

var _fedopsLogger = __webpack_require__(227);

var _fedops = __webpack_require__(279);

var _fedops2 = _interopRequireDefault(_fedops);

var _once = __webpack_require__(1040);

var _once2 = _interopRequireDefault(_once);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(209);


var LIVE_SITE_OLO_SOCIAL_CLICK = 214;
var bi = _webBiLogger2.default.factory({ endpoint: 'rest' }).updateDefaults({ src: 61, evid: LIVE_SITE_OLO_SOCIAL_CLICK }).logger();
var fedopsLogger = (0, _fedopsLogger.create)(_fedops2.default['app_name']);

function getInstance() {
    try {
        var inst = location.search.match(/instance=([^&]+)/)[1];
        var instanceBase64 = inst.substr(inst.indexOf(".") + 1);
        var instanceJson = atob(instanceBase64);
        return JSON.parse(instanceJson);
    } catch (e) {
        console.error('ERROR: no instance', e);
    }
}

function biEventDispatcher() {
    var params = getDefaultParams();

    return function (platform) {
        bi.log((0, _extends3.default)({}, params, {
            platform: platform
        })).then(function () {
            // do something
        }).catch(function (err) {
            // do something
        });
    };
}

function getDefaultParams() {
    var instance = getInstance();

    return {
        visitorId: instance.uid || instance.aid,
        ownerId: instance.siteOwnerId,
        isMerchant: instance.uid === instance.siteOwnerId,
        msid: instance.metaSiteId,
        instance_id: instance.instanceId,
        bi_token: instance.biToken
    };
}

var reportFirstRender = (0, _once2.default)(function () {
    if (typeof performance !== 'undefined' && typeof performance.mark === 'function') {
        performance.mark('[perfer] app-loaded');
    }
});

(0, _jquery2.default)(document).ready(function () {
    (0, _jquery2.default)('.__preloader').remove();
    var sendBiEvent = biEventDispatcher();

    (0, _jquery2.default)('a').on('click', function () {
        var element = (0, _jquery2.default)(this);
        var platform = element.data('platform');
        var href = element.attr('href');

        if (href) {
            sendBiEvent(platform);
        }
    });
    fedopsLogger.appLoaded();
    reportFirstRender();
    if (typeof Wix !== 'undefined') {
        Wix.Performance.applicationLoaded();
    }
});

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(7);
var global = __webpack_require__(13);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(70) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ 1040:
/***/ (function(module, exports, __webpack_require__) {

var before = __webpack_require__(1041);

/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */
function once(func) {
  return before(2, func);
}

module.exports = once;


/***/ }),

/***/ 1041:
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(216);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n = toInteger(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}

module.exports = before;


/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
var document = __webpack_require__(13).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(28);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(73);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(90);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ 110:
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ 111:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BiLoggerClientFactory = __webpack_require__(196);
var BiLogger = __webpack_require__(113);
var biLoggerManager = __webpack_require__(114);

module.exports.BiLoggerFactory = BiLoggerClientFactory;
module.exports.BiLogger = BiLogger;
module.exports.BiLoggerManager = biLoggerManager.BiLoggerManager;

module.exports.factory = function () {
  return new BiLoggerClientFactory();
};
module.exports.manager = biLoggerManager.manager;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var assert = __webpack_require__(74);

var _require = __webpack_require__(197),
    mapValues = _require.mapValues,
    filterValues = _require.filterValues;

var promise = __webpack_require__(198);
var log = __webpack_require__(199);
var EventBuffer = __webpack_require__(200);

var BiLogger = function () {
  //TODO: validate args
  function BiLogger(options, context) {
    _classCallCheck(this, BiLogger);

    this._publishers = options.publishers;
    this._validators = options.validators || [];
    this._defaults = options.defaults;
    this._events = options.events || {};
    this._context = context || {};
    this._defaultValueTimeout = options.defaultValueTimeout || 5000;
    this._defaultContinueOnFail = options.defaultContinueOnFail || false;
    this._onPublisherFailHandler = options.onPublisherFailHandler || BiLogger._defaultPublisherFailHandler;
  }

  _createClass(BiLogger, [{
    key: 'log',
    value: function log(eventOrKey, eventOrContextOrUndefined, contextOrUndefined) {
      var _this = this;

      assert.defined(eventOrKey, 'Event object or event key must be provided.');

      var _extractEventAndConte = this._extractEventAndContext(eventOrKey, eventOrContextOrUndefined, contextOrUndefined),
          event = _extractEventAndConte.event,
          context = _extractEventAndConte.context;

      var useBatch = typeof context.useBatch !== 'undefined' ? context.useBatch : this._context.useBatch;

      if (useBatch) {
        var buffer = this._initBuffer(useBatch);

        var dynamicDefaults = filterValues(this._defaults, function (v) {
          return typeof v === 'function';
        });
        var resolvedDefaults = mapValues(dynamicDefaults, function (v) {
          return v();
        });

        return buffer.feed(Object.assign({}, event, resolvedDefaults), context);
      }

      return this._getDefaults().then(function (defaults) {
        var fullEvent = Object.assign({}, defaults, event);

        var validatorsResult = _this._validators.length === 0 ? true : _this._validators.some(function (validator) {
          return validator.match(fullEvent) && (validator.execute(fullEvent) || true);
        });

        if (!validatorsResult) {
          throw new Error('No validator accepted the event. Source: ' + fullEvent.src + ' Evid: ' + (fullEvent.evid || fullEvent.evtId));
        }

        return _this._send(fullEvent, context);
      });
    }
  }, {
    key: 'flush',
    value: function flush() {
      if (!this._buffer) {
        return Promise.resolve();
      }
      return this._buffer.flush();
    }
  }, {
    key: '_send',
    value: function _send(payload) {
      var _this2 = this;

      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return Promise.all(this._publishers.map(function (publisher) {
        var cloned = Object.assign({}, payload);

        return Promise.resolve().then(function () {
          return publisher(cloned, Object.assign({}, _this2._context, context));
        }).catch(function (error) {
          return _this2._onPublisherFailHandler(error, { publisherName: publisher.name });
        });
      })).then(function () {
        return undefined;
      });
    }
  }, {
    key: '_extractEventAndContext',
    value: function _extractEventAndContext(eventOrKey, eventOrContextOrUndefined, contextOrUndefined) {
      var event = void 0;
      var context = {};

      if (typeof eventOrKey !== 'string') {
        event = eventOrKey;
        context = eventOrContextOrUndefined || context;
      } else {
        event = this._events[eventOrKey];

        if (!event) {
          throw new assert.AssertionError('Event with key \'' + eventOrKey + '\' not found in event map.');
        }

        if (eventOrContextOrUndefined) {
          event = Object.assign({}, event, eventOrContextOrUndefined);
          context = contextOrUndefined || context;
        }
      }

      return { event: event, context: context };
    }
  }, {
    key: '_initBuffer',
    value: function _initBuffer(useBatch) {
      var _this3 = this;

      var debounceMs = useBatch === true ? 300 : useBatch;

      return this._buffer || (this._buffer = new EventBuffer(debounceMs).onFlush(function (batchPayload) {
        var staticDefaults = filterValues(_this3._defaults, function (v) {
          return typeof v !== 'function';
        });
        batchPayload.g = staticDefaults;

        return _this3._send(batchPayload, { useBatch: useBatch });
      }));
    }
  }, {
    key: '_handleDefaultsError',
    value: function _handleDefaultsError(err) {
      if (this._defaultContinueOnFail) {
        log.error(err);
        return null;
      }
      return Promise.reject(err);
    }
  }, {
    key: '_getDefaults',
    value: function _getDefaults() {
      var _this4 = this;

      if (!this._defaults) {
        return Promise.resolve({});
      }

      var promises = mapValues(this._defaults, function (value, key) {
        if (typeof value === 'function') {
          try {
            value = value();
          } catch (err) {
            return _this4._handleDefaultsError(err);
          }
        }
        if (value && typeof value.then !== 'function') {
          return value;
        }
        return promise.timedPromise(value, {
          message: 'Cannot get default value \'' + key + ' for BI Event\'',
          timeout: _this4._defaultValueTimeout
        }).catch(function (err) {
          return _this4._handleDefaultsError(err);
        });
      });

      return promise.allAsObject(promises);
    }
  }], [{
    key: '_defaultPublisherFailHandler',
    value: function _defaultPublisherFailHandler(error, _ref) {
      var publisherName = _ref.publisherName;

      return publisherName; // do nothing
    }
  }]);

  return BiLogger;
}();

module.exports = BiLogger;
//# sourceMappingURL=bi-logger.js.map

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var assert = __webpack_require__(74);

var BiLoggerManager = function () {
  function BiLoggerManager() {
    _classCallCheck(this, BiLoggerManager);

    this.reset();
  }

  _createClass(BiLoggerManager, [{
    key: 'reset',
    value: function reset() {
      this._handlers = [];
    }
  }, {
    key: 'onLoggerCreated',
    value: function onLoggerCreated(handler) {
      assert.defined(handler, 'Handler must be provided.');
      assert.func(handler, 'Handler must be a function.');

      this._handlers.push(handler);
    }
  }, {
    key: 'notifyLoggerCreated',
    value: function notifyLoggerCreated(logger) {
      this._handlers.forEach(function (handler) {
        return handler(logger);
      });
    }
  }]);

  return BiLoggerManager;
}();

module.exports = {
  manager: new BiLoggerManager(),
  BiLoggerManager: BiLoggerManager
};
//# sourceMappingURL=bi-logger-manager.js.map

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.manager = exports.factory = exports.Factory = void 0;
var wix_bi_logger_client_1 = __webpack_require__(112);
var assert = __importStar(__webpack_require__(204));
var publishers_1 = __webpack_require__(205);
var utils_1 = __webpack_require__(75);
var consent_policy_1 = __webpack_require__(207);
var common_config_1 = __webpack_require__(208);
var env_1 = __webpack_require__(15);
var constants_1 = __webpack_require__(36);
var types_1 = __webpack_require__(77);
var types_2 = __webpack_require__(77);
Object.defineProperty(exports, "PublishMethods", { enumerable: true, get: function () { return types_2.PublishMethods; } });
Object.defineProperty(exports, "EventCategories", { enumerable: true, get: function () { return types_2.EventCategories; } });
var env_2 = __webpack_require__(15);
Object.defineProperty(exports, "setHost", { enumerable: true, get: function () { return env_2.setHost; } });
var filterContext = function (context) {
    return Object.keys(context).reduce(function (res, key) {
        if (constants_1.EventContextMap[key] && typeof context[key] !== 'undefined') {
            res[constants_1.EventContextMap[key]] = context[key];
        }
        return res;
    }, {});
};
var getUserContext = function () {
    return utils_1.getCookies({
        clientId: '_wixCIDX',
        uuid: {
            name: '_wixUIDX',
            transform: function (value) { return typeof value === 'string' && value.split('|')[1]; },
        },
    });
};
var getBrand = function (commonConfigGetter) {
    return common_config_1.getCommonConfigValue('brand', commonConfigGetter());
};
var getPolicy = function (commonConfigGetter, consentPolicyGetter) {
    return common_config_1.getCommonConfigValue('consentPolicy', commonConfigGetter()) ||
        consent_policy_1.getConsentPolicy(consentPolicyGetter());
};
var validatePublishMethod = function (publishMethod) {
    return (Object.keys(types_1.PublishMethods)
        .map(function (key) { return types_1.PublishMethods[key]; })
        .indexOf(publishMethod) !== -1);
};
var Factory = /** @class */ (function () {
    function Factory(options) {
        if (options === void 0) { options = {}; }
        this.options = options;
        this.commonConfigGetter = function () { return undefined; };
        this.consentPolicyGetter = function () { return undefined; };
        this.initialized = false;
        this.muted = false;
        assert.ok(!options.publishMethod || validatePublishMethod(options.publishMethod), "Unsupported publish method \"" + options.publishMethod + "\"");
        this.loggerClientFactory = wix_bi_logger_client_1.factory();
    }
    Factory.prototype.initFactory = function () {
        var _this = this;
        if (this.initialized) {
            return this.loggerClientFactory;
        }
        this.initialized = true;
        this.updateDefaults(filterContext({
            brandId: function () { return getBrand(_this.commonConfigGetter); },
        }));
        this.withUserContext(getUserContext());
        var options = __assign(__assign({}, this.options), { host: this.options.host || (function () { return env_1.getHost(getBrand(_this.commonConfigGetter)); }) });
        var publisher = publishers_1.getPublisher(options, this.transformer, this.publishFunctions);
        return this.loggerClientFactory.addPublisher(publisher);
    };
    Factory.prototype.withTransformer = function (transformer) {
        assert.defined(transformer, 'Transformer must be provided');
        assert.ok(typeof transformer === 'function' ||
            (transformer && typeof transformer.postMessage === 'function'), 'Valid transformer must be provided');
        this.transformer = transformer;
        return this;
    };
    Factory.prototype.withPublishFunction = function (publishFunctions) {
        assert.defined(publishFunctions, 'Publish function must be provided');
        assert.ok(publishFunctions && typeof publishFunctions.postMessage === 'function', 'Valid publish function must be provided');
        this.publishFunctions = publishFunctions;
        return this;
    };
    Factory.prototype.withUserContext = function (context) {
        assert.defined(context, 'User context object must be provided');
        this.updateDefaults(filterContext(context));
        return this;
    };
    Factory.prototype.withUoUContext = function (context) {
        assert.defined(context, 'UoU context object must be provided');
        this.updateDefaults(filterContext(context));
        return this;
    };
    Factory.prototype.withCommonConfigGetter = function (commonConfigGetter) {
        assert.defined(commonConfigGetter, 'Common config getter must be provided');
        assert.ok(typeof commonConfigGetter === 'function', 'Common config getter must be a function');
        this.commonConfigGetter = commonConfigGetter;
        return this;
    };
    Factory.prototype.withConsentPolicyGetter = function (consentPolicyGetter) {
        assert.defined(consentPolicyGetter, 'Consent policy getter must be provided');
        assert.ok(typeof consentPolicyGetter === 'function', 'Consent policy getter must be a function');
        this.consentPolicyGetter = consentPolicyGetter;
        return this;
    };
    Factory.prototype.updateDefaults = function (params) {
        this.loggerClientFactory.updateDefaults(params);
        return this;
    };
    Factory.prototype.setMuted = function (muted) {
        this.muted = muted;
        return this;
    };
    Factory.prototype.setEvents = function (events) {
        this.loggerClientFactory.setEvents(events);
        return this;
    };
    Factory.prototype.onError = function (handler) {
        this.loggerClientFactory.setPublisherFailHandler(handler);
        return this;
    };
    Factory.prototype.logger = function (options) {
        if (options === void 0) { options = {}; }
        var self = this;
        var useBatch = typeof options.useBatch !== 'undefined'
            ? options.useBatch
            : this.options.useBatch;
        var logger = this.initFactory().logger(__assign(__assign({}, options), { useBatch: useBatch }));
        return {
            log: function (params, context) {
                var category = context && context.category;
                var policy = getPolicy(self.commonConfigGetter, self.consentPolicyGetter);
                var shouldMute = self.muted ||
                    (category !== 'essential' &&
                        (category === 'functional' || category === 'analytics'
                            ? !policy[category]
                            : !policy.functional || !policy.analytics));
                if (shouldMute) {
                    return Promise.resolve();
                }
                return logger.log(params, context);
            },
        };
    };
    return Factory;
}());
exports.Factory = Factory;
exports.factory = function (options) {
    if (options === void 0) { options = {}; }
    return new Factory(options);
};
exports.manager = wix_bi_logger_client_1.manager;
//# sourceMappingURL=logger.js.map

/***/ }),

/***/ 120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loader__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__presets_presets_types__ = __webpack_require__(121);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__loader__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__presets_presets_types__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return presetsTypes; });
var presetsTypes = {
    DEFAULT: 'DEFAULT',
    DS: 'DS',
    EDITOR: 'EDITOR',
    OOI: 'OOI',
    BOLT: 'BOLT',
    MOBILE: 'MOBILE',
};
//# sourceMappingURL=presets-types.js.map

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SESSION_ID_STORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_APP_VERSION; });
var SESSION_ID_STORAGE_KEY = 'fedops.logger.sessionId';
var DEFAULT_APP_VERSION = '0.0.0';

/***/ }),

/***/ 123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reporter__ = __webpack_require__(235);

var ReporterFactory;
function setFactory(factory) {
  ReporterFactory = factory;
}
function create(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      biLoggerFactory = _ref.biLoggerFactory,
      baseUrl = _ref.baseUrl,
      endpoint = _ref.endpoint,
      preset = _ref.preset,
      useBatch = _ref.useBatch;

  if (!ReporterFactory) {
    return new __WEBPACK_IMPORTED_MODULE_0__reporter__["a" /* default */]({
      biLoggerFactory: biLoggerFactory,
      baseUrl: baseUrl,
      endpoint: endpoint,
      preset: preset,
      useBatch: useBatch
    });
  } else {
    return ReporterFactory({
      preset: preset
    });
  }
}

/***/ }),

/***/ 124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return METHODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PROPS_ACCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALLOW_ALL_POLICY; });
var METHODS = {
    policy: 'getCurrentConsentPolicy',
    header: '_getConsentPolicyHeader',
    isMethod: true,
};
var PROPS_ACCESS = {
    policy: 'consentPolicy',
    header: 'consentPolicyHeader',
    isMethod: false,
};
var ALLOW_ALL_POLICY = {
    essential: true,
    dataToThirdParty: true,
    advertising: true,
    functional: true,
    analytics: true,
};
//# sourceMappingURL=consts.js.map

/***/ }),

/***/ 125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Times; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_app_data_global_app_data__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__performance_performance__ = __webpack_require__(26);



var Times = /*#__PURE__*/function () {
  function Times(appName) {
    this.appName = appName;
    this.apps = {};
    this.apps[appName] = {};
  }

  var _proto = Times.prototype;

  _proto._getKeyForApp = function _getKeyForApp(appId, widgetId) {
    if (appId === void 0) {
      appId = this.appName;
    }

    return widgetId ? appId + "_" + widgetId : appId;
  };

  _proto.setLoadStarted = function setLoadStarted(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        appId = _ref.appId,
        widgetId = _ref.widgetId;

    var key = this._getKeyForApp(appId, widgetId);

    if (!this.apps[key]) {
      this.apps[key] = {};
    }

    var loadStartTime = __WEBPACK_IMPORTED_MODULE_1__performance_performance__["a" /* default */].now();
    this.apps[key].startLoadTime = loadStartTime;

    if (!appId) {
      Object(__WEBPACK_IMPORTED_MODULE_0__global_app_data_global_app_data__["c" /* setLoadStartTime */])(key, loadStartTime);
    }
  };

  _proto.getLoadStartTime = function getLoadStartTime(_temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2,
        appId = _ref2.appId,
        widgetId = _ref2.widgetId;

    var key = this._getKeyForApp(appId, widgetId);

    var loadStartTime = this.getLoadStartTimeFromInstance(key) || Object(__WEBPACK_IMPORTED_MODULE_0__global_app_data_global_app_data__["a" /* getLoadStartTime */])(key) || 0;
    return Math.floor(loadStartTime);
  };

  _proto.getLoadStartTimeFromInstance = function getLoadStartTimeFromInstance(key) {
    return this.apps[key] && this.apps[key].startLoadTime;
  };

  _proto.getAppLoadTime = function getAppLoadTime(_temp3) {
    var _ref3 = _temp3 === void 0 ? {} : _temp3,
        appId = _ref3.appId,
        widgetId = _ref3.widgetId;

    return Math.floor(__WEBPACK_IMPORTED_MODULE_1__performance_performance__["a" /* default */].now() - this.getLoadStartTime({
      appId: appId,
      widgetId: widgetId
    }));
  };

  _proto.getFirstRequestDuration = function getFirstRequestDuration(_temp4) {
    var _ref4 = _temp4 === void 0 ? {} : _temp4,
        appId = _ref4.appId,
        widgetId = _ref4.widgetId;

    return this.getLoadStartTime({
      appId: appId,
      widgetId: widgetId
    });
  };

  return Times;
}();



/***/ }),

/***/ 126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage_storage__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conf__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__env__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_app_data_global_app_data__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(127);





var sessionManager = {
  getSessionId: function getSessionId() {
    var res = typeof Object(__WEBPACK_IMPORTED_MODULE_2__env__["a" /* env */])() !== 'undefined' && Object(__WEBPACK_IMPORTED_MODULE_2__env__["a" /* env */])().fedops && Object(__WEBPACK_IMPORTED_MODULE_2__env__["a" /* env */])().fedops.sessionId;
    res = res || __WEBPACK_IMPORTED_MODULE_0__storage_storage__["a" /* default */].getItem(__WEBPACK_IMPORTED_MODULE_1__conf__["b" /* SESSION_ID_STORAGE_KEY */]);
    res = res || Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* generateGuid */])();
    Object(__WEBPACK_IMPORTED_MODULE_3__global_app_data_global_app_data__["d" /* setSessionId */])(res);
    __WEBPACK_IMPORTED_MODULE_0__storage_storage__["a" /* default */].setItem(__WEBPACK_IMPORTED_MODULE_1__conf__["b" /* SESSION_ID_STORAGE_KEY */], res);
    return res;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (sessionManager);

/***/ }),

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateGuid; });
var generateGuid = function generateGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c === 'x' ? r : r & 0x3 | 0x8; // eslint-disable-line

    return v.toString(16);
  });
};

/***/ }),

/***/ 128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return phasesConfigValues; });
var phasesConfigValues = {
  SEND_ON_START: 'SEND_ON_START',
  SEND_ON_FINISH: 'SEND_START_AND_FINISH',
  SEND_ON_APP_LOADED: 'SEND_ON_START',
  SEND_START_AND_FINISH: 'SEND_START_AND_FINISH'
};

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(20) && !__webpack_require__(43)(function () {
  return Object.defineProperty(__webpack_require__(105)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(42);
var toIObject = __webpack_require__(52);
var arrayIndexOf = __webpack_require__(183)(false);
var IE_PROTO = __webpack_require__(103)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ 144:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.requestGlobal = exports.requestWindow = exports.isWebWorker = exports.getHost = exports.setHost = void 0;
var constants_1 = __webpack_require__(36);
var host;
function setHost(_host) {
    host = _host;
}
exports.setHost = setHost;
function getHost(brand) {
    if (brand === void 0) { brand = constants_1.DefaultBrand; }
    var hostByBrand = constants_1.BrandToHostMap[brand] || constants_1.BrandToHostMap[constants_1.DefaultBrand];
    return host || "frog." + hostByBrand + ".com";
}
exports.getHost = getHost;
function isWebWorker() {
    /* global WorkerGlobalScope */
    //At the moment, this is the most reliable way of detecting if current code is run in a worker
    //Taken from here: https://stackoverflow.com/a/18002694
    return (typeof WorkerGlobalScope !== 'undefined' &&
        self instanceof WorkerGlobalScope);
}
exports.isWebWorker = isWebWorker;
/**
 * Provides a window object to the callback iff current window is the topmost one
 * Otherwise returns null
 */
function requestWindow(cb) {
    if (typeof window !== 'undefined' && window) {
        try {
            return window.top === window.self ? (cb ? cb(window) : window) : null;
        }
        catch (e) {
            return null;
        }
    }
    return null;
}
exports.requestWindow = requestWindow;
function requestGlobal(cb, defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    if (typeof self !== 'undefined' && self) {
        return cb(self) || defaultValue;
    }
    return defaultValue;
}
exports.requestGlobal = requestGlobal;
//# sourceMappingURL=env.js.map

/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return env; });
/* harmony export (immutable) */ __webpack_exports__["b"] = hasSendBeacon;
/* harmony export (immutable) */ __webpack_exports__["c"] = sendBeacon;
var envFallback = {};
var env = function env() {
  if (typeof window !== 'undefined') {
    return window;
  } else if (typeof global !== 'undefined') {
    return global;
  } else if (typeof WorkerGlobalScope !== 'undefined') {
    /* global WorkerGlobalScope */
    return WorkerGlobalScope;
  } else {
    return envFallback;
  }
};
function hasSendBeacon() {
  return typeof navigator !== 'undefined' && navigator && navigator.sendBeacon;
}
function sendBeacon(url) {
  return navigator.sendBeacon(url);
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5)))

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(52);
var toLength = __webpack_require__(109);
var toAbsoluteIndex = __webpack_require__(184);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(90);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var core = __webpack_require__(7);
var ctx = __webpack_require__(61);
var hide = __webpack_require__(50);
var has = __webpack_require__(42);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(192), __esModule: true };

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(193);
module.exports = __webpack_require__(7).Object.assign;


/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(19);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(194) });


/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(20);
var getKeys = __webpack_require__(72);
var gOPS = __webpack_require__(111);
var pIE = __webpack_require__(92);
var toObject = __webpack_require__(60);
var IObject = __webpack_require__(108);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(43)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventCategories = exports.manager = exports.setHost = exports.factory = void 0;
var wix_bi_logger_client_1 = __webpack_require__(112);
var tracker = __importStar(__webpack_require__(202));
var logger = __importStar(__webpack_require__(115));
exports.factory = function (options) {
    if (options === void 0) { options = {}; }
    var trackSession = options.trackSession || typeof options.trackSession === 'undefined';
    if (trackSession) {
        tracker.track(logger.factory);
    }
    return logger.factory(options);
};
exports.setHost = logger.setHost;
exports.manager = wix_bi_logger_client_1.manager;
exports.EventCategories = logger.EventCategories;
exports.default = {
    factory: exports.factory,
    setHost: logger.setHost,
    manager: wix_bi_logger_client_1.manager,
    EventCategories: logger.EventCategories,
};
//# sourceMappingURL=tracking-logger.js.map

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var assert = __webpack_require__(74);
var BiLogger = __webpack_require__(113);
var biLoggerManager = __webpack_require__(114);

var BiLoggerFactory = function () {
  function BiLoggerFactory() {
    _classCallCheck(this, BiLoggerFactory);

    this._publishers = [];
    this._validators = [];
    this._defaults = {};
    this._events = {};
  }

  _createClass(BiLoggerFactory, [{
    key: 'addPublisher',
    value: function addPublisher(publisher) {
      assert.defined(publisher, 'Publisher must be provided');
      assert.ok(typeof publisher === 'function', 'Expected a publisher function');
      this._publishers.push(publisher);
      return this;
    }
  }, {
    key: 'addValidator',
    value: function addValidator(validator) {
      assert.defined(validator, 'Validator must be provided');
      assert.ok((typeof validator === 'undefined' ? 'undefined' : _typeof(validator)) === 'object' && validator, 'Expected a validator object');
      assert.ok(validator.execute && validator.match, 'Provided validator does not match the interface');
      this._validators.push(validator);
      return this;
    }
  }, {
    key: 'setDefaults',
    value: function setDefaults(defaults) {
      assert.defined(defaults, 'Defaults must be provided');
      assert.object(defaults, 'Defaults must be an object');
      this._defaults = defaults;
      return this;
    }
  }, {
    key: 'updateDefaults',
    value: function updateDefaults(defaults) {
      assert.defined(defaults, 'Defaults must be provided');
      assert.object(defaults, 'Defaults must be an object');
      Object.assign(this._defaults, defaults);
      return this;
    }
  }, {
    key: 'setEvents',
    value: function setEvents(events) {
      assert.defined(events, 'Events must be provided');
      assert.object(events, 'Events must be an object');
      this._events = events;
      return this;
    }
  }, {
    key: 'setDefaultValueTimeout',
    value: function setDefaultValueTimeout(defaultValueTimeout) {
      assert.defined(defaultValueTimeout, 'Default Value Timeout must be provided');
      this._defaultValueTimeout = defaultValueTimeout;
      return this;
    }
  }, {
    key: 'setDefaultContinueOnFail',
    value: function setDefaultContinueOnFail(defaultContinueOnFail) {
      assert.defined(defaultContinueOnFail, 'Default Continue On Fail must be provided');
      this._defaultContinueOnFail = defaultContinueOnFail;
      return this;
    }
  }, {
    key: 'setPublisherFailHandler',
    value: function setPublisherFailHandler(onPublisherFailHandler) {
      assert.defined(onPublisherFailHandler, 'Publisher Fail Handler must be provided');
      this._onPublisherFailHandler = onPublisherFailHandler;
      return this;
    }
  }, {
    key: 'logger',
    value: function logger(context) {
      var logger = new BiLogger({
        publishers: this._publishers,
        validators: this._validators,
        defaults: this._defaults,
        events: this._events,
        defaultValueTimeout: this._defaultValueTimeout,
        defaultContinueOnFail: this._defaultContinueOnFail,
        onPublisherFailHandler: this._onPublisherFailHandler
      }, context);

      biLoggerManager.manager.notifyLoggerCreated(logger);

      return logger;
    }
  }]);

  return BiLoggerFactory;
}();

module.exports = BiLoggerFactory;
//# sourceMappingURL=bi-logger-factory.js.map

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This callback type is called `requestCallback` and is displayed as a global symbol.
 *
 * @callback iterateeCallback
 * @param {*} Value
 * @param {string} Key
 * @param {object} Original object
 */
/**
 * Iterates over object values
 * @param {Object} collection
 * @param {iterateeCallback} iteratee
 * @return {Object} iterated object
 */
module.exports.mapValues = function (collection, iteratee) {
  if (!collection) {
    return {};
  }

  return Object.keys(collection).reduce(function (acc, key) {
    acc[key] = iteratee(collection[key], key, collection);
    return acc;
  }, {});
};

module.exports.filterValues = function (collection, iteratee) {
  if (!collection) {
    return {};
  }

  return Object.keys(collection).reduce(function (acc, key) {
    var keep = iteratee(collection[key], key, collection);

    if (keep) {
      acc[key] = collection[key];
    }

    return acc;
  }, {});
};
//# sourceMappingURL=collections.js.map

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * rejects original promise after specified timeout
 * @param {Promise<R>} promise Original promise
 * @param {string} [message] Additional message for timeout reject
 * @param {number} timeout Time for reject
 * @return {Promise<R>}
 */
module.exports.timedPromise = function (promise, _ref) {
  var message = _ref.message,
      timeout = _ref.timeout;

  var timeoutPromise = new Promise(function (resolve, reject) {
    setTimeout(reject, timeout, message ? 'Timeout: ' + message : 'Timeout');
  });
  return Promise.race([promise, timeoutPromise]);
};

/**
 * Works like Promise.all expect uses object insetead of array.
 * @param {Object} promiseObject
 * @return {Promise} Promise wiht original keys and resolved values
 */
module.exports.allAsObject = function (promiseObject) {
  var keys = Object.keys(promiseObject);
  return Promise.all(keys.map(function (key) {
    return promiseObject[key];
  })).then(function (resolved) {
    return resolved.reduce(function (acc, value, i) {
      acc[keys[i]] = value;
      return acc;
    }, {});
  });
};
//# sourceMappingURL=promise.js.map

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  error: function error() {
    if (console && console.error) {
      var _console;

      (_console = console).error.apply(_console, arguments);
    }
  }
};
//# sourceMappingURL=log.js.map

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(43)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debounce = __webpack_require__(201);

var createEvent = function createEvent(event, context, startTime) {
  return {
    dt: Date.now() - startTime,
    f: event,
    context: context
  };
};

var createBatch = function createBatch(events, startTime) {
  return {
    dt: Date.now() - startTime,
    e: events
  };
};

var EventBuffer = function () {
  function EventBuffer(debounceMs) {
    var _this = this;

    _classCallCheck(this, EventBuffer);

    this._flushHandler = function (x) {
      return x;
    };
    this._flushDebounced = debounce(function () {
      return _this.flush();
    }, debounceMs);

    this._init();
  }

  _createClass(EventBuffer, [{
    key: '_init',
    value: function _init() {
      var _this2 = this;

      this._startTime = Date.now();
      this._events = [];
      this._resolve = null;
      this._promise = new Promise(function (resolve) {
        return _this2._resolve = resolve;
      });
    }
  }, {
    key: 'flush',
    value: function flush() {
      if (!this._events.length) {
        return Promise.resolve();
      }

      var events = this._events;
      var resolve = this._resolve;
      var startTime = this._startTime;

      this._init();

      return this._flushHandler(createBatch(events, startTime)).then(resolve);
    }
  }, {
    key: 'onFlush',
    value: function onFlush(handler) {
      this._flushHandler = handler;

      return this;
    }
  }, {
    key: 'feed',
    value: function feed(event, context) {
      this._events.push(createEvent(event, context, this._startTime));

      this._flushDebounced();

      return this._promise;
    }
  }]);

  return EventBuffer;
}();

module.exports = EventBuffer;
//# sourceMappingURL=event-buffer.js.map

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout = void 0;

  // This is the function that is actually executed when
  // the DOM event is triggered.
  return function () {
    // Store the context of this and any parameters passed to executedFunction
    var context = this;
    var args = arguments;

    // The function to be called after
    // the debounce time has elapsed
    var later = function later() {
      // null timeout to indicate the debounce ended
      timeout = null;

      // Call function now if you did not on the leading end
      if (!immediate) {
        func.apply(context, args);
      }
    };

    // Determine if you should call the function
    // on the leading or trail end
    var callNow = immediate && !timeout;

    // This will reset the waiting every function execution.
    // This is the step that prevents the function from
    // being executed because it will never reach the
    // inside of the previous setTimeout
    clearTimeout(timeout);

    // Restart the debounce waiting period.
    // setTimeout returns a truthy value (it differs in web vs node)
    timeout = setTimeout(later, wait);

    // Call immediately if you're dong a leading
    // end execution
    if (callNow) {
      func.apply(context, args);
    }
  };
}

module.exports = debounce;
//# sourceMappingURL=debounce.js.map

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.track = void 0;
var utils_1 = __webpack_require__(75);
var navigator_1 = __webpack_require__(203);
var env_1 = __webpack_require__(15);
var browser_1 = __webpack_require__(55);
var IS_TRACKING = '__isTrackingBiBrowsingSession__';
var ENDPOINT = 'p';
var SOURCE = 19;
var EVID = 3;
function shouldTrack() {
    return !env_1.isWebWorker() && env_1.requestWindow(function (window) { return !window[IS_TRACKING]; });
}
function setIsTracking() {
    return env_1.requestWindow(function (window) { return (window[IS_TRACKING] = true); });
}
function getLogger(loggerFactory) {
    return loggerFactory({ endpoint: ENDPOINT })
        .updateDefaults({ src: SOURCE, evid: EVID, vsi: utils_1.guid() })
        .logger();
}
function trackBrowsingSession(loggerFactory) {
    var logger = getLogger(loggerFactory);
    var firstInSession = 1;
    navigator_1.listen(function (fromUrl, toUrl) {
        var _a = env_1.requestWindow(function (window) { return ({
            sr: browser_1.getDesktopSize(window),
            wr: browser_1.getWindowSize(window),
        }); }), sr = _a.sr, wr = _a.wr;
        logger.log({ from: fromUrl, to: toUrl, fis: firstInSession, sr: sr, wr: wr });
        firstInSession = 0;
    });
}
/**
 * Sends a page view event on initial load and on every page switch
 * BI event definition: http://bo.wix.com/bi-catalog-webapp/#/sources/19/events/3
 */
function track(loggerFactory) {
    if (shouldTrack()) {
        setIsTracking();
        trackBrowsingSession(loggerFactory);
    }
}
exports.track = track;
//# sourceMappingURL=tracker.js.map

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.listen = void 0;
var env_1 = __webpack_require__(15);
function hook(obj, fnName, cbHook) {
    if (!obj || !obj[fnName]) {
        return;
    }
    var original = obj[fnName];
    obj[fnName] = function () {
        cbHook.apply(null, arguments);
        return original.apply(obj, arguments);
    };
}
function onLoad(cb) {
    setTimeout(function () { return env_1.requestWindow(function (window) { return cb(window.location.href); }); });
}
function onPushState(cb) {
    env_1.requestWindow(function (_a) {
        var history = _a.history;
        return ['pushState', 'replaceState'].forEach(function (fnName) {
            hook(history, fnName, function (_, __, url) { return cb(url); });
        });
    });
}
function onPopState(cb) {
    env_1.requestWindow(function (window) {
        return window.addEventListener('popstate', function () { return cb(window.location.href); });
    });
}
function listen(cb) {
    env_1.requestWindow(function (window) {
        var fromUrl = window.document.referrer;
        [onLoad, onPushState, onPopState].forEach(function (event) {
            return event(function (toUrl) {
                cb(fromUrl, toUrl);
                fromUrl = toUrl;
            });
        });
    });
}
exports.listen = listen;
//# sourceMappingURL=navigator.js.map

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ok = exports.object = exports.defined = void 0;
var errors_1 = __webpack_require__(76);
exports.defined = function (target, message) {
    if (target === undefined) {
        throw new errors_1.AssertionError(message);
    }
};
exports.object = function (target, message) {
    if (target !== undefined &&
        (typeof target !== 'object' || Array.isArray(target) || target === null)) {
        throw new errors_1.AssertionError(message);
    }
};
exports.ok = function (target, message) {
    if (!target) {
        throw new errors_1.AssertionError(message);
    }
};
//# sourceMappingURL=assert.js.map

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPublisher = exports.resolvePublisher = exports.postMessagePublisher = exports.xhrPublisher = exports.fetchPublisher = exports.beaconPublisher = exports.imagePublisher = void 0;
var utils_1 = __webpack_require__(75);
var env_1 = __webpack_require__(15);
var constants_1 = __webpack_require__(36);
var errors_1 = __webpack_require__(76);
var browser_1 = __webpack_require__(55);
var types_1 = __webpack_require__(77);
var transport_1 = __webpack_require__(206);
var getHttpMethod = function (context) {
    return context.useBatch ? 'POST' : 'GET';
};
var baseTransformer = function (params) {
    if (params === void 0) { params = {}; }
    params.ms = Math.round(browser_1.now());
    params._lv = constants_1.LoggerVersion;
    return params;
};
var resolveTransformer = function (options, transformer) {
    if (transformer) {
        if (typeof transformer !== 'function' &&
            transformer.postMessage &&
            options.publishMethod === types_1.PublishMethods.PostMessage) {
            transformer = transformer.postMessage;
        }
        else if (typeof transformer !== 'function') {
            transformer = null;
        }
    }
    var resolvedTransformer = transformer
        ? function (p) { return transformer(baseTransformer(p)); }
        : baseTransformer;
    return function (params, context) {
        if (context.useBatch) {
            params.e = params.e.map(function (e) {
                var eventContext = e.context, event = __rest(e, ["context"]);
                var res = __assign(__assign({}, event), { f: __assign(__assign({}, resolvedTransformer(event.f)), { _rp: (eventContext && eventContext.endpoint) ||
                            context.endpoint ||
                            options.endpoint }) });
                return res;
            });
            return params;
        }
        return resolvedTransformer(params);
    };
};
function imagePublisher(options) {
    if (options === void 0) { options = {}; }
    return function image(params, context) {
        if (context === void 0) { context = {}; }
        if (context.useBatch) {
            throw new errors_1.APINotSupportedError("Can't use image publisher to send batched events.");
        }
        var url = utils_1.buildBiUrl(options, params, context);
        return transport_1.pixelTransport(url, context.image);
    };
}
exports.imagePublisher = imagePublisher;
function beaconPublisher(options) {
    if (options === void 0) { options = {}; }
    return function beacon(params, context) {
        if (context === void 0) { context = {}; }
        var url = utils_1.buildBiUrl(options, params, context);
        return transport_1.beaconTransport(url, params, !!context.useBatch).catch(function () {
            var method = getHttpMethod(context);
            return context.useBatch
                ? transport_1.fetchTransport(url, params, method).catch(function (error) {
                    return error instanceof errors_1.APINotSupportedError
                        ? transport_1.xhrTransport(url, params, method)
                        : Promise.reject(error);
                })
                : transport_1.pixelTransport(url, context.image);
        });
    };
}
exports.beaconPublisher = beaconPublisher;
function fetchPublisher(options) {
    if (options === void 0) { options = {}; }
    return function fetch(params, context) {
        if (context === void 0) { context = {}; }
        var url = utils_1.buildBiUrl(options, params, context);
        var method = getHttpMethod(context);
        return transport_1.fetchTransport(url, params, method).catch(function (error) {
            return error instanceof errors_1.APINotSupportedError
                ? transport_1.xhrTransport(url, params, method)
                : Promise.reject(error);
        });
    };
}
exports.fetchPublisher = fetchPublisher;
function xhrPublisher(options) {
    if (options === void 0) { options = {}; }
    return function xhr(params, context) {
        if (context === void 0) { context = {}; }
        var url = utils_1.buildBiUrl(options, params, context);
        var method = getHttpMethod(context);
        return transport_1.xhrTransport(url, params, method);
    };
}
exports.xhrPublisher = xhrPublisher;
function postMessagePublisher(options, publishFunction) {
    if (options === void 0) { options = {}; }
    return function postMessage(params) {
        return transport_1.postMessageTransport(params, publishFunction);
    };
}
exports.postMessagePublisher = postMessagePublisher;
exports.resolvePublisher = function (options, publishFunctions) {
    var publisherFactory;
    var publishFunction;
    if (options.publishMethod === types_1.PublishMethods.PostMessage) {
        publisherFactory = postMessagePublisher;
        publishFunction = publishFunctions && publishFunctions.postMessage;
    }
    else if (env_1.isWebWorker()) {
        publisherFactory = fetchPublisher;
    }
    else {
        publisherFactory = beaconPublisher;
    }
    return publisherFactory(options, publishFunction);
};
function getPublisher(options, paramTransformer, publishFunctions) {
    var publisher = exports.resolvePublisher(options, publishFunctions);
    var transformer = resolveTransformer(options, paramTransformer);
    return function (params, context) {
        return publisher(transformer(params, context), context);
    };
}
exports.getPublisher = getPublisher;
//# sourceMappingURL=publishers.js.map

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.postMessageTransport = exports.xhrTransport = exports.fetchTransport = exports.pixelTransport = exports.beaconTransport = void 0;
var browser_1 = __webpack_require__(55);
var errors_1 = __webpack_require__(76);
function beaconTransport(url, params, sendInBody) {
    if (sendInBody === void 0) { sendInBody = false; }
    return new Promise(function (resolve, reject) {
        return browser_1.sendBeacon(url, sendInBody ? JSON.stringify(params) : undefined)
            ? resolve()
            : reject(new Error('Transport Error: Cannot send bi using beacon'));
    });
}
exports.beaconTransport = beaconTransport;
function pixelTransport(url, image) {
    return new Promise(function (resolve, reject) {
        var biImage = image || new window.Image(0, 0);
        biImage.onload = function () { return resolve(); };
        biImage.onerror = function () {
            return reject(new Error('Transport Error: Cannot send bi using pixel'));
        };
        biImage.src = url;
    });
}
exports.pixelTransport = pixelTransport;
function fetchTransport(url, params, method) {
    if (method === void 0) { method = 'GET'; }
    if (typeof fetch === 'undefined') {
        return Promise.reject(new errors_1.APINotSupportedError('fetch'));
    }
    var options = {
        method: method,
        credentials: 'include',
    };
    if (method === 'POST') {
        options.body = JSON.stringify(params);
    }
    else {
        options.keepalive = true;
    }
    return fetch(url, options).then(function (response) {
        if (!response.ok) {
            throw Error("Transport Error: Cannot send bi using fetch. Status: " + response.status);
        }
    });
}
exports.fetchTransport = fetchTransport;
function xhrTransport(url, params, method) {
    if (method === void 0) { method = 'GET'; }
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open(method, "" + location.protocol + url);
        xhr.onload = resolve;
        xhr.onerror = function () {
            reject(new Error("Transport Error: Cannot send bi using xhr."));
        };
        xhr.withCredentials = true;
        if (method === 'POST') {
            xhr.send(JSON.stringify(params));
        }
        else {
            xhr.send();
        }
    });
}
exports.xhrTransport = xhrTransport;
function postMessageTransport(message, postMesasage) {
    if (postMesasage === void 0) { postMesasage = self.postMessage; }
    var messageArgs = [message];
    // when not in a web worker...
    if (typeof WorkerGlobalScope === 'undefined') {
        messageArgs.push('*');
    }
    return postMesasage.apply(self, messageArgs);
}
exports.postMessageTransport = postMessageTransport;
//# sourceMappingURL=transport.js.map

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.getConsentPolicy = void 0;
var env_1 = __webpack_require__(15);
var constants_1 = __webpack_require__(36);
var getConsentPolicyDetails = function () {
    return env_1.requestGlobal(function (_a) {
        var consentPolicyManager = _a.consentPolicyManager, Wix = _a.Wix;
        var context = (Wix && Wix.Utils) || consentPolicyManager;
        return (context &&
            typeof context.getCurrentConsentPolicy === 'function' &&
            context.getCurrentConsentPolicy());
    });
};
exports.getConsentPolicy = function (consentPolicyDetails) {
    if (consentPolicyDetails === void 0) { consentPolicyDetails = getConsentPolicyDetails(); }
    return (consentPolicyDetails && consentPolicyDetails.policy) || constants_1.DefaultConsentPolicy;
};
//# sourceMappingURL=consent-policy.js.map

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommonConfigValue = exports.getConfigApi = void 0;
var env_1 = __webpack_require__(15);
var constants_1 = __webpack_require__(36);
var getConfigValue = function (key, commonConfigApi) {
    if (!commonConfigApi) {
        return;
    }
    if (typeof commonConfigApi.getAll === 'function') {
        var config = commonConfigApi.getAll();
        return config && config[key];
    }
    return commonConfigApi[key];
};
exports.getConfigApi = function () {
    return env_1.requestGlobal(function (g) {
        var context = (g.Wix && g.Wix.Utils) || g;
        return context && context.commonConfig;
    });
};
exports.getCommonConfigValue = function (key, commonConfigApi) {
    if (commonConfigApi === void 0) { commonConfigApi = exports.getConfigApi(); }
    var res = getConfigValue(key, commonConfigApi);
    return typeof res !== 'undefined' ? res : constants_1.DefaultCommonConfig[key];
};
//# sourceMappingURL=common-config.js.map

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * https://github.com/paulmillr/es6-shim
 * @license es6-shim Copyright 2013-2016 by Paul Miller (http://paulmillr.com)
 *   and contributors,  MIT License
 * es6-shim: v0.35.4
 * see https://github.com/paulmillr/es6-shim/blob/0.35.3/LICENSE
 * Details and documentation:
 * https://github.com/paulmillr/es6-shim/
 */

// UMD (Universal Module Definition)
// see https://github.com/umdjs/umd/blob/master/returnExports.js
(function (root, factory) {
  /*global define, module, exports */
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    // Browser globals (root is window)
    root.returnExports = factory();
  }
}(this, function () {
  'use strict';

  var _apply = Function.call.bind(Function.apply);
  var _call = Function.call.bind(Function.call);
  var isArray = Array.isArray;
  var keys = Object.keys;

  var not = function notThunker(func) {
    return function notThunk() {
      return !_apply(func, this, arguments);
    };
  };
  var throwsError = function (func) {
    try {
      func();
      return false;
    } catch (e) {
      return true;
    }
  };
  var valueOrFalseIfThrows = function valueOrFalseIfThrows(func) {
    try {
      return func();
    } catch (e) {
      return false;
    }
  };

  var isCallableWithoutNew = not(throwsError);
  var arePropertyDescriptorsSupported = function () {
    // if Object.defineProperty exists but throws, it's IE 8
    return !throwsError(function () {
      return Object.defineProperty({}, 'x', { get: function () { } }); // eslint-disable-line getter-return
    });
  };
  var supportsDescriptors = !!Object.defineProperty && arePropertyDescriptorsSupported();
  var functionsHaveNames = (function foo() {}).name === 'foo'; // eslint-disable-line no-extra-parens

  var _forEach = Function.call.bind(Array.prototype.forEach);
  var _reduce = Function.call.bind(Array.prototype.reduce);
  var _filter = Function.call.bind(Array.prototype.filter);
  var _some = Function.call.bind(Array.prototype.some);

  var defineProperty = function (object, name, value, force) {
    if (!force && name in object) { return; }
    if (supportsDescriptors) {
      Object.defineProperty(object, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
      });
    } else {
      object[name] = value;
    }
  };

  // Define configurable, writable and non-enumerable props
  // if they don’t exist.
  var defineProperties = function (object, map, forceOverride) {
    _forEach(keys(map), function (name) {
      var method = map[name];
      defineProperty(object, name, method, !!forceOverride);
    });
  };

  var _toString = Function.call.bind(Object.prototype.toString);
  var isCallable =  false ? function IsCallableSlow(x) {
    // Some old browsers (IE, FF) say that typeof /abc/ === 'function'
    return typeof x === 'function' && _toString(x) === '[object Function]';
  } : function IsCallableFast(x) { return typeof x === 'function'; };

  var Value = {
    getter: function (object, name, getter) {
      if (!supportsDescriptors) {
        throw new TypeError('getters require true ES5 support');
      }
      Object.defineProperty(object, name, {
        configurable: true,
        enumerable: false,
        get: getter
      });
    },
    proxy: function (originalObject, key, targetObject) {
      if (!supportsDescriptors) {
        throw new TypeError('getters require true ES5 support');
      }
      var originalDescriptor = Object.getOwnPropertyDescriptor(originalObject, key);
      Object.defineProperty(targetObject, key, {
        configurable: originalDescriptor.configurable,
        enumerable: originalDescriptor.enumerable,
        get: function getKey() { return originalObject[key]; },
        set: function setKey(value) { originalObject[key] = value; }
      });
    },
    redefine: function (object, property, newValue) {
      if (supportsDescriptors) {
        var descriptor = Object.getOwnPropertyDescriptor(object, property);
        descriptor.value = newValue;
        Object.defineProperty(object, property, descriptor);
      } else {
        object[property] = newValue;
      }
    },
    defineByDescriptor: function (object, property, descriptor) {
      if (supportsDescriptors) {
        Object.defineProperty(object, property, descriptor);
      } else if ('value' in descriptor) {
        object[property] = descriptor.value;
      }
    },
    preserveToString: function (target, source) {
      if (source && isCallable(source.toString)) {
        defineProperty(target, 'toString', source.toString.bind(source), true);
      }
    }
  };

  // Simple shim for Object.create on ES3 browsers
  // (unlike real shim, no attempt to support `prototype === null`)
  var create = Object.create || function (prototype, properties) {
    var Prototype = function Prototype() {};
    Prototype.prototype = prototype;
    var object = new Prototype();
    if (typeof properties !== 'undefined') {
      keys(properties).forEach(function (key) {
        Value.defineByDescriptor(object, key, properties[key]);
      });
    }
    return object;
  };

  var supportsSubclassing = function (C, f) {
    if (!Object.setPrototypeOf) { return false; /* skip test on IE < 11 */ }
    return valueOrFalseIfThrows(function () {
      var Sub = function Subclass(arg) {
        var o = new C(arg);
        Object.setPrototypeOf(o, Subclass.prototype);
        return o;
      };
      Object.setPrototypeOf(Sub, C);
      Sub.prototype = create(C.prototype, {
        constructor: { value: Sub }
      });
      return f(Sub);
    });
  };

  var getGlobal = function () {
    /* global self, window, global */
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== 'undefined') { return self; }
    if (typeof window !== 'undefined') { return window; }
    if (typeof global !== 'undefined') { return global; }
    throw new Error('unable to locate global object');
  };

  var globals = getGlobal();
  var globalIsFinite = globals.isFinite;
  var _indexOf = Function.call.bind(String.prototype.indexOf);
  var _arrayIndexOfApply = Function.apply.bind(Array.prototype.indexOf);
  var _concat = Function.call.bind(Array.prototype.concat);
  // var _sort = Function.call.bind(Array.prototype.sort);
  var _strSlice = Function.call.bind(String.prototype.slice);
  var _push = Function.call.bind(Array.prototype.push);
  var _pushApply = Function.apply.bind(Array.prototype.push);
  var _shift = Function.call.bind(Array.prototype.shift);
  var _max = Math.max;
  var _min = Math.min;
  var _floor = Math.floor;
  var _abs = Math.abs;
  var _exp = Math.exp;
  var _log = Math.log;
  var _sqrt = Math.sqrt;
  var _hasOwnProperty = Function.call.bind(Object.prototype.hasOwnProperty);
  var ArrayIterator; // make our implementation private
  var noop = function () {};

  var OrigMap = globals.Map;
  var origMapDelete = OrigMap && OrigMap.prototype['delete'];
  var origMapGet = OrigMap && OrigMap.prototype.get;
  var origMapHas = OrigMap && OrigMap.prototype.has;
  var origMapSet = OrigMap && OrigMap.prototype.set;

  var Symbol = globals.Symbol || {};
  var symbolSpecies = Symbol.species || '@@species';

  var numberIsNaN = Number.isNaN || function isNaN(value) {
    // NaN !== NaN, but they are identical.
    // NaNs are the only non-reflexive value, i.e., if x !== x,
    // then x is NaN.
    // isNaN is broken: it converts its argument to number, so
    // isNaN('foo') => true
    return value !== value;
  };
  var numberIsFinite = Number.isFinite || function isFinite(value) {
    return typeof value === 'number' && globalIsFinite(value);
  };
  var _sign = isCallable(Math.sign) ? Math.sign : function sign(value) {
    var number = Number(value);
    if (number === 0) { return number; }
    if (numberIsNaN(number)) { return number; }
    return number < 0 ? -1 : 1;
  };
  var _log1p = function log1p(value) {
    var x = Number(value);
    if (x < -1 || numberIsNaN(x)) { return NaN; }
    if (x === 0 || x === Infinity) { return x; }
    if (x === -1) { return -Infinity; }

    return (1 + x) - 1 === 0 ? x : x * (_log(1 + x) / ((1 + x) - 1));
  };

  // taken directly from https://github.com/ljharb/is-arguments/blob/master/index.js
  // can be replaced with require('is-arguments') if we ever use a build process instead
  var isStandardArguments = function isArguments(value) {
    return _toString(value) === '[object Arguments]';
  };
  var isLegacyArguments = function isArguments(value) {
    return value !== null &&
      typeof value === 'object' &&
      typeof value.length === 'number' &&
      value.length >= 0 &&
      _toString(value) !== '[object Array]' &&
      _toString(value.callee) === '[object Function]';
  };
  var isArguments = isStandardArguments(arguments) ? isStandardArguments : isLegacyArguments;

  var Type = {
    primitive: function (x) { return x === null || (typeof x !== 'function' && typeof x !== 'object'); },
    string: function (x) { return _toString(x) === '[object String]'; },
    regex: function (x) { return _toString(x) === '[object RegExp]'; },
    symbol: function (x) {
      return typeof globals.Symbol === 'function' && typeof x === 'symbol';
    }
  };

  var overrideNative = function overrideNative(object, property, replacement) {
    var original = object[property];
    defineProperty(object, property, replacement, true);
    Value.preserveToString(object[property], original);
  };

  // eslint-disable-next-line no-restricted-properties
  var hasSymbols = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' && Type.symbol(Symbol());

  // This is a private name in the es6 spec, equal to '[Symbol.iterator]'
  // we're going to use an arbitrary _-prefixed name to make our shims
  // work properly with each other, even though we don't have full Iterator
  // support.  That is, `Array.from(map.keys())` will work, but we don't
  // pretend to export a "real" Iterator interface.
  var $iterator$ = Type.symbol(Symbol.iterator) ? Symbol.iterator : '_es6-shim iterator_';
  // Firefox ships a partial implementation using the name @@iterator.
  // https://bugzilla.mozilla.org/show_bug.cgi?id=907077#c14
  // So use that name if we detect it.
  if (globals.Set && typeof new globals.Set()['@@iterator'] === 'function') {
    $iterator$ = '@@iterator';
  }

  // Reflect
  if (!globals.Reflect) {
    defineProperty(globals, 'Reflect', {}, true);
  }
  var Reflect = globals.Reflect;

  var $String = String;

  /* global document */
  var domAll = (typeof document === 'undefined' || !document) ? null : document.all;
  var isNullOrUndefined = domAll == null ? function isNullOrUndefined(x) {
    return x == null;
  } : function isNullOrUndefinedAndNotDocumentAll(x) {
    return x == null && x !== domAll;
  };

  var ES = {
    // http://www.ecma-international.org/ecma-262/6.0/#sec-call
    Call: function Call(F, V) {
      var args = arguments.length > 2 ? arguments[2] : [];
      if (!ES.IsCallable(F)) {
        throw new TypeError(F + ' is not a function');
      }
      return _apply(F, V, args);
    },

    RequireObjectCoercible: function (x, optMessage) {
      if (isNullOrUndefined(x)) {
        throw new TypeError(optMessage || 'Cannot call method on ' + x);
      }
      return x;
    },

    // This might miss the "(non-standard exotic and does not implement
    // [[Call]])" case from
    // http://www.ecma-international.org/ecma-262/6.0/#sec-typeof-operator-runtime-semantics-evaluation
    // but we can't find any evidence these objects exist in practice.
    // If we find some in the future, you could test `Object(x) === x`,
    // which is reliable according to
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toobject
    // but is not well optimized by runtimes and creates an object
    // whenever it returns false, and thus is very slow.
    TypeIsObject: function (x) {
      if (x === void 0 || x === null || x === true || x === false) {
        return false;
      }
      return typeof x === 'function' || typeof x === 'object' || x === domAll;
    },

    ToObject: function (o, optMessage) {
      return Object(ES.RequireObjectCoercible(o, optMessage));
    },

    IsCallable: isCallable,

    IsConstructor: function (x) {
      // We can't tell callables from constructors in ES5
      return ES.IsCallable(x);
    },

    ToInt32: function (x) {
      return ES.ToNumber(x) >> 0;
    },

    ToUint32: function (x) {
      return ES.ToNumber(x) >>> 0;
    },

    ToNumber: function (value) {
      if (_toString(value) === '[object Symbol]') {
        throw new TypeError('Cannot convert a Symbol value to a number');
      }
      return +value;
    },

    ToInteger: function (value) {
      var number = ES.ToNumber(value);
      if (numberIsNaN(number)) { return 0; }
      if (number === 0 || !numberIsFinite(number)) { return number; }
      return (number > 0 ? 1 : -1) * _floor(_abs(number));
    },

    ToLength: function (value) {
      var len = ES.ToInteger(value);
      if (len <= 0) { return 0; } // includes converting -0 to +0
      if (len > Number.MAX_SAFE_INTEGER) { return Number.MAX_SAFE_INTEGER; }
      return len;
    },

    SameValue: function (a, b) {
      if (a === b) {
        // 0 === -0, but they are not identical.
        if (a === 0) { return 1 / a === 1 / b; }
        return true;
      }
      return numberIsNaN(a) && numberIsNaN(b);
    },

    SameValueZero: function (a, b) {
      // same as SameValue except for SameValueZero(+0, -0) == true
      return (a === b) || (numberIsNaN(a) && numberIsNaN(b));
    },

    IsIterable: function (o) {
      return ES.TypeIsObject(o) && (typeof o[$iterator$] !== 'undefined' || isArguments(o));
    },

    GetIterator: function (o) {
      if (isArguments(o)) {
        // special case support for `arguments`
        return new ArrayIterator(o, 'value');
      }
      var itFn = ES.GetMethod(o, $iterator$);
      if (!ES.IsCallable(itFn)) {
        // Better diagnostics if itFn is null or undefined
        throw new TypeError('value is not an iterable');
      }
      var it = ES.Call(itFn, o);
      if (!ES.TypeIsObject(it)) {
        throw new TypeError('bad iterator');
      }
      return it;
    },

    GetMethod: function (o, p) {
      var func = ES.ToObject(o)[p];
      if (isNullOrUndefined(func)) {
        return void 0;
      }
      if (!ES.IsCallable(func)) {
        throw new TypeError('Method not callable: ' + p);
      }
      return func;
    },

    IteratorComplete: function (iterResult) {
      return !!iterResult.done;
    },

    IteratorClose: function (iterator, completionIsThrow) {
      var returnMethod = ES.GetMethod(iterator, 'return');
      if (returnMethod === void 0) {
        return;
      }
      var innerResult, innerException;
      try {
        innerResult = ES.Call(returnMethod, iterator);
      } catch (e) {
        innerException = e;
      }
      if (completionIsThrow) {
        return;
      }
      if (innerException) {
        throw innerException;
      }
      if (!ES.TypeIsObject(innerResult)) {
        throw new TypeError("Iterator's return method returned a non-object.");
      }
    },

    IteratorNext: function (it) {
      var result = arguments.length > 1 ? it.next(arguments[1]) : it.next();
      if (!ES.TypeIsObject(result)) {
        throw new TypeError('bad iterator');
      }
      return result;
    },

    IteratorStep: function (it) {
      var result = ES.IteratorNext(it);
      var done = ES.IteratorComplete(result);
      return done ? false : result;
    },

    Construct: function (C, args, newTarget, isES6internal) {
      var target = typeof newTarget === 'undefined' ? C : newTarget;

      if (!isES6internal && Reflect.construct) {
        // Try to use Reflect.construct if available
        return Reflect.construct(C, args, target);
      }
      // OK, we have to fake it.  This will only work if the
      // C.[[ConstructorKind]] == "base" -- but that's the only
      // kind we can make in ES5 code anyway.

      // OrdinaryCreateFromConstructor(target, "%ObjectPrototype%")
      var proto = target.prototype;
      if (!ES.TypeIsObject(proto)) {
        proto = Object.prototype;
      }
      var obj = create(proto);
      // Call the constructor.
      var result = ES.Call(C, obj, args);
      return ES.TypeIsObject(result) ? result : obj;
    },

    SpeciesConstructor: function (O, defaultConstructor) {
      var C = O.constructor;
      if (C === void 0) {
        return defaultConstructor;
      }
      if (!ES.TypeIsObject(C)) {
        throw new TypeError('Bad constructor');
      }
      var S = C[symbolSpecies];
      if (isNullOrUndefined(S)) {
        return defaultConstructor;
      }
      if (!ES.IsConstructor(S)) {
        throw new TypeError('Bad @@species');
      }
      return S;
    },

    CreateHTML: function (string, tag, attribute, value) {
      var S = ES.ToString(string);
      var p1 = '<' + tag;
      if (attribute !== '') {
        var V = ES.ToString(value);
        var escapedV = V.replace(/"/g, '&quot;');
        p1 += ' ' + attribute + '="' + escapedV + '"';
      }
      var p2 = p1 + '>';
      var p3 = p2 + S;
      return p3 + '</' + tag + '>';
    },

    IsRegExp: function IsRegExp(argument) {
      if (!ES.TypeIsObject(argument)) {
        return false;
      }
      var isRegExp = argument[Symbol.match];
      if (typeof isRegExp !== 'undefined') {
        return !!isRegExp;
      }
      return Type.regex(argument);
    },

    ToString: function ToString(string) {
      return $String(string);
    }
  };

  // Well-known Symbol shims
  if (supportsDescriptors && hasSymbols) {
    var defineWellKnownSymbol = function defineWellKnownSymbol(name) {
      if (Type.symbol(Symbol[name])) {
        return Symbol[name];
      }
      // eslint-disable-next-line no-restricted-properties
      var sym = Symbol['for']('Symbol.' + name);
      Object.defineProperty(Symbol, name, {
        configurable: false,
        enumerable: false,
        writable: false,
        value: sym
      });
      return sym;
    };
    if (!Type.symbol(Symbol.search)) {
      var symbolSearch = defineWellKnownSymbol('search');
      var originalSearch = String.prototype.search;
      defineProperty(RegExp.prototype, symbolSearch, function search(string) {
        return ES.Call(originalSearch, string, [this]);
      });
      var searchShim = function search(regexp) {
        var O = ES.RequireObjectCoercible(this);
        if (!isNullOrUndefined(regexp)) {
          var searcher = ES.GetMethod(regexp, symbolSearch);
          if (typeof searcher !== 'undefined') {
            return ES.Call(searcher, regexp, [O]);
          }
        }
        return ES.Call(originalSearch, O, [ES.ToString(regexp)]);
      };
      overrideNative(String.prototype, 'search', searchShim);
    }
    if (!Type.symbol(Symbol.replace)) {
      var symbolReplace = defineWellKnownSymbol('replace');
      var originalReplace = String.prototype.replace;
      defineProperty(RegExp.prototype, symbolReplace, function replace(string, replaceValue) {
        return ES.Call(originalReplace, string, [this, replaceValue]);
      });
      var replaceShim = function replace(searchValue, replaceValue) {
        var O = ES.RequireObjectCoercible(this);
        if (!isNullOrUndefined(searchValue)) {
          var replacer = ES.GetMethod(searchValue, symbolReplace);
          if (typeof replacer !== 'undefined') {
            return ES.Call(replacer, searchValue, [O, replaceValue]);
          }
        }
        return ES.Call(originalReplace, O, [ES.ToString(searchValue), replaceValue]);
      };
      overrideNative(String.prototype, 'replace', replaceShim);
    }
    if (!Type.symbol(Symbol.split)) {
      var symbolSplit = defineWellKnownSymbol('split');
      var originalSplit = String.prototype.split;
      defineProperty(RegExp.prototype, symbolSplit, function split(string, limit) {
        return ES.Call(originalSplit, string, [this, limit]);
      });
      var splitShim = function split(separator, limit) {
        var O = ES.RequireObjectCoercible(this);
        if (!isNullOrUndefined(separator)) {
          var splitter = ES.GetMethod(separator, symbolSplit);
          if (typeof splitter !== 'undefined') {
            return ES.Call(splitter, separator, [O, limit]);
          }
        }
        return ES.Call(originalSplit, O, [ES.ToString(separator), limit]);
      };
      overrideNative(String.prototype, 'split', splitShim);
    }
    var symbolMatchExists = Type.symbol(Symbol.match);
    var stringMatchIgnoresSymbolMatch = symbolMatchExists && (function () {
      // Firefox 41, through Nightly 45 has Symbol.match, but String#match ignores it.
      // Firefox 40 and below have Symbol.match but String#match works fine.
      var o = {};
      o[Symbol.match] = function () { return 42; };
      return 'a'.match(o) !== 42;
    }());
    if (!symbolMatchExists || stringMatchIgnoresSymbolMatch) {
      var symbolMatch = defineWellKnownSymbol('match');

      var originalMatch = String.prototype.match;
      defineProperty(RegExp.prototype, symbolMatch, function match(string) {
        return ES.Call(originalMatch, string, [this]);
      });

      var matchShim = function match(regexp) {
        var O = ES.RequireObjectCoercible(this);
        if (!isNullOrUndefined(regexp)) {
          var matcher = ES.GetMethod(regexp, symbolMatch);
          if (typeof matcher !== 'undefined') {
            return ES.Call(matcher, regexp, [O]);
          }
        }
        return ES.Call(originalMatch, O, [ES.ToString(regexp)]);
      };
      overrideNative(String.prototype, 'match', matchShim);
    }
  }

  var wrapConstructor = function wrapConstructor(original, replacement, keysToSkip) {
    Value.preserveToString(replacement, original);
    if (Object.setPrototypeOf) {
      // sets up proper prototype chain where possible
      Object.setPrototypeOf(original, replacement);
    }
    if (supportsDescriptors) {
      _forEach(Object.getOwnPropertyNames(original), function (key) {
        if (key in noop || keysToSkip[key]) { return; }
        Value.proxy(original, key, replacement);
      });
    } else {
      _forEach(Object.keys(original), function (key) {
        if (key in noop || keysToSkip[key]) { return; }
        replacement[key] = original[key];
      });
    }
    replacement.prototype = original.prototype;
    Value.redefine(original.prototype, 'constructor', replacement);
  };

  var defaultSpeciesGetter = function () { return this; };
  var addDefaultSpecies = function (C) {
    if (supportsDescriptors && !_hasOwnProperty(C, symbolSpecies)) {
      Value.getter(C, symbolSpecies, defaultSpeciesGetter);
    }
  };

  var addIterator = function (prototype, impl) {
    var implementation = impl || function iterator() { return this; };
    defineProperty(prototype, $iterator$, implementation);
    if (!prototype[$iterator$] && Type.symbol($iterator$)) {
      // implementations are buggy when $iterator$ is a Symbol
      prototype[$iterator$] = implementation;
    }
  };

  var createDataProperty = function createDataProperty(object, name, value) {
    if (supportsDescriptors) {
      Object.defineProperty(object, name, {
        configurable: true,
        enumerable: true,
        writable: true,
        value: value
      });
    } else {
      object[name] = value;
    }
  };
  var createDataPropertyOrThrow = function createDataPropertyOrThrow(object, name, value) {
    createDataProperty(object, name, value);
    if (!ES.SameValue(object[name], value)) {
      throw new TypeError('property is nonconfigurable');
    }
  };

  var emulateES6construct = function (o, defaultNewTarget, defaultProto, slots) {
    // This is an es5 approximation to es6 construct semantics.  in es6,
    // 'new Foo' invokes Foo.[[Construct]] which (for almost all objects)
    // just sets the internal variable NewTarget (in es6 syntax `new.target`)
    // to Foo and then returns Foo().

    // Many ES6 object then have constructors of the form:
    // 1. If NewTarget is undefined, throw a TypeError exception
    // 2. Let xxx by OrdinaryCreateFromConstructor(NewTarget, yyy, zzz)

    // So we're going to emulate those first two steps.
    if (!ES.TypeIsObject(o)) {
      throw new TypeError('Constructor requires `new`: ' + defaultNewTarget.name);
    }
    var proto = defaultNewTarget.prototype;
    if (!ES.TypeIsObject(proto)) {
      proto = defaultProto;
    }
    var obj = create(proto);
    for (var name in slots) {
      if (_hasOwnProperty(slots, name)) {
        var value = slots[name];
        defineProperty(obj, name, value, true);
      }
    }
    return obj;
  };

  // Firefox 31 reports this function's length as 0
  // https://bugzilla.mozilla.org/show_bug.cgi?id=1062484
  if (String.fromCodePoint && String.fromCodePoint.length !== 1) {
    var originalFromCodePoint = String.fromCodePoint;
    overrideNative(String, 'fromCodePoint', function fromCodePoint(codePoints) {
      return ES.Call(originalFromCodePoint, this, arguments);
    });
  }

  var StringShims = {
    fromCodePoint: function fromCodePoint(codePoints) {
      var result = [];
      var next;
      for (var i = 0, length = arguments.length; i < length; i++) {
        next = Number(arguments[i]);
        if (!ES.SameValue(next, ES.ToInteger(next)) || next < 0 || next > 0x10FFFF) {
          throw new RangeError('Invalid code point ' + next);
        }

        if (next < 0x10000) {
          _push(result, String.fromCharCode(next));
        } else {
          next -= 0x10000;
          _push(result, String.fromCharCode((next >> 10) + 0xD800));
          _push(result, String.fromCharCode((next % 0x400) + 0xDC00));
        }
      }
      return result.join('');
    },

    raw: function raw(callSite) {
      var cooked = ES.ToObject(callSite, 'bad callSite');
      var rawString = ES.ToObject(cooked.raw, 'bad raw value');
      var len = rawString.length;
      var literalsegments = ES.ToLength(len);
      if (literalsegments <= 0) {
        return '';
      }

      var stringElements = [];
      var nextIndex = 0;
      var nextKey, next, nextSeg, nextSub;
      while (nextIndex < literalsegments) {
        nextKey = ES.ToString(nextIndex);
        nextSeg = ES.ToString(rawString[nextKey]);
        _push(stringElements, nextSeg);
        if (nextIndex + 1 >= literalsegments) {
          break;
        }
        next = nextIndex + 1 < arguments.length ? arguments[nextIndex + 1] : '';
        nextSub = ES.ToString(next);
        _push(stringElements, nextSub);
        nextIndex += 1;
      }
      return stringElements.join('');
    }
  };
  if (String.raw && String.raw({ raw: { 0: 'x', 1: 'y', length: 2 } }) !== 'xy') {
    // IE 11 TP has a broken String.raw implementation
    overrideNative(String, 'raw', StringShims.raw);
  }
  defineProperties(String, StringShims);

  // Fast repeat, uses the `Exponentiation by squaring` algorithm.
  // Perf: http://jsperf.com/string-repeat2/2
  var stringRepeat = function repeat(s, times) {
    if (times < 1) { return ''; }
    if (times % 2) { return repeat(s, times - 1) + s; }
    var half = repeat(s, times / 2);
    return half + half;
  };
  var stringMaxLength = Infinity;

  var StringPrototypeShims = {
    repeat: function repeat(times) {
      var thisStr = ES.ToString(ES.RequireObjectCoercible(this));
      var numTimes = ES.ToInteger(times);
      if (numTimes < 0 || numTimes >= stringMaxLength) {
        throw new RangeError('repeat count must be less than infinity and not overflow maximum string size');
      }
      return stringRepeat(thisStr, numTimes);
    },

    startsWith: function startsWith(searchString) {
      var S = ES.ToString(ES.RequireObjectCoercible(this));
      if (ES.IsRegExp(searchString)) {
        throw new TypeError('Cannot call method "startsWith" with a regex');
      }
      var searchStr = ES.ToString(searchString);
      var position;
      if (arguments.length > 1) {
        position = arguments[1];
      }
      var start = _max(ES.ToInteger(position), 0);
      return _strSlice(S, start, start + searchStr.length) === searchStr;
    },

    endsWith: function endsWith(searchString) {
      var S = ES.ToString(ES.RequireObjectCoercible(this));
      if (ES.IsRegExp(searchString)) {
        throw new TypeError('Cannot call method "endsWith" with a regex');
      }
      var searchStr = ES.ToString(searchString);
      var len = S.length;
      var endPosition;
      if (arguments.length > 1) {
        endPosition = arguments[1];
      }
      var pos = typeof endPosition === 'undefined' ? len : ES.ToInteger(endPosition);
      var end = _min(_max(pos, 0), len);
      return _strSlice(S, end - searchStr.length, end) === searchStr;
    },

    includes: function includes(searchString) {
      if (ES.IsRegExp(searchString)) {
        throw new TypeError('"includes" does not accept a RegExp');
      }
      var searchStr = ES.ToString(searchString);
      var position;
      if (arguments.length > 1) {
        position = arguments[1];
      }
      // Somehow this trick makes method 100% compat with the spec.
      return _indexOf(this, searchStr, position) !== -1;
    },

    codePointAt: function codePointAt(pos) {
      var thisStr = ES.ToString(ES.RequireObjectCoercible(this));
      var position = ES.ToInteger(pos);
      var length = thisStr.length;
      if (position >= 0 && position < length) {
        var first = thisStr.charCodeAt(position);
        var isEnd = position + 1 === length;
        if (first < 0xD800 || first > 0xDBFF || isEnd) { return first; }
        var second = thisStr.charCodeAt(position + 1);
        if (second < 0xDC00 || second > 0xDFFF) { return first; }
        return ((first - 0xD800) * 1024) + (second - 0xDC00) + 0x10000;
      }
    }
  };
  if (String.prototype.includes && 'a'.includes('a', Infinity) !== false) {
    overrideNative(String.prototype, 'includes', StringPrototypeShims.includes);
  }

  if (String.prototype.startsWith && String.prototype.endsWith) {
    var startsWithRejectsRegex = throwsError(function () {
      /* throws if spec-compliant */
      return '/a/'.startsWith(/a/);
    });
    var startsWithHandlesInfinity = valueOrFalseIfThrows(function () {
      return 'abc'.startsWith('a', Infinity) === false;
    });
    if (!startsWithRejectsRegex || !startsWithHandlesInfinity) {
      // Firefox (< 37?) and IE 11 TP have a noncompliant startsWith implementation
      overrideNative(String.prototype, 'startsWith', StringPrototypeShims.startsWith);
      overrideNative(String.prototype, 'endsWith', StringPrototypeShims.endsWith);
    }
  }
  if (hasSymbols) {
    var startsWithSupportsSymbolMatch = valueOrFalseIfThrows(function () {
      var re = /a/;
      re[Symbol.match] = false;
      return '/a/'.startsWith(re);
    });
    if (!startsWithSupportsSymbolMatch) {
      overrideNative(String.prototype, 'startsWith', StringPrototypeShims.startsWith);
    }
    var endsWithSupportsSymbolMatch = valueOrFalseIfThrows(function () {
      var re = /a/;
      re[Symbol.match] = false;
      return '/a/'.endsWith(re);
    });
    if (!endsWithSupportsSymbolMatch) {
      overrideNative(String.prototype, 'endsWith', StringPrototypeShims.endsWith);
    }
    var includesSupportsSymbolMatch = valueOrFalseIfThrows(function () {
      var re = /a/;
      re[Symbol.match] = false;
      return '/a/'.includes(re);
    });
    if (!includesSupportsSymbolMatch) {
      overrideNative(String.prototype, 'includes', StringPrototypeShims.includes);
    }
  }

  defineProperties(String.prototype, StringPrototypeShims);

  // whitespace from: http://es5.github.io/#x15.5.4.20
  // implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
  var ws = [
    '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
    '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
    '\u2029\uFEFF'
  ].join('');
  var trimRegexp = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
  var trimShim = function trim() {
    return ES.ToString(ES.RequireObjectCoercible(this)).replace(trimRegexp, '');
  };
  var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
  var nonWSregex = new RegExp('[' + nonWS + ']', 'g');
  var isBadHexRegex = /^[-+]0x[0-9a-f]+$/i;
  var hasStringTrimBug = nonWS.trim().length !== nonWS.length;
  defineProperty(String.prototype, 'trim', trimShim, hasStringTrimBug);

  // Given an argument x, it will return an IteratorResult object,
  // with value set to x and done to false.
  // Given no arguments, it will return an iterator completion object.
  var iteratorResult = function (x) {
    return { value: x, done: arguments.length === 0 };
  };

  // see http://www.ecma-international.org/ecma-262/6.0/#sec-string.prototype-@@iterator
  var StringIterator = function (s) {
    ES.RequireObjectCoercible(s);
    this._s = ES.ToString(s);
    this._i = 0;
  };
  StringIterator.prototype.next = function () {
    var s = this._s;
    var i = this._i;
    if (typeof s === 'undefined' || i >= s.length) {
      this._s = void 0;
      return iteratorResult();
    }
    var first = s.charCodeAt(i);
    var second, len;
    if (first < 0xD800 || first > 0xDBFF || (i + 1) === s.length) {
      len = 1;
    } else {
      second = s.charCodeAt(i + 1);
      len = (second < 0xDC00 || second > 0xDFFF) ? 1 : 2;
    }
    this._i = i + len;
    return iteratorResult(s.substr(i, len));
  };
  addIterator(StringIterator.prototype);
  addIterator(String.prototype, function () {
    return new StringIterator(this);
  });

  var ArrayShims = {
    from: function from(items) {
      var C = this;
      var mapFn;
      if (arguments.length > 1) {
        mapFn = arguments[1];
      }
      var mapping, T;
      if (typeof mapFn === 'undefined') {
        mapping = false;
      } else {
        if (!ES.IsCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }
        if (arguments.length > 2) {
          T = arguments[2];
        }
        mapping = true;
      }

      // Note that that Arrays will use ArrayIterator:
      // https://bugs.ecmascript.org/show_bug.cgi?id=2416
      var usingIterator = typeof (isArguments(items) || ES.GetMethod(items, $iterator$)) !== 'undefined';

      var length, result, i;
      if (usingIterator) {
        result = ES.IsConstructor(C) ? Object(new C()) : [];
        var iterator = ES.GetIterator(items);
        var next, nextValue;

        i = 0;
        while (true) {
          next = ES.IteratorStep(iterator);
          if (next === false) {
            break;
          }
          nextValue = next.value;
          try {
            if (mapping) {
              nextValue = typeof T === 'undefined' ? mapFn(nextValue, i) : _call(mapFn, T, nextValue, i);
            }
            result[i] = nextValue;
          } catch (e) {
            ES.IteratorClose(iterator, true);
            throw e;
          }
          i += 1;
        }
        length = i;
      } else {
        var arrayLike = ES.ToObject(items);
        length = ES.ToLength(arrayLike.length);
        result = ES.IsConstructor(C) ? Object(new C(length)) : new Array(length);
        var value;
        for (i = 0; i < length; ++i) {
          value = arrayLike[i];
          if (mapping) {
            value = typeof T === 'undefined' ? mapFn(value, i) : _call(mapFn, T, value, i);
          }
          createDataPropertyOrThrow(result, i, value);
        }
      }

      result.length = length;
      return result;
    },

    of: function of() {
      var len = arguments.length;
      var C = this;
      var A = isArray(C) || !ES.IsCallable(C) ? new Array(len) : ES.Construct(C, [len]);
      for (var k = 0; k < len; ++k) {
        createDataPropertyOrThrow(A, k, arguments[k]);
      }
      A.length = len;
      return A;
    }
  };
  defineProperties(Array, ArrayShims);
  addDefaultSpecies(Array);

  // Our ArrayIterator is private; see
  // https://github.com/paulmillr/es6-shim/issues/252
  ArrayIterator = function (array, kind) {
    this.i = 0;
    this.array = array;
    this.kind = kind;
  };

  defineProperties(ArrayIterator.prototype, {
    next: function () {
      var i = this.i;
      var array = this.array;
      if (!(this instanceof ArrayIterator)) {
        throw new TypeError('Not an ArrayIterator');
      }
      if (typeof array !== 'undefined') {
        var len = ES.ToLength(array.length);
        for (; i < len; i++) {
          var kind = this.kind;
          var retval;
          if (kind === 'key') {
            retval = i;
          } else if (kind === 'value') {
            retval = array[i];
          } else if (kind === 'entry') {
            retval = [i, array[i]];
          }
          this.i = i + 1;
          return iteratorResult(retval);
        }
      }
      this.array = void 0;
      return iteratorResult();
    }
  });
  addIterator(ArrayIterator.prototype);

  /*
  var orderKeys = function orderKeys(a, b) {
    var aNumeric = String(ES.ToInteger(a)) === a;
    var bNumeric = String(ES.ToInteger(b)) === b;
    if (aNumeric && bNumeric) {
      return b - a;
    } else if (aNumeric && !bNumeric) {
      return -1;
    } else if (!aNumeric && bNumeric) {
      return 1;
    } else {
      return a.localeCompare(b);
    }
  };

  var getAllKeys = function getAllKeys(object) {
    var ownKeys = [];
    var keys = [];

    for (var key in object) {
      _push(_hasOwnProperty(object, key) ? ownKeys : keys, key);
    }
    _sort(ownKeys, orderKeys);
    _sort(keys, orderKeys);

    return _concat(ownKeys, keys);
  };
  */

  // note: this is positioned here because it depends on ArrayIterator
  var arrayOfSupportsSubclassing = Array.of === ArrayShims.of || (function () {
    // Detects a bug in Webkit nightly r181886
    var Foo = function Foo(len) { this.length = len; };
    Foo.prototype = [];
    var fooArr = Array.of.apply(Foo, [1, 2]);
    return fooArr instanceof Foo && fooArr.length === 2;
  }());
  if (!arrayOfSupportsSubclassing) {
    overrideNative(Array, 'of', ArrayShims.of);
  }

  var ArrayPrototypeShims = {
    copyWithin: function copyWithin(target, start) {
      var o = ES.ToObject(this);
      var len = ES.ToLength(o.length);
      var relativeTarget = ES.ToInteger(target);
      var relativeStart = ES.ToInteger(start);
      var to = relativeTarget < 0 ? _max(len + relativeTarget, 0) : _min(relativeTarget, len);
      var from = relativeStart < 0 ? _max(len + relativeStart, 0) : _min(relativeStart, len);
      var end;
      if (arguments.length > 2) {
        end = arguments[2];
      }
      var relativeEnd = typeof end === 'undefined' ? len : ES.ToInteger(end);
      var finalItem = relativeEnd < 0 ? _max(len + relativeEnd, 0) : _min(relativeEnd, len);
      var count = _min(finalItem - from, len - to);
      var direction = 1;
      if (from < to && to < (from + count)) {
        direction = -1;
        from += count - 1;
        to += count - 1;
      }
      while (count > 0) {
        if (from in o) {
          o[to] = o[from];
        } else {
          delete o[to];
        }
        from += direction;
        to += direction;
        count -= 1;
      }
      return o;
    },

    fill: function fill(value) {
      var start;
      if (arguments.length > 1) {
        start = arguments[1];
      }
      var end;
      if (arguments.length > 2) {
        end = arguments[2];
      }
      var O = ES.ToObject(this);
      var len = ES.ToLength(O.length);
      start = ES.ToInteger(typeof start === 'undefined' ? 0 : start);
      end = ES.ToInteger(typeof end === 'undefined' ? len : end);

      var relativeStart = start < 0 ? _max(len + start, 0) : _min(start, len);
      var relativeEnd = end < 0 ? len + end : end;

      for (var i = relativeStart; i < len && i < relativeEnd; ++i) {
        O[i] = value;
      }
      return O;
    },

    find: function find(predicate) {
      var list = ES.ToObject(this);
      var length = ES.ToLength(list.length);
      if (!ES.IsCallable(predicate)) {
        throw new TypeError('Array#find: predicate must be a function');
      }
      var thisArg = arguments.length > 1 ? arguments[1] : null;
      for (var i = 0, value; i < length; i++) {
        value = list[i];
        if (thisArg) {
          if (_call(predicate, thisArg, value, i, list)) {
            return value;
          }
        } else if (predicate(value, i, list)) {
          return value;
        }
      }
    },

    findIndex: function findIndex(predicate) {
      var list = ES.ToObject(this);
      var length = ES.ToLength(list.length);
      if (!ES.IsCallable(predicate)) {
        throw new TypeError('Array#findIndex: predicate must be a function');
      }
      var thisArg = arguments.length > 1 ? arguments[1] : null;
      for (var i = 0; i < length; i++) {
        if (thisArg) {
          if (_call(predicate, thisArg, list[i], i, list)) {
            return i;
          }
        } else if (predicate(list[i], i, list)) {
          return i;
        }
      }
      return -1;
    },

    keys: function keys() {
      return new ArrayIterator(this, 'key');
    },

    values: function values() {
      return new ArrayIterator(this, 'value');
    },

    entries: function entries() {
      return new ArrayIterator(this, 'entry');
    }
  };
  // Safari 7.1 defines Array#keys and Array#entries natively,
  // but the resulting ArrayIterator objects don't have a "next" method.
  if (Array.prototype.keys && !ES.IsCallable([1].keys().next)) {
    delete Array.prototype.keys;
  }
  if (Array.prototype.entries && !ES.IsCallable([1].entries().next)) {
    delete Array.prototype.entries;
  }

  // Chrome 38 defines Array#keys and Array#entries, and Array#@@iterator, but not Array#values
  if (Array.prototype.keys && Array.prototype.entries && !Array.prototype.values && Array.prototype[$iterator$]) {
    defineProperties(Array.prototype, {
      values: Array.prototype[$iterator$]
    });
    if (Type.symbol(Symbol.unscopables)) {
      Array.prototype[Symbol.unscopables].values = true;
    }
  }
  // Chrome 40 defines Array#values with the incorrect name, although Array#{keys,entries} have the correct name
  if (functionsHaveNames && Array.prototype.values && Array.prototype.values.name !== 'values') {
    var originalArrayPrototypeValues = Array.prototype.values;
    overrideNative(Array.prototype, 'values', function values() { return ES.Call(originalArrayPrototypeValues, this, arguments); });
    defineProperty(Array.prototype, $iterator$, Array.prototype.values, true);
  }
  defineProperties(Array.prototype, ArrayPrototypeShims);

  if (1 / [true].indexOf(true, -0) < 0) {
    // indexOf when given a position arg of -0 should return +0.
    // https://github.com/tc39/ecma262/pull/316
    defineProperty(Array.prototype, 'indexOf', function indexOf(searchElement) {
      var value = _arrayIndexOfApply(this, arguments);
      if (value === 0 && (1 / value) < 0) {
        return 0;
      }
      return value;
    }, true);
  }

  addIterator(Array.prototype, function () { return this.values(); });
  // Chrome defines keys/values/entries on Array, but doesn't give us
  // any way to identify its iterator.  So add our own shimmed field.
  if (Object.getPrototypeOf) {
    addIterator(Object.getPrototypeOf([].values()));
  }

  // note: this is positioned here because it relies on Array#entries
  var arrayFromSwallowsNegativeLengths = (function () {
    // Detects a Firefox bug in v32
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1063993
    return valueOrFalseIfThrows(function () {
      return Array.from({ length: -1 }).length === 0;
    });
  }());
  var arrayFromHandlesIterables = (function () {
    // Detects a bug in Webkit nightly r181886
    var arr = Array.from([0].entries());
    return arr.length === 1 && isArray(arr[0]) && arr[0][0] === 0 && arr[0][1] === 0;
  }());
  if (!arrayFromSwallowsNegativeLengths || !arrayFromHandlesIterables) {
    overrideNative(Array, 'from', ArrayShims.from);
  }
  var arrayFromHandlesUndefinedMapFunction = (function () {
    // Microsoft Edge v0.11 throws if the mapFn argument is *provided* but undefined,
    // but the spec doesn't care if it's provided or not - undefined doesn't throw.
    return valueOrFalseIfThrows(function () {
      return Array.from([0], void 0);
    });
  }());
  if (!arrayFromHandlesUndefinedMapFunction) {
    var origArrayFrom = Array.from;
    overrideNative(Array, 'from', function from(items) {
      if (arguments.length > 1 && typeof arguments[1] !== 'undefined') {
        return ES.Call(origArrayFrom, this, arguments);
      } else {
        return _call(origArrayFrom, this, items);
      }
    });
  }

  var int32sAsOne = -(Math.pow(2, 32) - 1);
  var toLengthsCorrectly = function (method, reversed) {
    var obj = { length: int32sAsOne };
    obj[reversed ? (obj.length >>> 0) - 1 : 0] = true;
    return valueOrFalseIfThrows(function () {
      _call(method, obj, function () {
        // note: in nonconforming browsers, this will be called
        // -1 >>> 0 times, which is 4294967295, so the throw matters.
        throw new RangeError('should not reach here');
      }, []);
      return true;
    });
  };
  if (!toLengthsCorrectly(Array.prototype.forEach)) {
    var originalForEach = Array.prototype.forEach;
    overrideNative(Array.prototype, 'forEach', function forEach(callbackFn) {
      return ES.Call(originalForEach, this.length >= 0 ? this : [], arguments);
    }, true);
  }
  if (!toLengthsCorrectly(Array.prototype.map)) {
    var originalMap = Array.prototype.map;
    overrideNative(Array.prototype, 'map', function map(callbackFn) {
      return ES.Call(originalMap, this.length >= 0 ? this : [], arguments);
    }, true);
  }
  if (!toLengthsCorrectly(Array.prototype.filter)) {
    var originalFilter = Array.prototype.filter;
    overrideNative(Array.prototype, 'filter', function filter(callbackFn) {
      return ES.Call(originalFilter, this.length >= 0 ? this : [], arguments);
    }, true);
  }
  if (!toLengthsCorrectly(Array.prototype.some)) {
    var originalSome = Array.prototype.some;
    overrideNative(Array.prototype, 'some', function some(callbackFn) {
      return ES.Call(originalSome, this.length >= 0 ? this : [], arguments);
    }, true);
  }
  if (!toLengthsCorrectly(Array.prototype.every)) {
    var originalEvery = Array.prototype.every;
    overrideNative(Array.prototype, 'every', function every(callbackFn) {
      return ES.Call(originalEvery, this.length >= 0 ? this : [], arguments);
    }, true);
  }
  if (!toLengthsCorrectly(Array.prototype.reduce)) {
    var originalReduce = Array.prototype.reduce;
    overrideNative(Array.prototype, 'reduce', function reduce(callbackFn) {
      return ES.Call(originalReduce, this.length >= 0 ? this : [], arguments);
    }, true);
  }
  if (!toLengthsCorrectly(Array.prototype.reduceRight, true)) {
    var originalReduceRight = Array.prototype.reduceRight;
    overrideNative(Array.prototype, 'reduceRight', function reduceRight(callbackFn) {
      return ES.Call(originalReduceRight, this.length >= 0 ? this : [], arguments);
    }, true);
  }

  var lacksOctalSupport = Number('0o10') !== 8;
  var lacksBinarySupport = Number('0b10') !== 2;
  var trimsNonWhitespace = _some(nonWS, function (c) {
    return Number(c + 0 + c) === 0;
  });
  if (lacksOctalSupport || lacksBinarySupport || trimsNonWhitespace) {
    var OrigNumber = Number;
    var binaryRegex = /^0b[01]+$/i;
    var octalRegex = /^0o[0-7]+$/i;
    // Note that in IE 8, RegExp.prototype.test doesn't seem to exist: ie, "test" is an own property of regexes. wtf.
    var isBinary = binaryRegex.test.bind(binaryRegex);
    var isOctal = octalRegex.test.bind(octalRegex);
    var toPrimitive = function (O) { // need to replace this with `es-to-primitive/es6`
      var result;
      if (typeof O.valueOf === 'function') {
        result = O.valueOf();
        if (Type.primitive(result)) {
          return result;
        }
      }
      if (typeof O.toString === 'function') {
        result = O.toString();
        if (Type.primitive(result)) {
          return result;
        }
      }
      throw new TypeError('No default value');
    };
    var hasNonWS = nonWSregex.test.bind(nonWSregex);
    var isBadHex = isBadHexRegex.test.bind(isBadHexRegex);
    var NumberShim = (function () {
      // this is wrapped in an IIFE because of IE 6-8's wacky scoping issues with named function expressions.
      var NumberShim = function Number(value) {
        var primValue;
        if (arguments.length > 0) {
          primValue = Type.primitive(value) ? value : toPrimitive(value, 'number');
        } else {
          primValue = 0;
        }
        if (typeof primValue === 'string') {
          primValue = ES.Call(trimShim, primValue);
          if (isBinary(primValue)) {
            primValue = parseInt(_strSlice(primValue, 2), 2);
          } else if (isOctal(primValue)) {
            primValue = parseInt(_strSlice(primValue, 2), 8);
          } else if (hasNonWS(primValue) || isBadHex(primValue)) {
            primValue = NaN;
          }
        }
        var receiver = this;
        var valueOfSucceeds = valueOrFalseIfThrows(function () {
          OrigNumber.prototype.valueOf.call(receiver);
          return true;
        });
        if (receiver instanceof NumberShim && !valueOfSucceeds) {
          return new OrigNumber(primValue);
        }
        return OrigNumber(primValue);
      };
      return NumberShim;
    }());
    wrapConstructor(OrigNumber, NumberShim, {});
    // this is necessary for ES3 browsers, where these properties are non-enumerable.
    defineProperties(NumberShim, {
      NaN: OrigNumber.NaN,
      MAX_VALUE: OrigNumber.MAX_VALUE,
      MIN_VALUE: OrigNumber.MIN_VALUE,
      NEGATIVE_INFINITY: OrigNumber.NEGATIVE_INFINITY,
      POSITIVE_INFINITY: OrigNumber.POSITIVE_INFINITY
    });
    /* globals Number: true */
    /* eslint-disable no-undef, no-global-assign */
    Number = NumberShim;
    Value.redefine(globals, 'Number', NumberShim);
    /* eslint-enable no-undef, no-global-assign */
    /* globals Number: false */
  }

  var maxSafeInteger = Math.pow(2, 53) - 1;
  defineProperties(Number, {
    MAX_SAFE_INTEGER: maxSafeInteger,
    MIN_SAFE_INTEGER: -maxSafeInteger,
    EPSILON: 2.220446049250313e-16,

    parseInt: globals.parseInt,
    parseFloat: globals.parseFloat,

    isFinite: numberIsFinite,

    isInteger: function isInteger(value) {
      return numberIsFinite(value) && ES.ToInteger(value) === value;
    },

    isSafeInteger: function isSafeInteger(value) {
      return Number.isInteger(value) && _abs(value) <= Number.MAX_SAFE_INTEGER;
    },

    isNaN: numberIsNaN
  });
  // Firefox 37 has a conforming Number.parseInt, but it's not === to the global parseInt (fixed in v40)
  defineProperty(Number, 'parseInt', globals.parseInt, Number.parseInt !== globals.parseInt);

  // Work around bugs in Array#find and Array#findIndex -- early
  // implementations skipped holes in sparse arrays. (Note that the
  // implementations of find/findIndex indirectly use shimmed
  // methods of Number, so this test has to happen down here.)
  /* eslint-disable no-sparse-arrays */
  if ([, 1].find(function () { return true; }) === 1) {
    overrideNative(Array.prototype, 'find', ArrayPrototypeShims.find);
  }
  if ([, 1].findIndex(function () { return true; }) !== 0) {
    overrideNative(Array.prototype, 'findIndex', ArrayPrototypeShims.findIndex);
  }
  /* eslint-enable no-sparse-arrays */

  var isEnumerableOn = Function.bind.call(Function.bind, Object.prototype.propertyIsEnumerable);
  var ensureEnumerable = function ensureEnumerable(obj, prop) {
    if (supportsDescriptors && isEnumerableOn(obj, prop)) {
      Object.defineProperty(obj, prop, { enumerable: false });
    }
  };
  var sliceArgs = function sliceArgs() {
    // per https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
    // and https://gist.github.com/WebReflection/4327762cb87a8c634a29
    var initial = Number(this);
    var len = arguments.length;
    var desiredArgCount = len - initial;
    var args = new Array(desiredArgCount < 0 ? 0 : desiredArgCount);
    for (var i = initial; i < len; ++i) {
      args[i - initial] = arguments[i];
    }
    return args;
  };
  var assignTo = function assignTo(source) {
    return function assignToSource(target, key) {
      target[key] = source[key];
      return target;
    };
  };
  var assignReducer = function (target, source) {
    var sourceKeys = keys(Object(source));
    var symbols;
    if (ES.IsCallable(Object.getOwnPropertySymbols)) {
      symbols = _filter(Object.getOwnPropertySymbols(Object(source)), isEnumerableOn(source));
    }
    return _reduce(_concat(sourceKeys, symbols || []), assignTo(source), target);
  };

  var ObjectShims = {
    // 19.1.3.1
    assign: function (target, source) {
      var to = ES.ToObject(target, 'Cannot convert undefined or null to object');
      return _reduce(ES.Call(sliceArgs, 1, arguments), assignReducer, to);
    },

    // Added in WebKit in https://bugs.webkit.org/show_bug.cgi?id=143865
    is: function is(a, b) {
      return ES.SameValue(a, b);
    }
  };
  var assignHasPendingExceptions = Object.assign && Object.preventExtensions && (function () {
    // Firefox 37 still has "pending exception" logic in its Object.assign implementation,
    // which is 72% slower than our shim, and Firefox 40's native implementation.
    var thrower = Object.preventExtensions({ 1: 2 });
    try {
      Object.assign(thrower, 'xy');
    } catch (e) {
      return thrower[1] === 'y';
    }
  }());
  if (assignHasPendingExceptions) {
    overrideNative(Object, 'assign', ObjectShims.assign);
  }
  defineProperties(Object, ObjectShims);

  if (supportsDescriptors) {
    var ES5ObjectShims = {
      // 19.1.3.9
      // shim from https://gist.github.com/WebReflection/5593554
      setPrototypeOf: (function (Object, magic) {
        var set;

        var checkArgs = function (O, proto) {
          if (!ES.TypeIsObject(O)) {
            throw new TypeError('cannot set prototype on a non-object');
          }
          if (!(proto === null || ES.TypeIsObject(proto))) {
            throw new TypeError('can only set prototype to an object or null' + proto);
          }
        };

        var setPrototypeOf = function (O, proto) {
          checkArgs(O, proto);
          _call(set, O, proto);
          return O;
        };

        try {
          // this works already in Firefox and Safari
          set = Object.getOwnPropertyDescriptor(Object.prototype, magic).set;
          _call(set, {}, null);
        } catch (e) {
          if (Object.prototype !== {}[magic]) {
            // IE < 11 cannot be shimmed
            return;
          }
          // probably Chrome or some old Mobile stock browser
          set = function (proto) {
            this[magic] = proto;
          };
          // please note that this will **not** work
          // in those browsers that do not inherit
          // __proto__ by mistake from Object.prototype
          // in these cases we should probably throw an error
          // or at least be informed about the issue
          setPrototypeOf.polyfill = setPrototypeOf(
            setPrototypeOf({}, null),
            Object.prototype
          ) instanceof Object;
          // setPrototypeOf.polyfill === true means it works as meant
          // setPrototypeOf.polyfill === false means it's not 100% reliable
          // setPrototypeOf.polyfill === undefined
          // or
          // setPrototypeOf.polyfill ==  null means it's not a polyfill
          // which means it works as expected
          // we can even delete Object.prototype.__proto__;
        }
        return setPrototypeOf;
      }(Object, '__proto__'))
    };

    defineProperties(Object, ES5ObjectShims);
  }

  // Workaround bug in Opera 12 where setPrototypeOf(x, null) doesn't work,
  // but Object.create(null) does.
  if (Object.setPrototypeOf && Object.getPrototypeOf &&
      Object.getPrototypeOf(Object.setPrototypeOf({}, null)) !== null &&
      Object.getPrototypeOf(Object.create(null)) === null) {
    (function () {
      var FAKENULL = Object.create(null);
      var gpo = Object.getPrototypeOf;
      var spo = Object.setPrototypeOf;
      Object.getPrototypeOf = function (o) {
        var result = gpo(o);
        return result === FAKENULL ? null : result;
      };
      Object.setPrototypeOf = function (o, p) {
        var proto = p === null ? FAKENULL : p;
        return spo(o, proto);
      };
      Object.setPrototypeOf.polyfill = false;
    }());
  }

  var objectKeysAcceptsPrimitives = !throwsError(function () { return Object.keys('foo'); });
  if (!objectKeysAcceptsPrimitives) {
    var originalObjectKeys = Object.keys;
    overrideNative(Object, 'keys', function keys(value) {
      return originalObjectKeys(ES.ToObject(value));
    });
    keys = Object.keys;
  }
  var objectKeysRejectsRegex = throwsError(function () { return Object.keys(/a/g); });
  if (objectKeysRejectsRegex) {
    var regexRejectingObjectKeys = Object.keys;
    overrideNative(Object, 'keys', function keys(value) {
      if (Type.regex(value)) {
        var regexKeys = [];
        for (var k in value) {
          if (_hasOwnProperty(value, k)) {
            _push(regexKeys, k);
          }
        }
        return regexKeys;
      }
      return regexRejectingObjectKeys(value);
    });
    keys = Object.keys;
  }

  if (Object.getOwnPropertyNames) {
    var objectGOPNAcceptsPrimitives = !throwsError(function () { return Object.getOwnPropertyNames('foo'); });
    if (!objectGOPNAcceptsPrimitives) {
      var cachedWindowNames = typeof window === 'object' ? Object.getOwnPropertyNames(window) : [];
      var originalObjectGetOwnPropertyNames = Object.getOwnPropertyNames;
      overrideNative(Object, 'getOwnPropertyNames', function getOwnPropertyNames(value) {
        var val = ES.ToObject(value);
        if (_toString(val) === '[object Window]') {
          try {
            return originalObjectGetOwnPropertyNames(val);
          } catch (e) {
            // IE bug where layout engine calls userland gOPN for cross-domain `window` objects
            return _concat([], cachedWindowNames);
          }
        }
        return originalObjectGetOwnPropertyNames(val);
      });
    }
  }
  if (Object.getOwnPropertyDescriptor) {
    var objectGOPDAcceptsPrimitives = !throwsError(function () { return Object.getOwnPropertyDescriptor('foo', 'bar'); });
    if (!objectGOPDAcceptsPrimitives) {
      var originalObjectGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
      overrideNative(Object, 'getOwnPropertyDescriptor', function getOwnPropertyDescriptor(value, property) {
        return originalObjectGetOwnPropertyDescriptor(ES.ToObject(value), property);
      });
    }
  }
  if (Object.seal) {
    var objectSealAcceptsPrimitives = !throwsError(function () { return Object.seal('foo'); });
    if (!objectSealAcceptsPrimitives) {
      var originalObjectSeal = Object.seal;
      overrideNative(Object, 'seal', function seal(value) {
        if (!ES.TypeIsObject(value)) { return value; }
        return originalObjectSeal(value);
      });
    }
  }
  if (Object.isSealed) {
    var objectIsSealedAcceptsPrimitives = !throwsError(function () { return Object.isSealed('foo'); });
    if (!objectIsSealedAcceptsPrimitives) {
      var originalObjectIsSealed = Object.isSealed;
      overrideNative(Object, 'isSealed', function isSealed(value) {
        if (!ES.TypeIsObject(value)) { return true; }
        return originalObjectIsSealed(value);
      });
    }
  }
  if (Object.freeze) {
    var objectFreezeAcceptsPrimitives = !throwsError(function () { return Object.freeze('foo'); });
    if (!objectFreezeAcceptsPrimitives) {
      var originalObjectFreeze = Object.freeze;
      overrideNative(Object, 'freeze', function freeze(value) {
        if (!ES.TypeIsObject(value)) { return value; }
        return originalObjectFreeze(value);
      });
    }
  }
  if (Object.isFrozen) {
    var objectIsFrozenAcceptsPrimitives = !throwsError(function () { return Object.isFrozen('foo'); });
    if (!objectIsFrozenAcceptsPrimitives) {
      var originalObjectIsFrozen = Object.isFrozen;
      overrideNative(Object, 'isFrozen', function isFrozen(value) {
        if (!ES.TypeIsObject(value)) { return true; }
        return originalObjectIsFrozen(value);
      });
    }
  }
  if (Object.preventExtensions) {
    var objectPreventExtensionsAcceptsPrimitives = !throwsError(function () { return Object.preventExtensions('foo'); });
    if (!objectPreventExtensionsAcceptsPrimitives) {
      var originalObjectPreventExtensions = Object.preventExtensions;
      overrideNative(Object, 'preventExtensions', function preventExtensions(value) {
        if (!ES.TypeIsObject(value)) { return value; }
        return originalObjectPreventExtensions(value);
      });
    }
  }
  if (Object.isExtensible) {
    var objectIsExtensibleAcceptsPrimitives = !throwsError(function () { return Object.isExtensible('foo'); });
    if (!objectIsExtensibleAcceptsPrimitives) {
      var originalObjectIsExtensible = Object.isExtensible;
      overrideNative(Object, 'isExtensible', function isExtensible(value) {
        if (!ES.TypeIsObject(value)) { return false; }
        return originalObjectIsExtensible(value);
      });
    }
  }
  if (Object.getPrototypeOf) {
    var objectGetProtoAcceptsPrimitives = !throwsError(function () { return Object.getPrototypeOf('foo'); });
    if (!objectGetProtoAcceptsPrimitives) {
      var originalGetProto = Object.getPrototypeOf;
      overrideNative(Object, 'getPrototypeOf', function getPrototypeOf(value) {
        return originalGetProto(ES.ToObject(value));
      });
    }
  }

  var hasFlags = supportsDescriptors && (function () {
    var desc = Object.getOwnPropertyDescriptor(RegExp.prototype, 'flags');
    return desc && ES.IsCallable(desc.get);
  }());
  if (supportsDescriptors && !hasFlags) {
    var regExpFlagsGetter = function flags() {
      if (!ES.TypeIsObject(this)) {
        throw new TypeError('Method called on incompatible type: must be an object.');
      }
      var result = '';
      if (this.global) {
        result += 'g';
      }
      if (this.ignoreCase) {
        result += 'i';
      }
      if (this.multiline) {
        result += 'm';
      }
      if (this.unicode) {
        result += 'u';
      }
      if (this.sticky) {
        result += 'y';
      }
      return result;
    };

    Value.getter(RegExp.prototype, 'flags', regExpFlagsGetter);
  }

  var regExpSupportsFlagsWithRegex = supportsDescriptors && valueOrFalseIfThrows(function () {
    return String(new RegExp(/a/g, 'i')) === '/a/i';
  });
  var regExpNeedsToSupportSymbolMatch = hasSymbols && supportsDescriptors && (function () {
    // Edge 0.12 supports flags fully, but does not support Symbol.match
    var regex = /./;
    regex[Symbol.match] = false;
    return RegExp(regex) === regex;
  }());

  var regexToStringIsGeneric = valueOrFalseIfThrows(function () {
    return RegExp.prototype.toString.call({ source: 'abc' }) === '/abc/';
  });
  var regexToStringSupportsGenericFlags = regexToStringIsGeneric && valueOrFalseIfThrows(function () {
    return RegExp.prototype.toString.call({ source: 'a', flags: 'b' }) === '/a/b';
  });
  if (!regexToStringIsGeneric || !regexToStringSupportsGenericFlags) {
    var origRegExpToString = RegExp.prototype.toString;
    defineProperty(RegExp.prototype, 'toString', function toString() {
      var R = ES.RequireObjectCoercible(this);
      if (Type.regex(R)) {
        return _call(origRegExpToString, R);
      }
      var pattern = $String(R.source);
      var flags = $String(R.flags);
      return '/' + pattern + '/' + flags;
    }, true);
    Value.preserveToString(RegExp.prototype.toString, origRegExpToString);
  }

  if (supportsDescriptors && (!regExpSupportsFlagsWithRegex || regExpNeedsToSupportSymbolMatch)) {
    var flagsGetter = Object.getOwnPropertyDescriptor(RegExp.prototype, 'flags').get;
    var sourceDesc = Object.getOwnPropertyDescriptor(RegExp.prototype, 'source') || {};
    var legacySourceGetter = function () {
      // prior to it being a getter, it's own + nonconfigurable
      return this.source;
    };
    var sourceGetter = ES.IsCallable(sourceDesc.get) ? sourceDesc.get : legacySourceGetter;

    var OrigRegExp = RegExp;
    var RegExpShim = (function () {
      return function RegExp(pattern, flags) {
        var patternIsRegExp = ES.IsRegExp(pattern);
        var calledWithNew = this instanceof RegExp;
        if (!calledWithNew && patternIsRegExp && typeof flags === 'undefined' && pattern.constructor === RegExp) {
          return pattern;
        }

        var P = pattern;
        var F = flags;
        if (Type.regex(pattern)) {
          P = ES.Call(sourceGetter, pattern);
          F = typeof flags === 'undefined' ? ES.Call(flagsGetter, pattern) : flags;
          return new RegExp(P, F);
        } else if (patternIsRegExp) {
          P = pattern.source;
          F = typeof flags === 'undefined' ? pattern.flags : flags;
        }
        return new OrigRegExp(pattern, flags);
      };
    }());
    wrapConstructor(OrigRegExp, RegExpShim, {
      $input: true // Chrome < v39 & Opera < 26 have a nonstandard "$input" property
    });
    /* globals RegExp: true */
    /* eslint-disable no-undef, no-global-assign */
    RegExp = RegExpShim;
    Value.redefine(globals, 'RegExp', RegExpShim);
    /* eslint-enable no-undef, no-global-assign */
    /* globals RegExp: false */
  }

  if (supportsDescriptors) {
    var regexGlobals = {
      input: '$_',
      lastMatch: '$&',
      lastParen: '$+',
      leftContext: '$`',
      rightContext: '$\''
    };
    _forEach(keys(regexGlobals), function (prop) {
      if (prop in RegExp && !(regexGlobals[prop] in RegExp)) {
        Value.getter(RegExp, regexGlobals[prop], function get() {
          return RegExp[prop];
        });
      }
    });
  }
  addDefaultSpecies(RegExp);

  var inverseEpsilon = 1 / Number.EPSILON;
  var roundTiesToEven = function roundTiesToEven(n) {
    // Even though this reduces down to `return n`, it takes advantage of built-in rounding.
    return (n + inverseEpsilon) - inverseEpsilon;
  };
  var BINARY_32_EPSILON = Math.pow(2, -23);
  var BINARY_32_MAX_VALUE = Math.pow(2, 127) * (2 - BINARY_32_EPSILON);
  var BINARY_32_MIN_VALUE = Math.pow(2, -126);
  var E = Math.E;
  var LOG2E = Math.LOG2E;
  var LOG10E = Math.LOG10E;
  var numberCLZ = Number.prototype.clz;
  delete Number.prototype.clz; // Safari 8 has Number#clz

  var MathShims = {
    acosh: function acosh(value) {
      var x = Number(value);
      if (numberIsNaN(x) || value < 1) { return NaN; }
      if (x === 1) { return 0; }
      if (x === Infinity) { return x; }

      var xInvSquared = 1 / (x * x);
      if (x < 2) {
        return _log1p(x - 1 + (_sqrt(1 - xInvSquared) * x));
      }
      var halfX = x / 2;
      return _log1p(halfX + (_sqrt(1 - xInvSquared) * halfX) - 1) + (1 / LOG2E);
    },

    asinh: function asinh(value) {
      var x = Number(value);
      if (x === 0 || !globalIsFinite(x)) {
        return x;
      }

      var a = _abs(x);
      var aSquared = a * a;
      var s = _sign(x);
      if (a < 1) {
        return s * _log1p(a + (aSquared / (_sqrt(aSquared + 1) + 1)));
      }
      return s * (_log1p((a / 2) + (_sqrt(1 + (1 / aSquared)) * a / 2) - 1) + (1 / LOG2E));
    },

    atanh: function atanh(value) {
      var x = Number(value);

      if (x === 0) { return x; }
      if (x === -1) { return -Infinity; }
      if (x === 1) { return Infinity; }
      if (numberIsNaN(x) || x < -1 || x > 1) {
        return NaN;
      }

      var a = _abs(x);
      return _sign(x) * _log1p(2 * a / (1 - a)) / 2;
    },

    cbrt: function cbrt(value) {
      var x = Number(value);
      if (x === 0) { return x; }
      var negate = x < 0;
      var result;
      if (negate) { x = -x; }
      if (x === Infinity) {
        result = Infinity;
      } else {
        result = _exp(_log(x) / 3);
        // from http://en.wikipedia.org/wiki/Cube_root#Numerical_methods
        result = ((x / (result * result)) + (2 * result)) / 3;
      }
      return negate ? -result : result;
    },

    clz32: function clz32(value) {
      // See https://bugs.ecmascript.org/show_bug.cgi?id=2465
      var x = Number(value);
      var number = ES.ToUint32(x);
      if (number === 0) {
        return 32;
      }
      return numberCLZ ? ES.Call(numberCLZ, number) : 31 - _floor(_log(number + 0.5) * LOG2E);
    },

    cosh: function cosh(value) {
      var x = Number(value);
      if (x === 0) { return 1; } // +0 or -0
      if (numberIsNaN(x)) { return NaN; }
      if (!globalIsFinite(x)) { return Infinity; }

      var t = _exp(_abs(x) - 1);
      return (t + (1 / (t * E * E))) * (E / 2);
    },

    expm1: function expm1(value) {
      var x = Number(value);
      if (x === -Infinity) { return -1; }
      if (!globalIsFinite(x) || x === 0) { return x; }
      if (_abs(x) > 0.5) {
        return _exp(x) - 1;
      }
      // A more precise approximation using Taylor series expansion
      // from https://github.com/paulmillr/es6-shim/issues/314#issuecomment-70293986
      var t = x;
      var sum = 0;
      var n = 1;
      while (sum + t !== sum) {
        sum += t;
        n += 1;
        t *= x / n;
      }
      return sum;
    },

    hypot: function hypot(x, y) {
      var result = 0;
      var largest = 0;
      for (var i = 0; i < arguments.length; ++i) {
        var value = _abs(Number(arguments[i]));
        if (largest < value) {
          result *= (largest / value) * (largest / value);
          result += 1;
          largest = value;
        } else {
          result += value > 0 ? (value / largest) * (value / largest) : value;
        }
      }
      return largest === Infinity ? Infinity : largest * _sqrt(result);
    },

    log2: function log2(value) {
      return _log(value) * LOG2E;
    },

    log10: function log10(value) {
      return _log(value) * LOG10E;
    },

    log1p: _log1p,

    sign: _sign,

    sinh: function sinh(value) {
      var x = Number(value);
      if (!globalIsFinite(x) || x === 0) { return x; }

      var a = _abs(x);
      if (a < 1) {
        var u = Math.expm1(a);
        return _sign(x) * u * (1 + (1 / (u + 1))) / 2;
      }
      var t = _exp(a - 1);
      return _sign(x) * (t - (1 / (t * E * E))) * (E / 2);
    },

    tanh: function tanh(value) {
      var x = Number(value);
      if (numberIsNaN(x) || x === 0) { return x; }
      // can exit early at +-20 as JS loses precision for true value at this integer
      if (x >= 20) { return 1; }
      if (x <= -20) { return -1; }

      return (Math.expm1(x) - Math.expm1(-x)) / (_exp(x) + _exp(-x));
    },

    trunc: function trunc(value) {
      var x = Number(value);
      return x < 0 ? -_floor(-x) : _floor(x);
    },

    imul: function imul(x, y) {
      // taken from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/imul
      var a = ES.ToUint32(x);
      var b = ES.ToUint32(y);
      var ah = (a >>> 16) & 0xffff;
      var al = a & 0xffff;
      var bh = (b >>> 16) & 0xffff;
      var bl = b & 0xffff;
      // the shift by 0 fixes the sign on the high part
      // the final |0 converts the unsigned value into a signed value
      return (al * bl) + ((((ah * bl) + (al * bh)) << 16) >>> 0) | 0;
    },

    fround: function fround(x) {
      var v = Number(x);
      if (v === 0 || v === Infinity || v === -Infinity || numberIsNaN(v)) {
        return v;
      }
      var sign = _sign(v);
      var abs = _abs(v);
      if (abs < BINARY_32_MIN_VALUE) {
        return sign * roundTiesToEven(abs / BINARY_32_MIN_VALUE / BINARY_32_EPSILON) * BINARY_32_MIN_VALUE * BINARY_32_EPSILON;
      }
      // Veltkamp's splitting (?)
      var a = (1 + (BINARY_32_EPSILON / Number.EPSILON)) * abs;
      var result = a - (a - abs);
      if (result > BINARY_32_MAX_VALUE || numberIsNaN(result)) {
        return sign * Infinity;
      }
      return sign * result;
    }
  };

  var withinULPDistance = function withinULPDistance(result, expected, distance) {
    return _abs(1 - (result / expected)) / Number.EPSILON < (distance || 8);
  };

  defineProperties(Math, MathShims);
  // Chrome < 40 sinh returns ∞ for large numbers
  defineProperty(Math, 'sinh', MathShims.sinh, Math.sinh(710) === Infinity);
  // Chrome < 40 cosh returns ∞ for large numbers
  defineProperty(Math, 'cosh', MathShims.cosh, Math.cosh(710) === Infinity);
  // IE 11 TP has an imprecise log1p: reports Math.log1p(-1e-17) as 0
  defineProperty(Math, 'log1p', MathShims.log1p, Math.log1p(-1e-17) !== -1e-17);
  // IE 11 TP has an imprecise asinh: reports Math.asinh(-1e7) as not exactly equal to -Math.asinh(1e7)
  defineProperty(Math, 'asinh', MathShims.asinh, Math.asinh(-1e7) !== -Math.asinh(1e7));
  // Chrome < 54 asinh returns ∞ for large numbers and should not
  defineProperty(Math, 'asinh', MathShims.asinh, Math.asinh(1e+300) === Infinity);
  // Chrome < 54 atanh incorrectly returns 0 for large numbers
  defineProperty(Math, 'atanh', MathShims.atanh, Math.atanh(1e-300) === 0);
  // Chrome 40 has an imprecise Math.tanh with very small numbers
  defineProperty(Math, 'tanh', MathShims.tanh, Math.tanh(-2e-17) !== -2e-17);
  // Chrome 40 loses Math.acosh precision with high numbers
  defineProperty(Math, 'acosh', MathShims.acosh, Math.acosh(Number.MAX_VALUE) === Infinity);
  // Chrome < 54 has an inaccurate acosh for EPSILON deltas
  defineProperty(Math, 'acosh', MathShims.acosh, !withinULPDistance(Math.acosh(1 + Number.EPSILON), Math.sqrt(2 * Number.EPSILON)));
  // Firefox 38 on Windows
  defineProperty(Math, 'cbrt', MathShims.cbrt, !withinULPDistance(Math.cbrt(1e-300), 1e-100));
  // node 0.11 has an imprecise Math.sinh with very small numbers
  defineProperty(Math, 'sinh', MathShims.sinh, Math.sinh(-2e-17) !== -2e-17);
  // FF 35 on Linux reports 22025.465794806725 for Math.expm1(10)
  var expm1OfTen = Math.expm1(10);
  defineProperty(Math, 'expm1', MathShims.expm1, expm1OfTen > 22025.465794806719 || expm1OfTen < 22025.4657948067165168);

  var origMathRound = Math.round;
  // breaks in e.g. Safari 8, Internet Explorer 11, Opera 12
  var roundHandlesBoundaryConditions = Math.round(0.5 - (Number.EPSILON / 4)) === 0 &&
    Math.round(-0.5 + (Number.EPSILON / 3.99)) === 1;

  // When engines use Math.floor(x + 0.5) internally, Math.round can be buggy for large integers.
  // This behavior should be governed by "round to nearest, ties to even mode"
  // see http://www.ecma-international.org/ecma-262/6.0/#sec-terms-and-definitions-number-type
  // These are the boundary cases where it breaks.
  var smallestPositiveNumberWhereRoundBreaks = inverseEpsilon + 1;
  var largestPositiveNumberWhereRoundBreaks = (2 * inverseEpsilon) - 1;
  var roundDoesNotIncreaseIntegers = [
    smallestPositiveNumberWhereRoundBreaks,
    largestPositiveNumberWhereRoundBreaks
  ].every(function (num) {
    return Math.round(num) === num;
  });
  defineProperty(Math, 'round', function round(x) {
    var floor = _floor(x);
    var ceil = floor === -1 ? -0 : floor + 1;
    return x - floor < 0.5 ? floor : ceil;
  }, !roundHandlesBoundaryConditions || !roundDoesNotIncreaseIntegers);
  Value.preserveToString(Math.round, origMathRound);

  var origImul = Math.imul;
  if (Math.imul(0xffffffff, 5) !== -5) {
    // Safari 6.1, at least, reports "0" for this value
    Math.imul = MathShims.imul;
    Value.preserveToString(Math.imul, origImul);
  }
  if (Math.imul.length !== 2) {
    // Safari 8.0.4 has a length of 1
    // fixed in https://bugs.webkit.org/show_bug.cgi?id=143658
    overrideNative(Math, 'imul', function imul(x, y) {
      return ES.Call(origImul, Math, arguments);
    });
  }

  // Promises
  // Simplest possible implementation; use a 3rd-party library if you
  // want the best possible speed and/or long stack traces.
  var PromiseShim = (function () {
    var setTimeout = globals.setTimeout;
    // some environments don't have setTimeout - no way to shim here.
    if (typeof setTimeout !== 'function' && typeof setTimeout !== 'object') { return; }

    ES.IsPromise = function (promise) {
      if (!ES.TypeIsObject(promise)) {
        return false;
      }
      if (typeof promise._promise === 'undefined') {
        return false; // uninitialized, or missing our hidden field.
      }
      return true;
    };

    // "PromiseCapability" in the spec is what most promise implementations
    // call a "deferred".
    var PromiseCapability = function (C) {
      if (!ES.IsConstructor(C)) {
        throw new TypeError('Bad promise constructor');
      }
      var capability = this;
      var resolver = function (resolve, reject) {
        if (capability.resolve !== void 0 || capability.reject !== void 0) {
          throw new TypeError('Bad Promise implementation!');
        }
        capability.resolve = resolve;
        capability.reject = reject;
      };
      // Initialize fields to inform optimizers about the object shape.
      capability.resolve = void 0;
      capability.reject = void 0;
      capability.promise = new C(resolver);
      if (!(ES.IsCallable(capability.resolve) && ES.IsCallable(capability.reject))) {
        throw new TypeError('Bad promise constructor');
      }
    };

    // find an appropriate setImmediate-alike
    var makeZeroTimeout;
    /*global window */
    if (typeof window !== 'undefined' && ES.IsCallable(window.postMessage)) {
      makeZeroTimeout = function () {
        // from http://dbaron.org/log/20100309-faster-timeouts
        var timeouts = [];
        var messageName = 'zero-timeout-message';
        var setZeroTimeout = function (fn) {
          _push(timeouts, fn);
          window.postMessage(messageName, '*');
        };
        var handleMessage = function (event) {
          if (event.source === window && event.data === messageName) {
            event.stopPropagation();
            if (timeouts.length === 0) { return; }
            var fn = _shift(timeouts);
            fn();
          }
        };
        window.addEventListener('message', handleMessage, true);
        return setZeroTimeout;
      };
    }
    var makePromiseAsap = function () {
      // An efficient task-scheduler based on a pre-existing Promise
      // implementation, which we can use even if we override the
      // global Promise below (in order to workaround bugs)
      // https://github.com/Raynos/observ-hash/issues/2#issuecomment-35857671
      var P = globals.Promise;
      var pr = P && P.resolve && P.resolve();
      return pr && function (task) {
        return pr.then(task);
      };
    };
    /*global process */
    var enqueue = ES.IsCallable(globals.setImmediate) ?
      globals.setImmediate :
      typeof process === 'object' && process.nextTick ? process.nextTick : makePromiseAsap() ||
      (ES.IsCallable(makeZeroTimeout) ? makeZeroTimeout() : function (task) { setTimeout(task, 0); }); // fallback

    // Constants for Promise implementation
    var PROMISE_IDENTITY = function (x) { return x; };
    var PROMISE_THROWER = function (e) { throw e; };
    var PROMISE_PENDING = 0;
    var PROMISE_FULFILLED = 1;
    var PROMISE_REJECTED = 2;
    // We store fulfill/reject handlers and capabilities in a single array.
    var PROMISE_FULFILL_OFFSET = 0;
    var PROMISE_REJECT_OFFSET = 1;
    var PROMISE_CAPABILITY_OFFSET = 2;
    // This is used in an optimization for chaining promises via then.
    var PROMISE_FAKE_CAPABILITY = {};

    var enqueuePromiseReactionJob = function (handler, capability, argument) {
      enqueue(function () {
        promiseReactionJob(handler, capability, argument);
      });
    };

    var promiseReactionJob = function (handler, promiseCapability, argument) {
      var handlerResult, f;
      if (promiseCapability === PROMISE_FAKE_CAPABILITY) {
        // Fast case, when we don't actually need to chain through to a
        // (real) promiseCapability.
        return handler(argument);
      }
      try {
        handlerResult = handler(argument);
        f = promiseCapability.resolve;
      } catch (e) {
        handlerResult = e;
        f = promiseCapability.reject;
      }
      f(handlerResult);
    };

    var fulfillPromise = function (promise, value) {
      var _promise = promise._promise;
      var length = _promise.reactionLength;
      if (length > 0) {
        enqueuePromiseReactionJob(
          _promise.fulfillReactionHandler0,
          _promise.reactionCapability0,
          value
        );
        _promise.fulfillReactionHandler0 = void 0;
        _promise.rejectReactions0 = void 0;
        _promise.reactionCapability0 = void 0;
        if (length > 1) {
          for (var i = 1, idx = 0; i < length; i++, idx += 3) {
            enqueuePromiseReactionJob(
              _promise[idx + PROMISE_FULFILL_OFFSET],
              _promise[idx + PROMISE_CAPABILITY_OFFSET],
              value
            );
            promise[idx + PROMISE_FULFILL_OFFSET] = void 0;
            promise[idx + PROMISE_REJECT_OFFSET] = void 0;
            promise[idx + PROMISE_CAPABILITY_OFFSET] = void 0;
          }
        }
      }
      _promise.result = value;
      _promise.state = PROMISE_FULFILLED;
      _promise.reactionLength = 0;
    };

    var rejectPromise = function (promise, reason) {
      var _promise = promise._promise;
      var length = _promise.reactionLength;
      if (length > 0) {
        enqueuePromiseReactionJob(
          _promise.rejectReactionHandler0,
          _promise.reactionCapability0,
          reason
        );
        _promise.fulfillReactionHandler0 = void 0;
        _promise.rejectReactions0 = void 0;
        _promise.reactionCapability0 = void 0;
        if (length > 1) {
          for (var i = 1, idx = 0; i < length; i++, idx += 3) {
            enqueuePromiseReactionJob(
              _promise[idx + PROMISE_REJECT_OFFSET],
              _promise[idx + PROMISE_CAPABILITY_OFFSET],
              reason
            );
            promise[idx + PROMISE_FULFILL_OFFSET] = void 0;
            promise[idx + PROMISE_REJECT_OFFSET] = void 0;
            promise[idx + PROMISE_CAPABILITY_OFFSET] = void 0;
          }
        }
      }
      _promise.result = reason;
      _promise.state = PROMISE_REJECTED;
      _promise.reactionLength = 0;
    };

    var createResolvingFunctions = function (promise) {
      var alreadyResolved = false;
      var resolve = function (resolution) {
        var then;
        if (alreadyResolved) { return; }
        alreadyResolved = true;
        if (resolution === promise) {
          return rejectPromise(promise, new TypeError('Self resolution'));
        }
        if (!ES.TypeIsObject(resolution)) {
          return fulfillPromise(promise, resolution);
        }
        try {
          then = resolution.then;
        } catch (e) {
          return rejectPromise(promise, e);
        }
        if (!ES.IsCallable(then)) {
          return fulfillPromise(promise, resolution);
        }
        enqueue(function () {
          promiseResolveThenableJob(promise, resolution, then);
        });
      };
      var reject = function (reason) {
        if (alreadyResolved) { return; }
        alreadyResolved = true;
        return rejectPromise(promise, reason);
      };
      return { resolve: resolve, reject: reject };
    };

    var optimizedThen = function (then, thenable, resolve, reject) {
      // Optimization: since we discard the result, we can pass our
      // own then implementation a special hint to let it know it
      // doesn't have to create it.  (The PROMISE_FAKE_CAPABILITY
      // object is local to this implementation and unforgeable outside.)
      if (then === Promise$prototype$then) {
        _call(then, thenable, resolve, reject, PROMISE_FAKE_CAPABILITY);
      } else {
        _call(then, thenable, resolve, reject);
      }
    };
    var promiseResolveThenableJob = function (promise, thenable, then) {
      var resolvingFunctions = createResolvingFunctions(promise);
      var resolve = resolvingFunctions.resolve;
      var reject = resolvingFunctions.reject;
      try {
        optimizedThen(then, thenable, resolve, reject);
      } catch (e) {
        reject(e);
      }
    };

    var Promise$prototype, Promise$prototype$then;
    var Promise = (function () {
      var PromiseShim = function Promise(resolver) {
        if (!(this instanceof PromiseShim)) {
          throw new TypeError('Constructor Promise requires "new"');
        }
        if (this && this._promise) {
          throw new TypeError('Bad construction');
        }
        // see https://bugs.ecmascript.org/show_bug.cgi?id=2482
        if (!ES.IsCallable(resolver)) {
          throw new TypeError('not a valid resolver');
        }
        var promise = emulateES6construct(this, PromiseShim, Promise$prototype, {
          _promise: {
            result: void 0,
            state: PROMISE_PENDING,
            // The first member of the "reactions" array is inlined here,
            // since most promises only have one reaction.
            // We've also exploded the 'reaction' object to inline the
            // "handler" and "capability" fields, since both fulfill and
            // reject reactions share the same capability.
            reactionLength: 0,
            fulfillReactionHandler0: void 0,
            rejectReactionHandler0: void 0,
            reactionCapability0: void 0
          }
        });
        var resolvingFunctions = createResolvingFunctions(promise);
        var reject = resolvingFunctions.reject;
        try {
          resolver(resolvingFunctions.resolve, reject);
        } catch (e) {
          reject(e);
        }
        return promise;
      };
      return PromiseShim;
    }());
    Promise$prototype = Promise.prototype;

    var _promiseAllResolver = function (index, values, capability, remaining) {
      var alreadyCalled = false;
      return function (x) {
        if (alreadyCalled) { return; }
        alreadyCalled = true;
        values[index] = x;
        if ((--remaining.count) === 0) {
          var resolve = capability.resolve;
          resolve(values); // call w/ this===undefined
        }
      };
    };

    var performPromiseAll = function (iteratorRecord, C, resultCapability) {
      var it = iteratorRecord.iterator;
      var values = [];
      var remaining = { count: 1 };
      var next, nextValue;
      var index = 0;
      while (true) {
        try {
          next = ES.IteratorStep(it);
          if (next === false) {
            iteratorRecord.done = true;
            break;
          }
          nextValue = next.value;
        } catch (e) {
          iteratorRecord.done = true;
          throw e;
        }
        values[index] = void 0;
        var nextPromise = C.resolve(nextValue);
        var resolveElement = _promiseAllResolver(
          index,
          values,
          resultCapability,
          remaining
        );
        remaining.count += 1;
        optimizedThen(nextPromise.then, nextPromise, resolveElement, resultCapability.reject);
        index += 1;
      }
      if ((--remaining.count) === 0) {
        var resolve = resultCapability.resolve;
        resolve(values); // call w/ this===undefined
      }
      return resultCapability.promise;
    };

    var performPromiseRace = function (iteratorRecord, C, resultCapability) {
      var it = iteratorRecord.iterator;
      var next, nextValue, nextPromise;
      while (true) {
        try {
          next = ES.IteratorStep(it);
          if (next === false) {
            // NOTE: If iterable has no items, resulting promise will never
            // resolve; see:
            // https://github.com/domenic/promises-unwrapping/issues/75
            // https://bugs.ecmascript.org/show_bug.cgi?id=2515
            iteratorRecord.done = true;
            break;
          }
          nextValue = next.value;
        } catch (e) {
          iteratorRecord.done = true;
          throw e;
        }
        nextPromise = C.resolve(nextValue);
        optimizedThen(nextPromise.then, nextPromise, resultCapability.resolve, resultCapability.reject);
      }
      return resultCapability.promise;
    };

    defineProperties(Promise, {
      all: function all(iterable) {
        var C = this;
        if (!ES.TypeIsObject(C)) {
          throw new TypeError('Promise is not object');
        }
        var capability = new PromiseCapability(C);
        var iterator, iteratorRecord;
        try {
          iterator = ES.GetIterator(iterable);
          iteratorRecord = { iterator: iterator, done: false };
          return performPromiseAll(iteratorRecord, C, capability);
        } catch (e) {
          var exception = e;
          if (iteratorRecord && !iteratorRecord.done) {
            try {
              ES.IteratorClose(iterator, true);
            } catch (ee) {
              exception = ee;
            }
          }
          var reject = capability.reject;
          reject(exception);
          return capability.promise;
        }
      },

      race: function race(iterable) {
        var C = this;
        if (!ES.TypeIsObject(C)) {
          throw new TypeError('Promise is not object');
        }
        var capability = new PromiseCapability(C);
        var iterator, iteratorRecord;
        try {
          iterator = ES.GetIterator(iterable);
          iteratorRecord = { iterator: iterator, done: false };
          return performPromiseRace(iteratorRecord, C, capability);
        } catch (e) {
          var exception = e;
          if (iteratorRecord && !iteratorRecord.done) {
            try {
              ES.IteratorClose(iterator, true);
            } catch (ee) {
              exception = ee;
            }
          }
          var reject = capability.reject;
          reject(exception);
          return capability.promise;
        }
      },

      reject: function reject(reason) {
        var C = this;
        if (!ES.TypeIsObject(C)) {
          throw new TypeError('Bad promise constructor');
        }
        var capability = new PromiseCapability(C);
        var rejectFunc = capability.reject;
        rejectFunc(reason); // call with this===undefined
        return capability.promise;
      },

      resolve: function resolve(v) {
        // See https://esdiscuss.org/topic/fixing-promise-resolve for spec
        var C = this;
        if (!ES.TypeIsObject(C)) {
          throw new TypeError('Bad promise constructor');
        }
        if (ES.IsPromise(v)) {
          var constructor = v.constructor;
          if (constructor === C) {
            return v;
          }
        }
        var capability = new PromiseCapability(C);
        var resolveFunc = capability.resolve;
        resolveFunc(v); // call with this===undefined
        return capability.promise;
      }
    });

    defineProperties(Promise$prototype, {
      'catch': function (onRejected) {
        return this.then(null, onRejected);
      },

      then: function then(onFulfilled, onRejected) {
        var promise = this;
        if (!ES.IsPromise(promise)) { throw new TypeError('not a promise'); }
        var C = ES.SpeciesConstructor(promise, Promise);
        var resultCapability;
        var returnValueIsIgnored = arguments.length > 2 && arguments[2] === PROMISE_FAKE_CAPABILITY;
        if (returnValueIsIgnored && C === Promise) {
          resultCapability = PROMISE_FAKE_CAPABILITY;
        } else {
          resultCapability = new PromiseCapability(C);
        }
        // PerformPromiseThen(promise, onFulfilled, onRejected, resultCapability)
        // Note that we've split the 'reaction' object into its two
        // components, "capabilities" and "handler"
        // "capabilities" is always equal to `resultCapability`
        var fulfillReactionHandler = ES.IsCallable(onFulfilled) ? onFulfilled : PROMISE_IDENTITY;
        var rejectReactionHandler = ES.IsCallable(onRejected) ? onRejected : PROMISE_THROWER;
        var _promise = promise._promise;
        var value;
        if (_promise.state === PROMISE_PENDING) {
          if (_promise.reactionLength === 0) {
            _promise.fulfillReactionHandler0 = fulfillReactionHandler;
            _promise.rejectReactionHandler0 = rejectReactionHandler;
            _promise.reactionCapability0 = resultCapability;
          } else {
            var idx = 3 * (_promise.reactionLength - 1);
            _promise[idx + PROMISE_FULFILL_OFFSET] = fulfillReactionHandler;
            _promise[idx + PROMISE_REJECT_OFFSET] = rejectReactionHandler;
            _promise[idx + PROMISE_CAPABILITY_OFFSET] = resultCapability;
          }
          _promise.reactionLength += 1;
        } else if (_promise.state === PROMISE_FULFILLED) {
          value = _promise.result;
          enqueuePromiseReactionJob(
            fulfillReactionHandler,
            resultCapability,
            value
          );
        } else if (_promise.state === PROMISE_REJECTED) {
          value = _promise.result;
          enqueuePromiseReactionJob(
            rejectReactionHandler,
            resultCapability,
            value
          );
        } else {
          throw new TypeError('unexpected Promise state');
        }
        return resultCapability.promise;
      }
    });
    // This helps the optimizer by ensuring that methods which take
    // capabilities aren't polymorphic.
    PROMISE_FAKE_CAPABILITY = new PromiseCapability(Promise);
    Promise$prototype$then = Promise$prototype.then;

    return Promise;
  }());

  // Chrome's native Promise has extra methods that it shouldn't have. Let's remove them.
  if (globals.Promise) {
    delete globals.Promise.accept;
    delete globals.Promise.defer;
    delete globals.Promise.prototype.chain;
  }

  if (typeof PromiseShim === 'function') {
    // export the Promise constructor.
    defineProperties(globals, { Promise: PromiseShim });
    // In Chrome 33 (and thereabouts) Promise is defined, but the
    // implementation is buggy in a number of ways.  Let's check subclassing
    // support to see if we have a buggy implementation.
    var promiseSupportsSubclassing = supportsSubclassing(globals.Promise, function (S) {
      return S.resolve(42).then(function () {}) instanceof S;
    });
    var promiseIgnoresNonFunctionThenCallbacks = !throwsError(function () {
      return globals.Promise.reject(42).then(null, 5).then(null, noop);
    });
    var promiseRequiresObjectContext = throwsError(function () { return globals.Promise.call(3, noop); });
    // Promise.resolve() was errata'ed late in the ES6 process.
    // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1170742
    //      https://code.google.com/p/v8/issues/detail?id=4161
    // It serves as a proxy for a number of other bugs in early Promise
    // implementations.
    var promiseResolveBroken = (function (Promise) {
      var p = Promise.resolve(5);
      p.constructor = {};
      var p2 = Promise.resolve(p);
      try {
        p2.then(null, noop).then(null, noop); // avoid "uncaught rejection" warnings in console
      } catch (e) {
        return true; // v8 native Promises break here https://code.google.com/p/chromium/issues/detail?id=575314
      }
      return p === p2; // This *should* be false!
    }(globals.Promise));

    // Chrome 46 (probably older too) does not retrieve a thenable's .then synchronously
    var getsThenSynchronously = supportsDescriptors && (function () {
      var count = 0;
      // eslint-disable-next-line getter-return
      var thenable = Object.defineProperty({}, 'then', { get: function () { count += 1; } });
      Promise.resolve(thenable);
      return count === 1;
    }());

    var BadResolverPromise = function BadResolverPromise(executor) {
      var p = new Promise(executor);
      executor(3, function () {});
      this.then = p.then;
      this.constructor = BadResolverPromise;
    };
    BadResolverPromise.prototype = Promise.prototype;
    BadResolverPromise.all = Promise.all;
    // Chrome Canary 49 (probably older too) has some implementation bugs
    var hasBadResolverPromise = valueOrFalseIfThrows(function () {
      return !!BadResolverPromise.all([1, 2]);
    });

    if (!promiseSupportsSubclassing || !promiseIgnoresNonFunctionThenCallbacks ||
        !promiseRequiresObjectContext || promiseResolveBroken ||
        !getsThenSynchronously || hasBadResolverPromise) {
      /* globals Promise: true */
      /* eslint-disable no-undef, no-global-assign */
      Promise = PromiseShim;
      /* eslint-enable no-undef, no-global-assign */
      /* globals Promise: false */
      overrideNative(globals, 'Promise', PromiseShim);
    }
    if (Promise.all.length !== 1) {
      var origAll = Promise.all;
      overrideNative(Promise, 'all', function all(iterable) {
        return ES.Call(origAll, this, arguments);
      });
    }
    if (Promise.race.length !== 1) {
      var origRace = Promise.race;
      overrideNative(Promise, 'race', function race(iterable) {
        return ES.Call(origRace, this, arguments);
      });
    }
    if (Promise.resolve.length !== 1) {
      var origResolve = Promise.resolve;
      overrideNative(Promise, 'resolve', function resolve(x) {
        return ES.Call(origResolve, this, arguments);
      });
    }
    if (Promise.reject.length !== 1) {
      var origReject = Promise.reject;
      overrideNative(Promise, 'reject', function reject(r) {
        return ES.Call(origReject, this, arguments);
      });
    }
    ensureEnumerable(Promise, 'all');
    ensureEnumerable(Promise, 'race');
    ensureEnumerable(Promise, 'resolve');
    ensureEnumerable(Promise, 'reject');
    addDefaultSpecies(Promise);
  }

  // Map and Set require a true ES5 environment
  // Their fast path also requires that the environment preserve
  // property insertion order, which is not guaranteed by the spec.
  var testOrder = function (a) {
    var b = keys(_reduce(a, function (o, k) {
      o[k] = true;
      return o;
    }, {}));
    return a.join(':') === b.join(':');
  };
  var preservesInsertionOrder = testOrder(['z', 'a', 'bb']);
  // some engines (eg, Chrome) only preserve insertion order for string keys
  var preservesNumericInsertionOrder = testOrder(['z', 1, 'a', '3', 2]);

  if (supportsDescriptors) {

    var fastkey = function fastkey(key, skipInsertionOrderCheck) {
      if (!skipInsertionOrderCheck && !preservesInsertionOrder) {
        return null;
      }
      if (isNullOrUndefined(key)) {
        return '^' + ES.ToString(key);
      } else if (typeof key === 'string') {
        return '$' + key;
      } else if (typeof key === 'number') {
        // note that -0 will get coerced to "0" when used as a property key
        if (!preservesNumericInsertionOrder) {
          return 'n' + key;
        }
        return key;
      } else if (typeof key === 'boolean') {
        return 'b' + key;
      }
      return null;
    };

    var emptyObject = function emptyObject() {
      // accomodate some older not-quite-ES5 browsers
      return Object.create ? Object.create(null) : {};
    };

    var addIterableToMap = function addIterableToMap(MapConstructor, map, iterable) {
      if (isArray(iterable) || Type.string(iterable)) {
        _forEach(iterable, function (entry) {
          if (!ES.TypeIsObject(entry)) {
            throw new TypeError('Iterator value ' + entry + ' is not an entry object');
          }
          map.set(entry[0], entry[1]);
        });
      } else if (iterable instanceof MapConstructor) {
        _call(MapConstructor.prototype.forEach, iterable, function (value, key) {
          map.set(key, value);
        });
      } else {
        var iter, adder;
        if (!isNullOrUndefined(iterable)) {
          adder = map.set;
          if (!ES.IsCallable(adder)) { throw new TypeError('bad map'); }
          iter = ES.GetIterator(iterable);
        }
        if (typeof iter !== 'undefined') {
          while (true) {
            var next = ES.IteratorStep(iter);
            if (next === false) { break; }
            var nextItem = next.value;
            try {
              if (!ES.TypeIsObject(nextItem)) {
                throw new TypeError('Iterator value ' + nextItem + ' is not an entry object');
              }
              _call(adder, map, nextItem[0], nextItem[1]);
            } catch (e) {
              ES.IteratorClose(iter, true);
              throw e;
            }
          }
        }
      }
    };
    var addIterableToSet = function addIterableToSet(SetConstructor, set, iterable) {
      if (isArray(iterable) || Type.string(iterable)) {
        _forEach(iterable, function (value) {
          set.add(value);
        });
      } else if (iterable instanceof SetConstructor) {
        _call(SetConstructor.prototype.forEach, iterable, function (value) {
          set.add(value);
        });
      } else {
        var iter, adder;
        if (!isNullOrUndefined(iterable)) {
          adder = set.add;
          if (!ES.IsCallable(adder)) { throw new TypeError('bad set'); }
          iter = ES.GetIterator(iterable);
        }
        if (typeof iter !== 'undefined') {
          while (true) {
            var next = ES.IteratorStep(iter);
            if (next === false) { break; }
            var nextValue = next.value;
            try {
              _call(adder, set, nextValue);
            } catch (e) {
              ES.IteratorClose(iter, true);
              throw e;
            }
          }
        }
      }
    };

    var collectionShims = {
      Map: (function () {

        var empty = {};

        var MapEntry = function MapEntry(key, value) {
          this.key = key;
          this.value = value;
          this.next = null;
          this.prev = null;
        };

        MapEntry.prototype.isRemoved = function isRemoved() {
          return this.key === empty;
        };

        var isMap = function isMap(map) {
          return !!map._es6map;
        };

        var requireMapSlot = function requireMapSlot(map, method) {
          if (!ES.TypeIsObject(map) || !isMap(map)) {
            throw new TypeError('Method Map.prototype.' + method + ' called on incompatible receiver ' + ES.ToString(map));
          }
        };

        var MapIterator = function MapIterator(map, kind) {
          requireMapSlot(map, '[[MapIterator]]');
          this.head = map._head;
          this.i = this.head;
          this.kind = kind;
        };

        MapIterator.prototype = {
          isMapIterator: true,
          next: function next() {
            if (!this.isMapIterator) {
              throw new TypeError('Not a MapIterator');
            }
            var i = this.i;
            var kind = this.kind;
            var head = this.head;
            if (typeof this.i === 'undefined') {
              return iteratorResult();
            }
            while (i.isRemoved() && i !== head) {
              // back up off of removed entries
              i = i.prev;
            }
            // advance to next unreturned element.
            var result;
            while (i.next !== head) {
              i = i.next;
              if (!i.isRemoved()) {
                if (kind === 'key') {
                  result = i.key;
                } else if (kind === 'value') {
                  result = i.value;
                } else {
                  result = [i.key, i.value];
                }
                this.i = i;
                return iteratorResult(result);
              }
            }
            // once the iterator is done, it is done forever.
            this.i = void 0;
            return iteratorResult();
          }
        };
        addIterator(MapIterator.prototype);

        var Map$prototype;
        var MapShim = function Map() {
          if (!(this instanceof Map)) {
            throw new TypeError('Constructor Map requires "new"');
          }
          if (this && this._es6map) {
            throw new TypeError('Bad construction');
          }
          var map = emulateES6construct(this, Map, Map$prototype, {
            _es6map: true,
            _head: null,
            _map: OrigMap ? new OrigMap() : null,
            _size: 0,
            _storage: emptyObject()
          });

          var head = new MapEntry(null, null);
          // circular doubly-linked list.
          /* eslint no-multi-assign: 1 */
          head.next = head.prev = head;
          map._head = head;

          // Optionally initialize map from iterable
          if (arguments.length > 0) {
            addIterableToMap(Map, map, arguments[0]);
          }
          return map;
        };
        Map$prototype = MapShim.prototype;

        Value.getter(Map$prototype, 'size', function () {
          if (typeof this._size === 'undefined') {
            throw new TypeError('size method called on incompatible Map');
          }
          return this._size;
        });

        defineProperties(Map$prototype, {
          get: function get(key) {
            requireMapSlot(this, 'get');
            var entry;
            var fkey = fastkey(key, true);
            if (fkey !== null) {
              // fast O(1) path
              entry = this._storage[fkey];
              if (entry) {
                return entry.value;
              } else {
                return;
              }
            }
            if (this._map) {
              // fast object key path
              entry = origMapGet.call(this._map, key);
              if (entry) {
                return entry.value;
              } else {
                return;
              }
            }
            var head = this._head;
            var i = head;
            while ((i = i.next) !== head) {
              if (ES.SameValueZero(i.key, key)) {
                return i.value;
              }
            }
          },

          has: function has(key) {
            requireMapSlot(this, 'has');
            var fkey = fastkey(key, true);
            if (fkey !== null) {
              // fast O(1) path
              return typeof this._storage[fkey] !== 'undefined';
            }
            if (this._map) {
              // fast object key path
              return origMapHas.call(this._map, key);
            }
            var head = this._head;
            var i = head;
            while ((i = i.next) !== head) {
              if (ES.SameValueZero(i.key, key)) {
                return true;
              }
            }
            return false;
          },

          set: function set(key, value) {
            requireMapSlot(this, 'set');
            var head = this._head;
            var i = head;
            var entry;
            var fkey = fastkey(key, true);
            if (fkey !== null) {
              // fast O(1) path
              if (typeof this._storage[fkey] !== 'undefined') {
                this._storage[fkey].value = value;
                return this;
              } else {
                entry = this._storage[fkey] = new MapEntry(key, value); /* eslint no-multi-assign: 1 */
                i = head.prev;
                // fall through
              }
            } else if (this._map) {
              // fast object key path
              if (origMapHas.call(this._map, key)) {
                origMapGet.call(this._map, key).value = value;
              } else {
                entry = new MapEntry(key, value);
                origMapSet.call(this._map, key, entry);
                i = head.prev;
                // fall through
              }
            }
            while ((i = i.next) !== head) {
              if (ES.SameValueZero(i.key, key)) {
                i.value = value;
                return this;
              }
            }
            entry = entry || new MapEntry(key, value);
            if (ES.SameValue(-0, key)) {
              entry.key = +0; // coerce -0 to +0 in entry
            }
            entry.next = this._head;
            entry.prev = this._head.prev;
            entry.prev.next = entry;
            entry.next.prev = entry;
            this._size += 1;
            return this;
          },

          'delete': function (key) {
            requireMapSlot(this, 'delete');
            var head = this._head;
            var i = head;
            var fkey = fastkey(key, true);
            if (fkey !== null) {
              // fast O(1) path
              if (typeof this._storage[fkey] === 'undefined') {
                return false;
              }
              i = this._storage[fkey].prev;
              delete this._storage[fkey];
              // fall through
            } else if (this._map) {
              // fast object key path
              if (!origMapHas.call(this._map, key)) {
                return false;
              }
              i = origMapGet.call(this._map, key).prev;
              origMapDelete.call(this._map, key);
              // fall through
            }
            while ((i = i.next) !== head) {
              if (ES.SameValueZero(i.key, key)) {
                i.key = empty;
                i.value = empty;
                i.prev.next = i.next;
                i.next.prev = i.prev;
                this._size -= 1;
                return true;
              }
            }
            return false;
          },

          clear: function clear() {
            /* eslint no-multi-assign: 1 */
            requireMapSlot(this, 'clear');
            this._map = OrigMap ? new OrigMap() : null;
            this._size = 0;
            this._storage = emptyObject();
            var head = this._head;
            var i = head;
            var p = i.next;
            while ((i = p) !== head) {
              i.key = empty;
              i.value = empty;
              p = i.next;
              i.next = i.prev = head;
            }
            head.next = head.prev = head;
          },

          keys: function keys() {
            requireMapSlot(this, 'keys');
            return new MapIterator(this, 'key');
          },

          values: function values() {
            requireMapSlot(this, 'values');
            return new MapIterator(this, 'value');
          },

          entries: function entries() {
            requireMapSlot(this, 'entries');
            return new MapIterator(this, 'key+value');
          },

          forEach: function forEach(callback) {
            requireMapSlot(this, 'forEach');
            var context = arguments.length > 1 ? arguments[1] : null;
            var it = this.entries();
            for (var entry = it.next(); !entry.done; entry = it.next()) {
              if (context) {
                _call(callback, context, entry.value[1], entry.value[0], this);
              } else {
                callback(entry.value[1], entry.value[0], this);
              }
            }
          }
        });
        addIterator(Map$prototype, Map$prototype.entries);

        return MapShim;
      }()),

      Set: (function () {
        var isSet = function isSet(set) {
          return set._es6set && typeof set._storage !== 'undefined';
        };
        var requireSetSlot = function requireSetSlot(set, method) {
          if (!ES.TypeIsObject(set) || !isSet(set)) {
            // https://github.com/paulmillr/es6-shim/issues/176
            throw new TypeError('Set.prototype.' + method + ' called on incompatible receiver ' + ES.ToString(set));
          }
        };

        // Creating a Map is expensive.  To speed up the common case of
        // Sets containing only string or numeric keys, we use an object
        // as backing storage and lazily create a full Map only when
        // required.
        var Set$prototype;
        var SetShim = function Set() {
          if (!(this instanceof Set)) {
            throw new TypeError('Constructor Set requires "new"');
          }
          if (this && this._es6set) {
            throw new TypeError('Bad construction');
          }
          var set = emulateES6construct(this, Set, Set$prototype, {
            _es6set: true,
            '[[SetData]]': null,
            _storage: emptyObject()
          });
          if (!set._es6set) {
            throw new TypeError('bad set');
          }

          // Optionally initialize Set from iterable
          if (arguments.length > 0) {
            addIterableToSet(Set, set, arguments[0]);
          }
          return set;
        };
        Set$prototype = SetShim.prototype;

        var decodeKey = function (key) {
          var k = key;
          if (k === '^null') {
            return null;
          } else if (k === '^undefined') {
            return void 0;
          } else {
            var first = k.charAt(0);
            if (first === '$') {
              return _strSlice(k, 1);
            } else if (first === 'n') {
              return +_strSlice(k, 1);
            } else if (first === 'b') {
              return k === 'btrue';
            }
          }
          return +k;
        };
        // Switch from the object backing storage to a full Map.
        var ensureMap = function ensureMap(set) {
          if (!set['[[SetData]]']) {
            var m = new collectionShims.Map();
            set['[[SetData]]'] = m;
            _forEach(keys(set._storage), function (key) {
              var k = decodeKey(key);
              m.set(k, k);
            });
            set['[[SetData]]'] = m;
          }
          set._storage = null; // free old backing storage
        };

        Value.getter(SetShim.prototype, 'size', function () {
          requireSetSlot(this, 'size');
          if (this._storage) {
            return keys(this._storage).length;
          }
          ensureMap(this);
          return this['[[SetData]]'].size;
        });

        defineProperties(SetShim.prototype, {
          has: function has(key) {
            requireSetSlot(this, 'has');
            var fkey;
            if (this._storage && (fkey = fastkey(key)) !== null) {
              return !!this._storage[fkey];
            }
            ensureMap(this);
            return this['[[SetData]]'].has(key);
          },

          add: function add(key) {
            requireSetSlot(this, 'add');
            var fkey;
            if (this._storage && (fkey = fastkey(key)) !== null) {
              this._storage[fkey] = true;
              return this;
            }
            ensureMap(this);
            this['[[SetData]]'].set(key, key);
            return this;
          },

          'delete': function (key) {
            requireSetSlot(this, 'delete');
            var fkey;
            if (this._storage && (fkey = fastkey(key)) !== null) {
              var hasFKey = _hasOwnProperty(this._storage, fkey);
              return (delete this._storage[fkey]) && hasFKey;
            }
            ensureMap(this);
            return this['[[SetData]]']['delete'](key);
          },

          clear: function clear() {
            requireSetSlot(this, 'clear');
            if (this._storage) {
              this._storage = emptyObject();
            }
            if (this['[[SetData]]']) {
              this['[[SetData]]'].clear();
            }
          },

          values: function values() {
            requireSetSlot(this, 'values');
            ensureMap(this);
            return new SetIterator(this['[[SetData]]'].values());
          },

          entries: function entries() {
            requireSetSlot(this, 'entries');
            ensureMap(this);
            return new SetIterator(this['[[SetData]]'].entries());
          },

          forEach: function forEach(callback) {
            requireSetSlot(this, 'forEach');
            var context = arguments.length > 1 ? arguments[1] : null;
            var entireSet = this;
            ensureMap(entireSet);
            this['[[SetData]]'].forEach(function (value, key) {
              if (context) {
                _call(callback, context, key, key, entireSet);
              } else {
                callback(key, key, entireSet);
              }
            });
          }
        });
        defineProperty(SetShim.prototype, 'keys', SetShim.prototype.values, true);
        addIterator(SetShim.prototype, SetShim.prototype.values);

        var SetIterator = function SetIterator(it) {
          this.it = it;
        };
        SetIterator.prototype = {
          isSetIterator: true,
          next: function next() {
            if (!this.isSetIterator) {
              throw new TypeError('Not a SetIterator');
            }
            return this.it.next();
          }
        };
        addIterator(SetIterator.prototype);

        return SetShim;
      }())
    };

    var isGoogleTranslate = globals.Set && !Set.prototype['delete'] && Set.prototype.remove && Set.prototype.items && Set.prototype.map && Array.isArray(new Set().keys);
    if (isGoogleTranslate) {
      // special-case force removal of wildly invalid Set implementation in Google Translate iframes
      // see https://github.com/paulmillr/es6-shim/issues/438 / https://twitter.com/ljharb/status/849335573114363904
      globals.Set = collectionShims.Set;
    }
    if (globals.Map || globals.Set) {
      // Safari 8, for example, doesn't accept an iterable.
      var mapAcceptsArguments = valueOrFalseIfThrows(function () { return new Map([[1, 2]]).get(1) === 2; });
      if (!mapAcceptsArguments) {
        globals.Map = function Map() {
          if (!(this instanceof Map)) {
            throw new TypeError('Constructor Map requires "new"');
          }
          var m = new OrigMap();
          if (arguments.length > 0) {
            addIterableToMap(Map, m, arguments[0]);
          }
          delete m.constructor;
          Object.setPrototypeOf(m, globals.Map.prototype);
          return m;
        };
        globals.Map.prototype = create(OrigMap.prototype);
        defineProperty(globals.Map.prototype, 'constructor', globals.Map, true);
        Value.preserveToString(globals.Map, OrigMap);
      }
      var testMap = new Map();
      var mapUsesSameValueZero = (function () {
        // Chrome 38-42, node 0.11/0.12, iojs 1/2 also have a bug when the Map has a size > 4
        var m = new Map([[1, 0], [2, 0], [3, 0], [4, 0]]);
        m.set(-0, m);
        return m.get(0) === m && m.get(-0) === m && m.has(0) && m.has(-0);
      }());
      var mapSupportsChaining = testMap.set(1, 2) === testMap;
      if (!mapUsesSameValueZero || !mapSupportsChaining) {
        overrideNative(Map.prototype, 'set', function set(k, v) {
          _call(origMapSet, this, k === 0 ? 0 : k, v);
          return this;
        });
      }
      if (!mapUsesSameValueZero) {
        defineProperties(Map.prototype, {
          get: function get(k) {
            return _call(origMapGet, this, k === 0 ? 0 : k);
          },
          has: function has(k) {
            return _call(origMapHas, this, k === 0 ? 0 : k);
          }
        }, true);
        Value.preserveToString(Map.prototype.get, origMapGet);
        Value.preserveToString(Map.prototype.has, origMapHas);
      }
      var testSet = new Set();
      var setUsesSameValueZero = Set.prototype['delete'] && Set.prototype.add && Set.prototype.has && (function (s) {
        s['delete'](0);
        s.add(-0);
        return !s.has(0);
      }(testSet));
      var setSupportsChaining = testSet.add(1) === testSet;
      if (!setUsesSameValueZero || !setSupportsChaining) {
        var origSetAdd = Set.prototype.add;
        Set.prototype.add = function add(v) {
          _call(origSetAdd, this, v === 0 ? 0 : v);
          return this;
        };
        Value.preserveToString(Set.prototype.add, origSetAdd);
      }
      if (!setUsesSameValueZero) {
        var origSetHas = Set.prototype.has;
        Set.prototype.has = function has(v) {
          return _call(origSetHas, this, v === 0 ? 0 : v);
        };
        Value.preserveToString(Set.prototype.has, origSetHas);
        var origSetDel = Set.prototype['delete'];
        Set.prototype['delete'] = function SetDelete(v) {
          return _call(origSetDel, this, v === 0 ? 0 : v);
        };
        Value.preserveToString(Set.prototype['delete'], origSetDel);
      }
      var mapSupportsSubclassing = supportsSubclassing(globals.Map, function (M) {
        var m = new M([]);
        // Firefox 32 is ok with the instantiating the subclass but will
        // throw when the map is used.
        m.set(42, 42);
        return m instanceof M;
      });
      // without Object.setPrototypeOf, subclassing is not possible
      var mapFailsToSupportSubclassing = Object.setPrototypeOf && !mapSupportsSubclassing;
      var mapRequiresNew = (function () {
        try {
          return !(globals.Map() instanceof globals.Map);
        } catch (e) {
          return e instanceof TypeError;
        }
      }());
      if (globals.Map.length !== 0 || mapFailsToSupportSubclassing || !mapRequiresNew) {
        globals.Map = function Map() {
          if (!(this instanceof Map)) {
            throw new TypeError('Constructor Map requires "new"');
          }
          var m = new OrigMap();
          if (arguments.length > 0) {
            addIterableToMap(Map, m, arguments[0]);
          }
          delete m.constructor;
          Object.setPrototypeOf(m, Map.prototype);
          return m;
        };
        globals.Map.prototype = OrigMap.prototype;
        defineProperty(globals.Map.prototype, 'constructor', globals.Map, true);
        Value.preserveToString(globals.Map, OrigMap);
      }
      var setSupportsSubclassing = supportsSubclassing(globals.Set, function (S) {
        var s = new S([]);
        s.add(42, 42);
        return s instanceof S;
      });
      // without Object.setPrototypeOf, subclassing is not possible
      var setFailsToSupportSubclassing = Object.setPrototypeOf && !setSupportsSubclassing;
      var setRequiresNew = (function () {
        try {
          return !(globals.Set() instanceof globals.Set);
        } catch (e) {
          return e instanceof TypeError;
        }
      }());
      if (globals.Set.length !== 0 || setFailsToSupportSubclassing || !setRequiresNew) {
        var OrigSet = globals.Set;
        globals.Set = function Set() {
          if (!(this instanceof Set)) {
            throw new TypeError('Constructor Set requires "new"');
          }
          var s = new OrigSet();
          if (arguments.length > 0) {
            addIterableToSet(Set, s, arguments[0]);
          }
          delete s.constructor;
          Object.setPrototypeOf(s, Set.prototype);
          return s;
        };
        globals.Set.prototype = OrigSet.prototype;
        defineProperty(globals.Set.prototype, 'constructor', globals.Set, true);
        Value.preserveToString(globals.Set, OrigSet);
      }
      var newMap = new globals.Map();
      var mapIterationThrowsStopIterator = !valueOrFalseIfThrows(function () {
        return newMap.keys().next().done;
      });
      /*
        - In Firefox < 23, Map#size is a function.
        - In all current Firefox, Set#entries/keys/values & Map#clear do not exist
        - https://bugzilla.mozilla.org/show_bug.cgi?id=869996
        - In Firefox 24, Map and Set do not implement forEach
        - In Firefox 25 at least, Map and Set are callable without "new"
      */
      if (
        typeof globals.Map.prototype.clear !== 'function' ||
        new globals.Set().size !== 0 ||
        newMap.size !== 0 ||
        typeof globals.Map.prototype.keys !== 'function' ||
        typeof globals.Set.prototype.keys !== 'function' ||
        typeof globals.Map.prototype.forEach !== 'function' ||
        typeof globals.Set.prototype.forEach !== 'function' ||
        isCallableWithoutNew(globals.Map) ||
        isCallableWithoutNew(globals.Set) ||
        typeof newMap.keys().next !== 'function' || // Safari 8
        mapIterationThrowsStopIterator || // Firefox 25
        !mapSupportsSubclassing
      ) {
        defineProperties(globals, {
          Map: collectionShims.Map,
          Set: collectionShims.Set
        }, true);
      }

      if (globals.Set.prototype.keys !== globals.Set.prototype.values) {
        // Fixed in WebKit with https://bugs.webkit.org/show_bug.cgi?id=144190
        defineProperty(globals.Set.prototype, 'keys', globals.Set.prototype.values, true);
      }

      // Shim incomplete iterator implementations.
      addIterator(Object.getPrototypeOf((new globals.Map()).keys()));
      addIterator(Object.getPrototypeOf((new globals.Set()).keys()));

      if (functionsHaveNames && globals.Set.prototype.has.name !== 'has') {
        // Microsoft Edge v0.11.10074.0 is missing a name on Set#has
        var anonymousSetHas = globals.Set.prototype.has;
        overrideNative(globals.Set.prototype, 'has', function has(key) {
          return _call(anonymousSetHas, this, key);
        });
      }
    }
    defineProperties(globals, collectionShims);
    addDefaultSpecies(globals.Map);
    addDefaultSpecies(globals.Set);
  }

  var throwUnlessTargetIsObject = function throwUnlessTargetIsObject(target) {
    if (!ES.TypeIsObject(target)) {
      throw new TypeError('target must be an object');
    }
  };

  // Some Reflect methods are basically the same as
  // those on the Object global, except that a TypeError is thrown if
  // target isn't an object. As well as returning a boolean indicating
  // the success of the operation.
  var ReflectShims = {
    // Apply method in a functional form.
    apply: function apply() {
      return ES.Call(ES.Call, null, arguments);
    },

    // New operator in a functional form.
    construct: function construct(constructor, args) {
      if (!ES.IsConstructor(constructor)) {
        throw new TypeError('First argument must be a constructor.');
      }
      var newTarget = arguments.length > 2 ? arguments[2] : constructor;
      if (!ES.IsConstructor(newTarget)) {
        throw new TypeError('new.target must be a constructor.');
      }
      return ES.Construct(constructor, args, newTarget, 'internal');
    },

    // When deleting a non-existent or configurable property,
    // true is returned.
    // When attempting to delete a non-configurable property,
    // it will return false.
    deleteProperty: function deleteProperty(target, key) {
      throwUnlessTargetIsObject(target);
      if (supportsDescriptors) {
        var desc = Object.getOwnPropertyDescriptor(target, key);

        if (desc && !desc.configurable) {
          return false;
        }
      }

      // Will return true.
      return delete target[key];
    },

    has: function has(target, key) {
      throwUnlessTargetIsObject(target);
      return key in target;
    }
  };

  if (Object.getOwnPropertyNames) {
    Object.assign(ReflectShims, {
      // Basically the result of calling the internal [[OwnPropertyKeys]].
      // Concatenating propertyNames and propertySymbols should do the trick.
      // This should continue to work together with a Symbol shim
      // which overrides Object.getOwnPropertyNames and implements
      // Object.getOwnPropertySymbols.
      ownKeys: function ownKeys(target) {
        throwUnlessTargetIsObject(target);
        var keys = Object.getOwnPropertyNames(target);

        if (ES.IsCallable(Object.getOwnPropertySymbols)) {
          _pushApply(keys, Object.getOwnPropertySymbols(target));
        }

        return keys;
      }
    });
  }

  var callAndCatchException = function ConvertExceptionToBoolean(func) {
    return !throwsError(func);
  };

  if (Object.preventExtensions) {
    Object.assign(ReflectShims, {
      isExtensible: function isExtensible(target) {
        throwUnlessTargetIsObject(target);
        return Object.isExtensible(target);
      },
      preventExtensions: function preventExtensions(target) {
        throwUnlessTargetIsObject(target);
        return callAndCatchException(function () {
          return Object.preventExtensions(target);
        });
      }
    });
  }

  if (supportsDescriptors) {
    var internalGet = function get(target, key, receiver) {
      var desc = Object.getOwnPropertyDescriptor(target, key);

      if (!desc) {
        var parent = Object.getPrototypeOf(target);

        if (parent === null) {
          return void 0;
        }

        return internalGet(parent, key, receiver);
      }

      if ('value' in desc) {
        return desc.value;
      }

      if (desc.get) {
        return ES.Call(desc.get, receiver);
      }

      return void 0;
    };

    var internalSet = function set(target, key, value, receiver) {
      var desc = Object.getOwnPropertyDescriptor(target, key);

      if (!desc) {
        var parent = Object.getPrototypeOf(target);

        if (parent !== null) {
          return internalSet(parent, key, value, receiver);
        }

        desc = {
          value: void 0,
          writable: true,
          enumerable: true,
          configurable: true
        };
      }

      if ('value' in desc) {
        if (!desc.writable) {
          return false;
        }

        if (!ES.TypeIsObject(receiver)) {
          return false;
        }

        var existingDesc = Object.getOwnPropertyDescriptor(receiver, key);

        if (existingDesc) {
          return Reflect.defineProperty(receiver, key, {
            value: value
          });
        } else {
          return Reflect.defineProperty(receiver, key, {
            value: value,
            writable: true,
            enumerable: true,
            configurable: true
          });
        }
      }

      if (desc.set) {
        _call(desc.set, receiver, value);
        return true;
      }

      return false;
    };

    Object.assign(ReflectShims, {
      defineProperty: function defineProperty(target, propertyKey, attributes) {
        throwUnlessTargetIsObject(target);
        return callAndCatchException(function () {
          return Object.defineProperty(target, propertyKey, attributes);
        });
      },

      getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
        throwUnlessTargetIsObject(target);
        return Object.getOwnPropertyDescriptor(target, propertyKey);
      },

      // Syntax in a functional form.
      get: function get(target, key) {
        throwUnlessTargetIsObject(target);
        var receiver = arguments.length > 2 ? arguments[2] : target;

        return internalGet(target, key, receiver);
      },

      set: function set(target, key, value) {
        throwUnlessTargetIsObject(target);
        var receiver = arguments.length > 3 ? arguments[3] : target;

        return internalSet(target, key, value, receiver);
      }
    });
  }

  if (Object.getPrototypeOf) {
    var objectDotGetPrototypeOf = Object.getPrototypeOf;
    ReflectShims.getPrototypeOf = function getPrototypeOf(target) {
      throwUnlessTargetIsObject(target);
      return objectDotGetPrototypeOf(target);
    };
  }

  if (Object.setPrototypeOf && ReflectShims.getPrototypeOf) {
    var willCreateCircularPrototype = function (object, lastProto) {
      var proto = lastProto;
      while (proto) {
        if (object === proto) {
          return true;
        }
        proto = ReflectShims.getPrototypeOf(proto);
      }
      return false;
    };

    Object.assign(ReflectShims, {
      // Sets the prototype of the given object.
      // Returns true on success, otherwise false.
      setPrototypeOf: function setPrototypeOf(object, proto) {
        throwUnlessTargetIsObject(object);
        if (proto !== null && !ES.TypeIsObject(proto)) {
          throw new TypeError('proto must be an object or null');
        }

        // If they already are the same, we're done.
        if (proto === Reflect.getPrototypeOf(object)) {
          return true;
        }

        // Cannot alter prototype if object not extensible.
        if (Reflect.isExtensible && !Reflect.isExtensible(object)) {
          return false;
        }

        // Ensure that we do not create a circular prototype chain.
        if (willCreateCircularPrototype(object, proto)) {
          return false;
        }

        Object.setPrototypeOf(object, proto);

        return true;
      }
    });
  }
  var defineOrOverrideReflectProperty = function (key, shim) {
    if (!ES.IsCallable(globals.Reflect[key])) {
      defineProperty(globals.Reflect, key, shim);
    } else {
      var acceptsPrimitives = valueOrFalseIfThrows(function () {
        globals.Reflect[key](1);
        globals.Reflect[key](NaN);
        globals.Reflect[key](true);
        return true;
      });
      if (acceptsPrimitives) {
        overrideNative(globals.Reflect, key, shim);
      }
    }
  };
  Object.keys(ReflectShims).forEach(function (key) {
    defineOrOverrideReflectProperty(key, ReflectShims[key]);
  });
  var originalReflectGetProto = globals.Reflect.getPrototypeOf;
  if (functionsHaveNames && originalReflectGetProto && originalReflectGetProto.name !== 'getPrototypeOf') {
    overrideNative(globals.Reflect, 'getPrototypeOf', function getPrototypeOf(target) {
      return _call(originalReflectGetProto, globals.Reflect, target);
    });
  }
  if (globals.Reflect.setPrototypeOf) {
    if (valueOrFalseIfThrows(function () {
      globals.Reflect.setPrototypeOf(1, {});
      return true;
    })) {
      overrideNative(globals.Reflect, 'setPrototypeOf', ReflectShims.setPrototypeOf);
    }
  }
  if (globals.Reflect.defineProperty) {
    if (!valueOrFalseIfThrows(function () {
      var basic = !globals.Reflect.defineProperty(1, 'test', { value: 1 });
      // "extensible" fails on Edge 0.12
      var extensible = typeof Object.preventExtensions !== 'function' || !globals.Reflect.defineProperty(Object.preventExtensions({}), 'test', {});
      return basic && extensible;
    })) {
      overrideNative(globals.Reflect, 'defineProperty', ReflectShims.defineProperty);
    }
  }
  if (globals.Reflect.construct) {
    if (!valueOrFalseIfThrows(function () {
      var F = function F() {};
      return globals.Reflect.construct(function () {}, [], F) instanceof F;
    })) {
      overrideNative(globals.Reflect, 'construct', ReflectShims.construct);
    }
  }

  if (String(new Date(NaN)) !== 'Invalid Date') {
    var dateToString = Date.prototype.toString;
    var shimmedDateToString = function toString() {
      var valueOf = +this;
      if (valueOf !== valueOf) {
        return 'Invalid Date';
      }
      return ES.Call(dateToString, this);
    };
    overrideNative(Date.prototype, 'toString', shimmedDateToString);
  }

  // Annex B HTML methods
  // http://www.ecma-international.org/ecma-262/6.0/#sec-additional-properties-of-the-string.prototype-object
  var stringHTMLshims = {
    anchor: function anchor(name) { return ES.CreateHTML(this, 'a', 'name', name); },
    big: function big() { return ES.CreateHTML(this, 'big', '', ''); },
    blink: function blink() { return ES.CreateHTML(this, 'blink', '', ''); },
    bold: function bold() { return ES.CreateHTML(this, 'b', '', ''); },
    fixed: function fixed() { return ES.CreateHTML(this, 'tt', '', ''); },
    fontcolor: function fontcolor(color) { return ES.CreateHTML(this, 'font', 'color', color); },
    fontsize: function fontsize(size) { return ES.CreateHTML(this, 'font', 'size', size); },
    italics: function italics() { return ES.CreateHTML(this, 'i', '', ''); },
    link: function link(url) { return ES.CreateHTML(this, 'a', 'href', url); },
    small: function small() { return ES.CreateHTML(this, 'small', '', ''); },
    strike: function strike() { return ES.CreateHTML(this, 'strike', '', ''); },
    sub: function sub() { return ES.CreateHTML(this, 'sub', '', ''); },
    sup: function sub() { return ES.CreateHTML(this, 'sup', '', ''); }
  };
  _forEach(Object.keys(stringHTMLshims), function (key) {
    var method = String.prototype[key];
    var shouldOverwrite = false;
    if (ES.IsCallable(method)) {
      var output = _call(method, '', ' " ');
      var quotesCount = _concat([], output.match(/"/g)).length;
      shouldOverwrite = output !== output.toLowerCase() || quotesCount > 2;
    } else {
      shouldOverwrite = true;
    }
    if (shouldOverwrite) {
      overrideNative(String.prototype, key, stringHTMLshims[key]);
    }
  });

  var JSONstringifiesSymbols = (function () {
    // Microsoft Edge v0.12 stringifies Symbols incorrectly
    if (!hasSymbols) { return false; } // Symbols are not supported
    var stringify = typeof JSON === 'object' && typeof JSON.stringify === 'function' ? JSON.stringify : null;
    if (!stringify) { return false; } // JSON.stringify is not supported
    if (typeof stringify(Symbol()) !== 'undefined') { return true; } // Symbols should become `undefined`
    if (stringify([Symbol()]) !== '[null]') { return true; } // Symbols in arrays should become `null`
    var obj = { a: Symbol() };
    obj[Symbol()] = true;
    if (stringify(obj) !== '{}') { return true; } // Symbol-valued keys *and* Symbol-valued properties should be omitted
    return false;
  }());
  var JSONstringifyAcceptsObjectSymbol = valueOrFalseIfThrows(function () {
    // Chrome 45 throws on stringifying object symbols
    if (!hasSymbols) { return true; } // Symbols are not supported
    return JSON.stringify(Object(Symbol())) === '{}' && JSON.stringify([Object(Symbol())]) === '[{}]';
  });
  if (JSONstringifiesSymbols || !JSONstringifyAcceptsObjectSymbol) {
    var origStringify = JSON.stringify;
    overrideNative(JSON, 'stringify', function stringify(value) {
      if (typeof value === 'symbol') { return; }
      var replacer;
      if (arguments.length > 1) {
        replacer = arguments[1];
      }
      var args = [value];
      if (!isArray(replacer)) {
        var replaceFn = ES.IsCallable(replacer) ? replacer : null;
        var wrappedReplacer = function (key, val) {
          var parsedValue = replaceFn ? _call(replaceFn, this, key, val) : val;
          if (typeof parsedValue !== 'symbol') {
            if (Type.symbol(parsedValue)) {
              return assignTo({})(parsedValue);
            } else {
              return parsedValue;
            }
          }
        };
        args.push(wrappedReplacer);
      } else {
        // create wrapped replacer that handles an array replacer?
        args.push(replacer);
      }
      if (arguments.length > 2) {
        args.push(arguments[2]);
      }
      return origStringify.apply(this, args);
    });
  }

  return globals;
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(8)))

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(78);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 213:
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(217);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(218);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(93),
    isSymbol = __webpack_require__(64);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["create"] = create;
/* harmony export (immutable) */ __webpack_exports__["reportAppLoadStarted"] = reportAppLoadStarted;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "phasesConfig", function() { return phasesConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wix_fedops_presets__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conf__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reporter_reporter_factory__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_logger__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_app_data_global_app_data__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__session_manager_session_manager__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__performance_performance__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loading_phases_loading_phases_config__ = __webpack_require__(128);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











function getAppVersion() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__env__["a" /* env */])().__CI_APP_VERSION__ || __WEBPACK_IMPORTED_MODULE_2__conf__["a" /* DEFAULT_APP_VERSION */];
}
/*
 * @param baseUrl
 * @param appId
 * @param disableAutoLoadFinish
 * @param interactionTimeout
 * @param timeoutHook
 * @param startHook
 * @param endHook
 * @param biLoggerFactory
 * @param endpoint
 * @param endpoint artifactData
 */


function create(appName, params) {
  if (params === void 0) {
    params = {};
  }

  if (!appName) {
    return null;
  }

  var appNameWithoutDots = appName.replace(/\./g, '-');
  Object(__WEBPACK_IMPORTED_MODULE_5__global_app_data_global_app_data__["b" /* initializeGlobal */])(appNameWithoutDots);

  var fullParams = _objectSpread(_objectSpread({}, params), {}, {
    preset: Object(__WEBPACK_IMPORTED_MODULE_0__wix_fedops_presets__["a" /* presetLoader */])(params.presetType)
  });

  var reporter = Object(__WEBPACK_IMPORTED_MODULE_3__reporter_reporter_factory__["a" /* create */])(fullParams);
  return new __WEBPACK_IMPORTED_MODULE_4__base_logger__["a" /* default */](appNameWithoutDots, getAppVersion(), reporter, fullParams);
}
/**
 * Report application started loading
 * @param {string} appName Application/Dashboard name
 * @param {{artifactData}} artifact data
 */

function reportAppLoadStarted(appName, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      artifactData = _ref.artifactData,
      presetType = _ref.presetType,
      isPersistent = _ref.isPersistent,
      paramsOverrides = _ref.paramsOverrides;

  Object(__WEBPACK_IMPORTED_MODULE_5__global_app_data_global_app_data__["b" /* initializeGlobal */])(appName);
  Object(__WEBPACK_IMPORTED_MODULE_5__global_app_data_global_app_data__["c" /* setLoadStartTime */])(appName, __WEBPACK_IMPORTED_MODULE_7__performance_performance__["a" /* default */].responseEndTime() || __WEBPACK_IMPORTED_MODULE_7__performance_performance__["a" /* default */].now());
  var sessionId = __WEBPACK_IMPORTED_MODULE_6__session_manager_session_manager__["a" /* default */].getSessionId();
  Object(__WEBPACK_IMPORTED_MODULE_5__global_app_data_global_app_data__["d" /* setSessionId */])(sessionId);
  var preset = Object(__WEBPACK_IMPORTED_MODULE_0__wix_fedops_presets__["a" /* presetLoader */])(presetType);
  var endpoint = isPersistent === true ? preset.persistentEndpoint : preset.nonPersistentEndpoint;
  var urlSearchParams = new URLSearchParams();
  urlSearchParams.set('appName', appName);
  urlSearchParams.set('src', preset.src);
  urlSearchParams.set('evid', preset.appLoadStart.eventId);
  urlSearchParams.set('session_id', sessionId);
  urlSearchParams.set('_', Math.random());

  if (artifactData) {
    urlSearchParams.set('artifactId', artifactData.id);
    urlSearchParams.set('artifactVersion', artifactData.version);
    urlSearchParams.set('isRollout', artifactData.isRollout);
  }

  Object.keys(paramsOverrides || {}).forEach(function (x) {
    return urlSearchParams.set(x, paramsOverrides[x]);
  });
  var url = "//frog.wix.com/" + endpoint + "?" + urlSearchParams.toString();

  if (Object(__WEBPACK_IMPORTED_MODULE_1__env__["b" /* hasSendBeacon */])()) {
    Object(__WEBPACK_IMPORTED_MODULE_1__env__["c" /* sendBeacon */])(url);
  } else {
    new Image().src = url;
  }
}
var phasesConfig = __WEBPACK_IMPORTED_MODULE_8__loading_phases_loading_phases_config__["a" /* phasesConfigValues */];

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = presetLoader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__presets_default_json__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__presets_default_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__presets_default_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__presets_ds_json__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__presets_ds_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__presets_ds_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__presets_editor_json__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__presets_editor_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__presets_editor_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__presets_bolt_json__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__presets_bolt_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__presets_bolt_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__presets_ooi_json__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__presets_ooi_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__presets_ooi_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__presets_mobile_json__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__presets_mobile_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__presets_mobile_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__presets_presets_types__ = __webpack_require__(121);







function presetLoader(presetType) {
    switch (presetType) {
        case __WEBPACK_IMPORTED_MODULE_6__presets_presets_types__["a" /* presetsTypes */].DEFAULT:
            return __WEBPACK_IMPORTED_MODULE_0__presets_default_json___default.a;
        case __WEBPACK_IMPORTED_MODULE_6__presets_presets_types__["a" /* presetsTypes */].BOLT:
            return __WEBPACK_IMPORTED_MODULE_3__presets_bolt_json___default.a;
        case __WEBPACK_IMPORTED_MODULE_6__presets_presets_types__["a" /* presetsTypes */].DS:
            return __WEBPACK_IMPORTED_MODULE_1__presets_ds_json___default.a;
        case __WEBPACK_IMPORTED_MODULE_6__presets_presets_types__["a" /* presetsTypes */].EDITOR:
            return __WEBPACK_IMPORTED_MODULE_2__presets_editor_json___default.a;
        case __WEBPACK_IMPORTED_MODULE_6__presets_presets_types__["a" /* presetsTypes */].OOI:
            return __WEBPACK_IMPORTED_MODULE_4__presets_ooi_json___default.a;
        case __WEBPACK_IMPORTED_MODULE_6__presets_presets_types__["a" /* presetsTypes */].MOBILE:
            return __WEBPACK_IMPORTED_MODULE_5__presets_mobile_json___default.a;
        default:
            return __WEBPACK_IMPORTED_MODULE_0__presets_default_json___default.a;
    }
}
//# sourceMappingURL=loader.js.map

/***/ }),

/***/ 229:
/***/ (function(module, exports) {

module.exports = {"src":72,"persistentEndpoint":"performance","nonPersistentEndpoint":"fed","successRateRoot":"fedops_events","performanceRoot":"fedops_performance","appLoadStart":{"eventId":14},"appLoadFinish":{"eventId":11},"loadPhaseStart":{"eventId":12},"loadPhaseFinish":{"eventId":13},"interactionStart":{"eventId":15},"interactionEnd":{"eventId":16},"error":{"eventId":17},"resource":{"eventId":18}}

/***/ }),

/***/ 230:
/***/ (function(module, exports) {

module.exports = {"src":72,"persistentEndpoint":"ds-performance","nonPersistentEndpoint":"ds-performance","successRateRoot":"ds_events","performanceRoot":"ds_performance","appLoadStart":{"eventId":31},"appLoadFinish":{"eventId":33},"interactionStart":{"eventId":34},"interactionEnd":{"eventId":35},"loadPhaseStart":{"eventId":38},"loadPhaseFinish":{"eventId":32},"error":{"eventId":36},"resource":{"eventId":37}}

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

module.exports = {"src":72,"persistentEndpoint":"editor-performance","nonPersistentEndpoint":"editor-performance","successRateRoot":"editor_events","performanceRoot":"editor_performance","appLoadStart":{"eventId":41},"appLoadFinish":{"eventId":43},"interactionStart":{"eventId":44},"interactionEnd":{"eventId":45},"loadPhaseStart":{"eventId":48},"loadPhaseFinish":{"eventId":42},"error":{"eventId":46},"resource":{"eventId":47}}

/***/ }),

/***/ 232:
/***/ (function(module, exports) {

module.exports = {"src":72,"persistentEndpoint":"bolt-performance","nonPersistentEndpoint":"bolt-performance","successRateRoot":"bolt_events","performanceRoot":"bolt_performance","appLoadStart":{"eventId":21},"loadPhaseStart":{"eventId":28},"loadPhaseFinish":{"eventId":22},"appLoadFinish":{"eventId":23},"interactionStart":{"eventId":24},"interactionEnd":{"eventId":25},"error":{"eventId":26},"resource":{"eventId":27}}

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

module.exports = {"src":72,"persistentEndpoint":"ooi-performance","nonPersistentEndpoint":"ooi-performance","successRateRoot":"fedops_events","performanceRoot":"fedops_performance","appLoadStart":{"eventId":61},"appLoadFinish":{"eventId":63},"interactionStart":{"eventId":64},"interactionEnd":{"eventId":65},"loadPhaseStart":{"eventId":68},"loadPhaseFinish":{"eventId":62},"error":{"eventId":66},"resource":{"eventId":67}}

/***/ }),

/***/ 234:
/***/ (function(module, exports) {

module.exports = {"src":72,"persistentEndpoint":"mobile-performance","nonPersistentEndpoint":"mobile-performance","successRateRoot":"fedops_events","performanceRoot":"fedops_performance","appLoadStart":{"eventId":51},"appLoadFinish":{"eventId":53},"interactionStart":{"eventId":54},"interactionEnd":{"eventId":55},"loadPhaseStart":{"eventId":58},"loadPhaseFinish":{"eventId":52},"error":{"eventId":56},"resource":{"eventId":57}}

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Reporter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wix_web_bi_logger_dist_src_logger__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wix_web_bi_logger_dist_src_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__wix_web_bi_logger_dist_src_logger__);


var Reporter = /*#__PURE__*/function () {
  function Reporter(_ref) {
    var _this = this;

    var biLoggerFactory = _ref.biLoggerFactory,
        baseUrl = _ref.baseUrl,
        preset = _ref.preset,
        useBatch = _ref.useBatch;
    this._preset = preset;
    this._loggers = [];
    var shouldBatch = !(useBatch === false);
    this._factory = biLoggerFactory || __WEBPACK_IMPORTED_MODULE_0__wix_web_bi_logger_dist_src_logger__["factory"]({
      host: baseUrl,
      useBatch: shouldBatch
    });
    __WEBPACK_IMPORTED_MODULE_0__wix_web_bi_logger_dist_src_logger__["manager"].onLoggerCreated(function (logger) {
      return _this._loggers.push(logger);
    });
    this._publisher = this._factory.logger();
  }

  var _proto = Reporter.prototype;

  _proto.flush = function flush() {
    this._loggers.forEach(function (logger) {
      return logger.flush();
    });
  };

  _proto.report = function report(data, reporterEndpoint) {
    if (!data) {
      return null;
    }

    var endpoint = reporterEndpoint || this._preset.nonPersistentEndpoint;
    return this._publisher.log(data, {
      endpoint: endpoint,
      category: 'essential'
    });
  };

  return Reporter;
}();



/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseLogger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wix_fedops_presets__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wix_consent_policy_client_accessor__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__env__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__performance_performance__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__times_times__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_source_data_source__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__session_manager_session_manager__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loading_phases_loading_phases__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reporter_reporter_factory__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_items_data_items__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loading_phases_loading_phases_config__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(127);
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }














var callHook = function callHook(hook, hookArgs) {
  if (hook) {
    return hook(hookArgs);
  }
};
/**
 * Base Logger
 * Before adding new parameters to the reported events, please make sure the BI schema supports them:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */


var BaseLogger = /*#__PURE__*/function () {
  function BaseLogger(appName, appVersion, reporter, params) {
    var defaultParams = {
      appId: null,
      widgetId: null,
      metasiteId: null,
      sessionId: __WEBPACK_IMPORTED_MODULE_6__session_manager_session_manager__["a" /* default */].getSessionId(),
      isServerSide: null,
      disableAutoLoadFinish: false,
      phasesConfig: __WEBPACK_IMPORTED_MODULE_10__loading_phases_loading_phases_config__["a" /* phasesConfigValues */].SEND_ON_START,
      interactionTimeout: null,
      timeoutHook: null,
      startHook: null,
      endHook: null,
      isPersistent: false,
      corrId: Object(__WEBPACK_IMPORTED_MODULE_11__utils__["a" /* generateGuid */])(),
      presetType: __WEBPACK_IMPORTED_MODULE_0__wix_fedops_presets__["b" /* presetsTypes */].DEFAULT,
      customParams: {},
      paramsOverrides: {}
    };
    var paramsWithDefaults = Object.assign({}, defaultParams, params);
    this.appName = appName;
    this.appVersion = appVersion;
    this.appId = paramsWithDefaults.appId;
    this.widgetId = paramsWithDefaults.widgetId;
    this.metasiteId = paramsWithDefaults.metasiteId;
    this.corrId = paramsWithDefaults.corrId;
    this.isServerSide = paramsWithDefaults.isServerSide;
    this.params = {
      sessionId: paramsWithDefaults.sessionId
    };
    this._customParams = Object.assign({}, paramsWithDefaults.customParams);
    this.disableAutoLoadFinish = paramsWithDefaults.disableAutoLoadFinish;
    this.phasesConfig = paramsWithDefaults.phasesConfig;
    this._appLoadedCalled = {};
    this._appStartLoadCalled = {};
    this._presetType = paramsWithDefaults.presetType;
    this._preset = Object(__WEBPACK_IMPORTED_MODULE_0__wix_fedops_presets__["a" /* presetLoader */])(this._presetType);
    this.dataItems = new __WEBPACK_IMPORTED_MODULE_9__data_items_data_items__["a" /* DataItems */](this.sessionId, this._preset);
    this.reporter = reporter || Object(__WEBPACK_IMPORTED_MODULE_8__reporter_reporter_factory__["a" /* create */])({
      preset: this._preset
    });
    this.times = new __WEBPACK_IMPORTED_MODULE_4__times_times__["a" /* default */](appName);
    this.loadingPhases = new __WEBPACK_IMPORTED_MODULE_7__loading_phases_loading_phases__["b" /* default */](appName, this.times);
    this.dataSourceBase = new __WEBPACK_IMPORTED_MODULE_5__data_source_data_source__["a" /* default */]();
    this.dataSourceBase.addItem(this.dataItems.appName({
      appName: appName,
      isServerSide: this.isServerSide
    })).addItem(this.dataItems.dataItem({
      corrId: this.corrId
    })).addItem(this.dataItems.dataItem(paramsWithDefaults.paramsOverrides));

    if (params && params.artifactData) {
      this.dataSourceBase.addItem(this.dataItems.artifact(params.artifactData));
    }

    this._outgoingInteractions = {};
    this.interactionTimeout = paramsWithDefaults.interactionTimeout;
    this.timeoutHook = paramsWithDefaults.timeoutHook;
    this.startHook = paramsWithDefaults.startHook;
    this.endHook = paramsWithDefaults.endHook;
    this.isPersistent = paramsWithDefaults.isPersistent;

    if (paramsWithDefaults.reportBlackbox) {
      this._handleBlackboxPerformance();
    }
  }

  var _proto = BaseLogger.prototype;

  _proto._report = function _report(dataSource, reporterEndpoint) {
    return this.reporter.report(dataSource.mergeItems(), reporterEndpoint);
  };

  _proto.getAppName = function getAppName() {
    return this.appName;
  };

  _proto.getAppVersion = function getAppVersion() {
    return this.appVersion;
  };

  _proto.getReporter = function getReporter() {
    return this.reporter;
  };

  _proto.getParam = function getParam(paramName) {
    return this.params[paramName];
  };

  _proto._isDisableAutoLoadFinish = function _isDisableAutoLoadFinish() {
    return this.disableAutoLoadFinish;
  };

  _proto.isDisableAutoLoadFinish = function isDisableAutoLoadFinish() {
    return this._isDisableAutoLoadFinish();
  };

  _proto.reportNetworkAnalysis = function reportNetworkAnalysis(_ref) {
    var _this = this;

    var appId = _ref.appId;
    var resources = __WEBPACK_IMPORTED_MODULE_3__performance_performance__["a" /* default */].getResources();
    setTimeout(function () {
      try {
        var resourceDataItem = _this.dataItems.resource();

        var analysis = resourceDataItem.performNetworkAnalysis(resources);

        if (!analysis) {
          return;
        }

        var dataSource = _this.dataSource.addItem(resourceDataItem).addItem(analysis);

        if (appId) {
          _this._changeAppNameForEvent(dataSource, appId);
        }

        _this._report(dataSource);
      } catch (e) {
        console.error('[fedops] Failed to report resource metrics', e);
      }
    }, 1000);
  }
  /**
   * Manual report for widget load start - Should only be used if your widget doesn't have its own .vm / .ejs file
   * Call this method at the earliest point possible when your widget starts loading.
   */
  ;

  _proto.appLoadStarted = function appLoadStarted(_temp) {
    var _ref2 = _temp === void 0 ? {} : _temp,
        appId = _ref2.appId,
        paramsOverrides = _ref2.paramsOverrides;

    if (appId && this._appStartLoadCalled[appId] || !appId && this._appStartLoadCalled[this.appName]) {
      return;
    }

    BaseLogger._markAppLoadStarted(this.appName);

    this._appStartLoadCalled[appId || this.appName] = true;
    this.times.setLoadStarted({
      appId: appId
    });
    var dataSource = this.dataSource.addItem(this.dataItems.biAppLoadStart()).addItem(this.dataItems.appContext({
      appId: appId || this.appId,
      widgetId: this.widgetId,
      isServerSide: this.isServerSide
    })).addItem(this.dataItems.dataItem(paramsOverrides));

    if (appId) {
      this._changeAppNameForEvent(dataSource, appId);
    }

    return this._report(dataSource, this._getEndpoint());
  };

  _proto._shouldAddCustomParams = function _shouldAddCustomParams(customParams) {
    var isEmptyObject = function isEmptyObject(obj) {
      return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
    };

    var bothCustomParamsAreEmpty = isEmptyObject(this._customParams) && isEmptyObject(customParams);
    var consentPolicyAccessor = new __WEBPACK_IMPORTED_MODULE_1__wix_consent_policy_client_accessor__["a" /* ConsentPolicyAccessor */]();

    var _consentPolicyAccesso = consentPolicyAccessor.getCurrentConsentPolicy(),
        functional = _consentPolicyAccesso.functional,
        analytics = _consentPolicyAccesso.analytics;

    var consentAllowsCustomParams = functional && analytics;
    return !bothCustomParamsAreEmpty && consentAllowsCustomParams;
  };

  _proto._addCustomParamsToEvent = function _addCustomParamsToEvent(dataSource, customParams) {
    var customParamsObj = typeof customParams === 'string' ? JSON.parse(customParams) : customParams;
    customParams = Object.assign({}, this._customParams, customParamsObj);

    if (Object.keys(customParams).length > 0) {
      var stringifiedCustomParams = JSON.stringify(customParams);
      dataSource.addItem(this.dataItems.customParams(stringifiedCustomParams));
    }
  }
  /**
   * Final phase. Call this method when your application finishes loading and after all custom phases.
   */
  ;

  _proto.appLoaded = function appLoaded(_temp2) {
    var _ref3 = _temp2 === void 0 ? {} : _temp2,
        appId = _ref3.appId,
        customParams = _ref3.customParams,
        paramsOverrides = _ref3.paramsOverrides;

    if (appId && this._appLoadedCalled[appId] || !appId && this._appLoadedCalled[this.appName]) {
      return;
    }

    BaseLogger._clearLoadTimeout();

    BaseLogger._markAndMeasureAppLoad(this.appName);

    this._appLoadedCalled[appId || this.appName] = true;

    this._sendLastAppLoadPhaseIfNeeded();

    this.reportNetworkAnalysis({
      appId: appId
    });
    var dataSource = this.dataSource.addItem(this.dataItems.biAppLoadFinish()).addItem(this.dataItems.appContext({
      appId: appId || this.appId,
      widgetId: this.widgetId,
      isServerSide: this.isServerSide
    })).addItem(this.dataItems.duration(this.times.getAppLoadTime({
      appId: appId
    })).setFirstRequestDuration(this.times.getFirstRequestDuration())).addItem(this.dataItems.dataItem(paramsOverrides));

    if (appId) {
      this._changeAppNameForEvent(dataSource, appId);
    }

    if (this._shouldAddCustomParams(customParams)) {
      this._addCustomParamsToEvent(dataSource, customParams);
    }

    return this._report(dataSource, this._getEndpoint());
  }
  /**
   * Start of an app loading phase, reports end of previous phase if configured
   */
  ;

  _proto.appLoadingPhaseStart = function appLoadingPhaseStart(name, _temp3) {
    var _ref4 = _temp3 === void 0 ? {} : _temp3,
        appId = _ref4.appId,
        widgetId = _ref4.widgetId,
        paramsOverrides = _ref4.paramsOverrides;

    this.loadingPhases.createCodeParsingPhaseIfNotExist({
      appId: appId,
      widgetId: widgetId
    });
    this.loadingPhases.saveLoadingPhase({
      name: name,
      appId: appId,
      widgetId: widgetId
    });

    this._sendPreviousPhaseIfNeeded(name, {
      appId: appId,
      widgetId: widgetId,
      paramsOverrides: paramsOverrides
    });

    __WEBPACK_IMPORTED_MODULE_3__performance_performance__["a" /* default */].mark("[fedops] " + name + " started");
    var dataSource = this.dataSource.addItem(this.dataItems.biLoadPhaseStart()).addItem(this.dataItems.appContext({
      appId: appId,
      widgetId: widgetId
    })).addItem(this.dataItems.loadingPhaseStart({
      name: name
    })).addItem(this.dataItems.dataItem(paramsOverrides));

    if (appId) {
      this._changeAppNameForEvent(dataSource, appId);
    }

    this._report(dataSource, this._getEndpoint());
  };

  _proto._changeAppNameForEvent = function _changeAppNameForEvent(dataSource, appName) {
    dataSource.addItem(this.dataItems.appName({
      appName: appName,
      isServerSide: this.isServerSide
    }));
  };

  _proto._sendPreviousPhaseIfNeeded = function _sendPreviousPhaseIfNeeded(name, _temp4) {
    var _ref5 = _temp4 === void 0 ? {} : _temp4,
        appId = _ref5.appId,
        widgetId = _ref5.widgetId,
        paramsOverrides = _ref5.paramsOverrides;

    var previousPhase = this.loadingPhases.getPhasePreviousTo({
      name: name,
      appId: appId,
      widgetId: widgetId
    });

    if (this.phasesConfig === __WEBPACK_IMPORTED_MODULE_10__loading_phases_loading_phases_config__["a" /* phasesConfigValues */].SEND_ON_START || previousPhase && previousPhase.name === __WEBPACK_IMPORTED_MODULE_7__loading_phases_loading_phases__["a" /* CODE_PARSING_PHASE_NAME */]) {
      __WEBPACK_IMPORTED_MODULE_3__performance_performance__["a" /* default */].mark("[fedops] " + previousPhase.name + " finished");
      var loadingPhaseDataItem = this.dataItems.loadingPhaseFinish(previousPhase);
      var loadingPhaseBiItem = this.dataItems.biLoadPhaseFinish();
      var overridesDataItem = this.dataItems.dataItem(paramsOverrides);
      var dataSource = this.dataSource.addItem(loadingPhaseDataItem).addItem(loadingPhaseBiItem).addItem(overridesDataItem);

      this._report(dataSource);
    }
  }
  /**
   * End of an app loading phase, reports end of previous phase
   */
  ;

  _proto.appLoadingPhaseFinish = function appLoadingPhaseFinish(name, _temp5) {
    var _ref6 = _temp5 === void 0 ? {} : _temp5,
        appId = _ref6.appId,
        widgetId = _ref6.widgetId,
        widgetArray = _ref6.widgetArray,
        paramsOverrides = _ref6.paramsOverrides;

    if (this.phasesConfig === __WEBPACK_IMPORTED_MODULE_10__loading_phases_loading_phases_config__["a" /* phasesConfigValues */].SEND_ON_START) {
      throw new Error('To use appLoadingPhaseFinish you must use "phasesConfig: SEND_START_AND_FINISH" setting');
    }

    __WEBPACK_IMPORTED_MODULE_3__performance_performance__["a" /* default */].mark("[fedops] " + name + " finished");
    var loadingPhase = this.loadingPhases.getAppLoadingPhaseData({
      name: name,
      appId: appId,
      widgetId: widgetId
    });

    if (!loadingPhase) {
      throw new Error("Cannot report end of a phase that wasn't started. Phase " + name + " doesn't exist");
    }

    var loadingPhaseDataItem = this.dataItems.loadingPhaseFinish(loadingPhase);
    var loadingPhaseBiItem = this.dataItems.biLoadPhaseFinish();
    var overridesDataItem = this.dataItems.dataItem(paramsOverrides);
    var eventContextDataItem = this.dataItems.appContext({
      appId: appId,
      widgetId: widgetId,
      widgetArray: widgetArray,
      isServerSide: this.isServerSide
    });
    var dataSource = this.dataSource.addItem(loadingPhaseDataItem).addItem(loadingPhaseBiItem).addItem(eventContextDataItem).addItem(overridesDataItem);

    if (appId) {
      this._changeAppNameForEvent(dataSource, appId);
    }

    return this._report(dataSource, this._getEndpoint());
  };

  _proto._getEndpoint = function _getEndpoint() {
    return this.isPersistent ? this._preset.persistentEndpoint : this._preset.nonPersistentEndpoint;
  } // only for backwards compatibility purposes until we eliminate phasesConfig and SEND_ON_START
  ;

  _proto._sendLastAppLoadPhaseIfNeeded = function _sendLastAppLoadPhaseIfNeeded() {
    var appLoadingPhase = this.loadingPhases.getNextPhaseToReport();
    var shouldReportLastPhase = this.phasesConfig === __WEBPACK_IMPORTED_MODULE_10__loading_phases_loading_phases_config__["a" /* phasesConfigValues */].SEND_ON_START && appLoadingPhase && appLoadingPhase.name !== __WEBPACK_IMPORTED_MODULE_7__loading_phases_loading_phases__["a" /* CODE_PARSING_PHASE_NAME */];

    if (shouldReportLastPhase) {
      this._report(this.dataSource.addItem(this.dataItems.loadingPhaseFinish(appLoadingPhase)).addItem(this.dataItems.biLoadPhaseFinish()));
    }
  };

  BaseLogger._clearLoadTimeout = function _clearLoadTimeout() {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__env__["a" /* env */])() && Object(__WEBPACK_IMPORTED_MODULE_2__env__["a" /* env */])().fedops && typeof Object(__WEBPACK_IMPORTED_MODULE_2__env__["a" /* env */])().fedops.clearLoadTimeout === 'function') {
      Object(__WEBPACK_IMPORTED_MODULE_2__env__["a" /* env */])().fedops.clearLoadTimeout();
    }
  };

  _proto.clearResourceTimings = function clearResourceTimings() {
    __WEBPACK_IMPORTED_MODULE_3__performance_performance__["a" /* default */].clearResourceTimings();
  };

  BaseLogger._markAppLoadStarted = function _markAppLoadStarted(appName) {
    __WEBPACK_IMPORTED_MODULE_3__performance_performance__["a" /* default */].mark("[fedops] " + appName + " app-load-started");
  };

  BaseLogger._markAndMeasureAppLoad = function _markAndMeasureAppLoad(appName) {
    __WEBPACK_IMPORTED_MODULE_3__performance_performance__["a" /* default */].mark("[fedops] " + appName + " app-loaded");

    try {
      __WEBPACK_IMPORTED_MODULE_3__performance_performance__["a" /* default */].measure("[fedops] " + appName + " app-loaded", "[fedops] " + appName + " app-load-started", "[fedops] " + appName + " app-loaded");
    } catch (e) {}
  };

  BaseLogger._markInteractionStarted = function _markInteractionStarted(interactionName) {
    __WEBPACK_IMPORTED_MODULE_3__performance_performance__["a" /* default */].mark("[fedops] " + interactionName + " started");
  };

  BaseLogger._markAndMeasureInteractionEnded = function _markAndMeasureInteractionEnded(interactionName, outgoingInteraction) {
    if (outgoingInteraction) {
      __WEBPACK_IMPORTED_MODULE_3__performance_performance__["a" /* default */].mark("[fedops] " + interactionName + " ended");

      try {
        __WEBPACK_IMPORTED_MODULE_3__performance_performance__["a" /* default */].measure("[fedops] " + interactionName + " duration", "[fedops] " + interactionName + " started", "[fedops] " + interactionName + " ended");
      } catch (e) {}
    }
  }
  /**
   * Custom interaction start (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/)
   */
  ;

  _proto.interactionStarted = function interactionStarted(interactionName, _temp6) {
    var _this2 = this;

    var _ref7 = _temp6 === void 0 ? {} : _temp6,
        timeOverride = _ref7.timeOverride,
        interactionTimeout = _ref7.interactionTimeout,
        startHook = _ref7.startHook,
        timeoutHook = _ref7.timeoutHook,
        customParams = _ref7.customParams,
        paramsOverrides = _ref7.paramsOverrides;

    BaseLogger._markInteractionStarted(interactionName);

    var scheduleTimeoutEvent = function scheduleTimeoutEvent() {
      if (interactionTimeout || _this2.interactionTimeout) {
        return setTimeout(function () {
          var dataSource = _this2.dataSource.addItem({
            interactionName: interactionName
          }).addItem({
            errorType: 'timeout'
          }).addItem(_this2.dataItems.biError());

          _this2._report(dataSource);

          callHook(timeoutHook || _this2.timeoutHook, {
            name: interactionName,
            timeout: interactionTimeout || _this2.interactionTimeout
          });
        }, interactionTimeout || _this2.interactionTimeout);
      }
    };

    var dataSource = this.dataSource.addItem({
      name: interactionName
    }).addItem(this.dataItems.biInteractionStart()).addItem(this.dataItems.dataItem(paramsOverrides));

    if (this._shouldAddCustomParams(customParams)) {
      this._addCustomParamsToEvent(dataSource, customParams);
    }

    this._outgoingInteractions[interactionName] = {
      timestamp: timeOverride ? timeOverride : __WEBPACK_IMPORTED_MODULE_3__performance_performance__["a" /* default */].now(),
      timeout: interactionTimeout || this.interactionTimeout
    };

    this._report(dataSource);

    callHook(startHook || this.startHook, {
      name: interactionName
    });
    var timeoutId = scheduleTimeoutEvent();
    return {
      timeoutId: timeoutId
    };
  }
  /**
   * Custom interaction end (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/)
   */
  ;

  _proto.interactionEnded = function interactionEnded(interactionName, _temp7) {
    var _this3 = this;

    var _ref8 = _temp7 === void 0 ? {} : _temp7,
        timeOverride = _ref8.timeOverride,
        timeoutId = _ref8.timeoutId,
        endHook = _ref8.endHook,
        customParams = _ref8.customParams,
        paramsOverrides = _ref8.paramsOverrides;

    var outgoingInteraction = this._outgoingInteractions[interactionName];

    BaseLogger._markAndMeasureInteractionEnded(interactionName, outgoingInteraction);

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    var getInteractionFromWindowIfPresent = function getInteractionFromWindowIfPresent(actualEnv) {
      return actualEnv.fedops && actualEnv.fedops.apps && actualEnv.fedops.apps[_this3.appName] && actualEnv.fedops.apps[_this3.appName].interactions && actualEnv.fedops.apps[_this3.appName].interactions[interactionName];
    };

    var interaction = this._outgoingInteractions[interactionName] || getInteractionFromWindowIfPresent(Object(__WEBPACK_IMPORTED_MODULE_2__env__["a" /* env */])());
    var endTime = timeOverride ? timeOverride : __WEBPACK_IMPORTED_MODULE_3__performance_performance__["a" /* default */].now();
    var duration = interaction ? Math.floor(endTime - interaction.timestamp) : '';
    callHook(endHook || this.endHook, {
      name: interactionName,
      duration: duration,
      timeout: this._outgoingInteractions[interactionName] && this._outgoingInteractions[interactionName].timeout
    });
    var dataSource = this.dataSource.addItem({
      name: interactionName
    }).addItem({
      duration: duration
    }).addItem(this.dataItems.biInteractionEnd()).addItem(this.dataItems.dataItem(paramsOverrides));

    if (this._shouldAddCustomParams(customParams)) {
      this._addCustomParamsToEvent(dataSource, customParams);
    }

    delete this._outgoingInteractions[interactionName];

    this._report(dataSource);
  };

  _proto.flush = function flush() {
    this.reporter.flush();
  };

  _proto._handleBlackboxPerformance = function _handleBlackboxPerformance() {
    var _this4 = this;

    var _env = Object(__WEBPACK_IMPORTED_MODULE_2__env__["a" /* env */])(),
        wixPerformanceMeasurements = _env.wixPerformanceMeasurements;

    if (wixPerformanceMeasurements) {
      this._handleBlackboxPerformanceEntries(wixPerformanceMeasurements);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_2__env__["a" /* env */])().addEventListener && Object(__WEBPACK_IMPORTED_MODULE_2__env__["a" /* env */])().addEventListener('wixPerformanceMeasurements', function (event) {
        return _this4._handleBlackboxPerformance(event.detail);
      });
    }
  };

  _proto._handleBlackboxPerformanceEntries = function _handleBlackboxPerformanceEntries(measurements) {
    var _this5 = this;

    measurements.forEach(function (performanceEntry) {
      return performanceEntry.then && _this5._reportBlackboxEvent(performanceEntry);
    });
  };

  _proto._reportBlackboxEvent = function _reportBlackboxEvent(performanceEntryPromise) {
    var _this6 = this;

    var BLACKBOX_ENDPOINT = 'bpm';
    performanceEntryPromise.then(function (performanceEntry) {
      var blackboxBiDataItem = _this6.dataItems.biBlackbox(performanceEntry);

      var blackboxDataItem = _this6.dataItems.blackboxPerformance(performanceEntry);

      if (blackboxBiDataItem) {
        var dataSource = new __WEBPACK_IMPORTED_MODULE_5__data_source_data_source__["a" /* default */]().addItem(blackboxBiDataItem).addItem(blackboxDataItem);

        _this6._report(dataSource, BLACKBOX_ENDPOINT);
      }
    });
  };

  _proto.getLoggerForWidget = function getLoggerForWidget(_ref9) {
    var appName = _ref9.appName,
        appId = _ref9.appId,
        widgetId = _ref9.widgetId,
        version = _ref9.version,
        timeoutHook = _ref9.timeoutHook,
        startHook = _ref9.startHook,
        endHook = _ref9.endHook,
        useGlobalLogger = _ref9.useGlobalLogger,
        paramsOverrides = _ref9.paramsOverrides,
        phasesConfig = _ref9.phasesConfig;
    var widgetAppName = appName || appId + "_" + widgetId;
    var widgetVersion = version || this.getAppVersion();
    var reporter = useGlobalLogger ? this.reporter : Object(__WEBPACK_IMPORTED_MODULE_8__reporter_reporter_factory__["a" /* create */])({
      biLoggerFactory: this.reporter._factory,
      preset: this._preset
    });
    var config = {
      isServerSide: this.isServerSide,
      appId: appId,
      widgetId: widgetId,
      sessionId: this.sessionId,
      phasesConfig: phasesConfig || __WEBPACK_IMPORTED_MODULE_10__loading_phases_loading_phases_config__["a" /* phasesConfigValues */].SEND_ON_START,
      isPersistent: this.isPersistent,
      timeoutHook: timeoutHook,
      startHook: startHook,
      endHook: endHook,
      customParams: this._customParams,
      presetType: this._presetType,
      paramsOverrides: paramsOverrides
    };
    return new BaseLogger(widgetAppName, widgetVersion, reporter, config);
  };

  _createClass(BaseLogger, [{
    key: "dataSource",
    get: function get() {
      return this.dataSourceBase.clone();
    }
  }, {
    key: "sessionId",
    get: function get() {
      return this.getParam('sessionId');
    },
    set: function set(sessionId) {
      this.params['sessionId'] = sessionId;
    }
  }]);

  return BaseLogger;
}();



/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsentPolicyAccessor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consent_policy_accessor__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts__ = __webpack_require__(124);


var ConsentPolicyAccessor = /** @class */ (function () {
    function ConsentPolicyAccessor(env) {
        if (env) {
            this.env = env;
        }
        this.consentPolicyAccess = Object(__WEBPACK_IMPORTED_MODULE_0__consent_policy_accessor__["a" /* getConsentPolicyManager */])(this.env);
    }
    ConsentPolicyAccessor.prototype.getCurrentConsentPolicy = function () {
        if (!this.consentPolicyAccess) {
            this.consentPolicyAccess = Object(__WEBPACK_IMPORTED_MODULE_0__consent_policy_accessor__["a" /* getConsentPolicyManager */])(this.env);
        }
        var policyObj = (this.consentPolicyAccess &&
            this.consentPolicyAccess.getCurrentConsentPolicy()) ||
            __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* ALLOW_ALL_POLICY */];
        return policyObj.policy ? policyObj.policy : policyObj;
    };
    ConsentPolicyAccessor.prototype.getConsentPolicyHeader = function (valueOnly) {
        if (valueOnly === void 0) { valueOnly = false; }
        if (!this.consentPolicyAccess) {
            this.consentPolicyAccess = Object(__WEBPACK_IMPORTED_MODULE_0__consent_policy_accessor__["a" /* getConsentPolicyManager */])(this.env);
        }
        var consentPolicyHeaderObj = (this.consentPolicyAccess &&
            this.consentPolicyAccess._getConsentPolicyHeader()) || {
            'consent-policy': '',
        };
        return valueOnly
            ? consentPolicyHeaderObj['consent-policy']
            : consentPolicyHeaderObj;
    };
    return ConsentPolicyAccessor;
}());

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export getGlobalAccessor */
/* harmony export (immutable) */ __webpack_exports__["a"] = getConsentPolicyManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(124);

var globalContext;
function getGlobalAccessor() {
    [getGlobalThis, getGlobal, getSelf, getWindow].forEach(function (globalAccessFunc) {
        try {
            if (!globalContext) {
                globalContext = globalAccessFunc();
            }
        }
        catch (e) {
            // Lint this mofo
        }
    });
    return globalContext;
}
function getWindow() {
    return window;
}
function getSelf() {
    return self;
}
function getGlobal() {
    return global;
}
function getGlobalThis() {
    return globalThis;
}
function getConsentPolicyManager(env) {
    if (env === void 0) { env = undefined; }
    if (env) {
        globalContext = env;
    }
    if (!globalContext && !env) {
        globalContext = getGlobalAccessor();
    }
    var consentPolicyManager;
    try {
        if (typeof globalContext.commonConfig === 'object' &&
            globalContext.commonConfig.consentPolicy) {
            consentPolicyManager = wrapConsentPolicy(globalContext.commonConfig, __WEBPACK_IMPORTED_MODULE_0__consts__["c" /* PROPS_ACCESS */]);
        }
        if (!consentPolicyManager &&
            typeof globalContext.consentPolicyManager === 'object') {
            consentPolicyManager = wrapConsentPolicy(globalContext.consentPolicyManager, __WEBPACK_IMPORTED_MODULE_0__consts__["b" /* METHODS */]);
        }
        if (!consentPolicyManager &&
            typeof globalContext.Wix === 'object' &&
            typeof globalContext.Wix.Utils === 'object' &&
            typeof globalContext.Wix.Utils.getCurrentConsentPolicy === 'function') {
            consentPolicyManager = wrapConsentPolicy(globalContext.Wix.Utils, __WEBPACK_IMPORTED_MODULE_0__consts__["b" /* METHODS */]);
        }
    }
    catch (e) {
        // Lint this if you can
    }
    return consentPolicyManager;
}
function wrapConsentPolicy(accessor, conf) {
    return {
        getCurrentConsentPolicy: function () {
            var extractor = accessor[conf.policy];
            return conf.isMethod ? extractor() : extractor;
        },
        _getConsentPolicyHeader: function () {
            var extractor = accessor[conf.header];
            return conf.isMethod ? extractor() : extractor;
        },
    };
}
//# sourceMappingURL=consent-policy-accessor.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5)))

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataSource; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_items_common_data_item__ = __webpack_require__(41);

/**
 * Data accumulator
 */

var DataSource = /*#__PURE__*/function () {
  function DataSource(item) {
    var _this = this;

    if (item === void 0) {
      item = null;
    }

    this.items = [];

    if (item) {
      (typeof item.length === 'undefined' ? [item] : item).forEach(function (item) {
        return _this.addItem(item);
      });
    }
  }
  /**
   * Creates a new DataSource instance and clones internal state.
   *
   * @returns {DataSource}
   */


  var _proto = DataSource.prototype;

  _proto.clone = function clone() {
    return new DataSource(this.items.slice());
  }
  /**
   * Adds a new item.
   *
   * @param {Object | DataItem} item
   *
   * @return {DataSource} self
   */
  ;

  _proto.addItem = function addItem(item) {
    this.items.push(item instanceof __WEBPACK_IMPORTED_MODULE_0__data_items_common_data_item__["a" /* default */] ? item : new __WEBPACK_IMPORTED_MODULE_0__data_items_common_data_item__["a" /* default */](item));
    return this;
  }
  /**
   * Merges all added items into one plain object.
   *
   * @returns {Object}
   */
  ;

  _proto.mergeItems = function mergeItems() {
    var res = {};

    for (var i = 0; i < this.items.length; i++) {
      var item = this.items[i];

      if (!item.isActive()) {
        res = null;
        break;
      }

      var data = item["export"]();

      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          // eslint-disable-line
          res[key] = data[key];
        }
      }
    }

    return res;
  };

  return DataSource;
}();



/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__(17);

/**
 * Local storage wrapper (for tests mainly)
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  getItem: function getItem(key) {
    try {
      return Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().localStorage && Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().localStorage.getItem(key);
    } catch (e) {}
  },
  setItem: function setItem(key, value) {
    try {
      return Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().localStorage && Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().localStorage.setItem(key, value);
    } catch (e) {}
  }
});

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CODE_PARSING_PHASE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LoadingPhases; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__performance_performance__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__times_times__ = __webpack_require__(125);


var CODE_PARSING_PHASE_NAME = 'code-parsing-phase';

var LoadingPhases = /*#__PURE__*/function () {
  function LoadingPhases(appName, times) {
    this.appName = appName;
    this.phases = new Map();
    this.indexToKey = new Map();
    this.times = times || new __WEBPACK_IMPORTED_MODULE_1__times_times__["a" /* default */](appName);
  }

  LoadingPhases._getIndexForPhase = function _getIndexForPhase(_ref) {
    var name = _ref.name,
        _ref$appId = _ref.appId,
        appId = _ref$appId === void 0 ? '' : _ref$appId,
        _ref$widgetId = _ref.widgetId,
        widgetId = _ref$widgetId === void 0 ? '' : _ref$widgetId;
    return name + "_" + appId + "_" + widgetId;
  };

  var _proto = LoadingPhases.prototype;

  _proto.getAppLoadingPhaseData = function getAppLoadingPhaseData(_ref2) {
    var name = _ref2.name,
        appId = _ref2.appId,
        widgetId = _ref2.widgetId;
    return this.phases.get(LoadingPhases._getIndexForPhase({
      name: name,
      appId: appId,
      widgetId: widgetId
    }));
  };

  _proto.saveLoadingPhase = function saveLoadingPhase(_ref3) {
    var name = _ref3.name,
        appId = _ref3.appId,
        widgetId = _ref3.widgetId;

    var phaseKey = LoadingPhases._getIndexForPhase({
      name: name,
      appId: appId,
      widgetId: widgetId
    });

    if (!this.phases.has(phaseKey)) {
      var index = this.phases.size;
      this.phases.set(phaseKey, {
        name: name,
        phaseStartTime: __WEBPACK_IMPORTED_MODULE_0__performance_performance__["a" /* default */].now(),
        index: index
      });
      this.indexToKey.set(index, phaseKey);
    }
  };

  _proto.endLoadingPhase = function endLoadingPhase(_ref4) {
    var name = _ref4.name,
        appId = _ref4.appId,
        widgetId = _ref4.widgetId,
        widgetArray = _ref4.widgetArray;

    var phaseKey = LoadingPhases._getIndexForPhase({
      name: name,
      appId: appId,
      widgetId: widgetId
    });

    if (!this.phases.has(phaseKey) || this.phases.get(phaseKey).duration) {
      return;
    }

    var phase = this.phases.get(phaseKey);
    phase.duration = __WEBPACK_IMPORTED_MODULE_0__performance_performance__["a" /* default */].now() - phase.phaseStartTime;

    if (widgetArray) {
      phase.widgetArray = widgetArray;
    }

    if (widgetId) {
      phase.widgetId = widgetId;
    }

    this.phases.set(phaseKey, phase);
  };

  _proto.getNextPhaseToReport = function getNextPhaseToReport() {
    var latestStepIndex = this.phases.size - 1;
    var lastPhaseKey = this.indexToKey.get(latestStepIndex);
    return this.phases.get(lastPhaseKey);
  };

  _proto.getPhasePreviousTo = function getPhasePreviousTo(_ref5) {
    var name = _ref5.name,
        appId = _ref5.appId,
        widgetId = _ref5.widgetId;
    var currentPhase = this.phases.get(LoadingPhases._getIndexForPhase({
      name: name,
      appId: appId,
      widgetId: widgetId
    }));
    var previousPhaseIndex = this.indexToKey.get(currentPhase.index - 1);
    return this.phases.get(previousPhaseIndex);
  };

  _proto.getPhases = function getPhases(_temp) {
    var _ref6 = _temp === void 0 ? {} : _temp,
        appId = _ref6.appId;

    var phaseToNamedPhaseObject = function phaseToNamedPhaseObject(phase) {
      var _ref7;

      return _ref7 = {}, _ref7[phase.name] = phase, _ref7;
    };

    return Array.from(this.phases).filter(function (_ref8) {
      var phaseKey = _ref8[0];

      var _phaseKey$split = phaseKey.split('_'),
          appIdOfPhase = _phaseKey$split[1];

      return appId && appIdOfPhase === appId || !appId;
    }).map(function (_ref9) {
      var phase = _ref9[1];
      return phaseToNamedPhaseObject(phase);
    });
  };

  _proto.createCodeParsingPhaseIfNotExist = function createCodeParsingPhaseIfNotExist(_temp2) {
    var _ref10 = _temp2 === void 0 ? {} : _temp2,
        appId = _ref10.appId,
        widgetId = _ref10.widgetId;

    var phaseKey = LoadingPhases._getIndexForPhase({
      name: CODE_PARSING_PHASE_NAME,
      appId: appId,
      widgetId: widgetId
    });

    if (!this.phases.has(phaseKey)) {
      var appLoadStartTime = this.times.getLoadStartTime({
        appId: appId,
        widgetId: widgetId
      });
      this.phases.set(phaseKey, {
        phaseStartTime: appLoadStartTime,
        index: 0,
        name: CODE_PARSING_PHASE_NAME
      });
      this.indexToKey.set(0, phaseKey);
    }
  };

  return LoadingPhases;
}();



/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataItems; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_data_item__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_bi_app_context_item__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resource_resource_item__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__duration_duration_item__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__phases_utils__ = __webpack_require__(247);





var DataItems = /*#__PURE__*/function () {
  function DataItems(sessionId, preset) {
    this._sessionId = sessionId;
    this._preset = preset;
  }

  var _proto = DataItems.prototype;

  _proto.biAppLoadStart = function biAppLoadStart() {
    return this._biDataItem(this._preset.appLoadStart.eventId);
  };

  _proto.biAppLoadFinish = function biAppLoadFinish() {
    return this._biDataItem(this._preset.appLoadFinish.eventId);
  };

  _proto.biInteractionStart = function biInteractionStart() {
    return this._biDataItem(this._preset.interactionStart.eventId);
  };

  _proto.biInteractionEnd = function biInteractionEnd() {
    return this._biDataItem(this._preset.interactionEnd.eventId);
  };

  _proto.biLoadPhaseStart = function biLoadPhaseStart() {
    return this._biDataItem(this._preset.loadPhaseStart.eventId);
  };

  _proto.biLoadPhaseFinish = function biLoadPhaseFinish() {
    return this._biDataItem(this._preset.loadPhaseFinish.eventId);
  };

  _proto.biBlackbox = function biBlackbox(performanceEntry) {
    var entryTypeToEventId = {
      environment: 500,
      'initial-paint': 501,
      loaded: 502,
      visibility: 503,
      'first-input': 504
    };
    var eventId = entryTypeToEventId[performanceEntry.entryType];
    return eventId && this._biDataItem(eventId);
  };

  _proto.blackboxPerformance = function blackboxPerformance(performanceEntry) {
    return this.dataItem(performanceEntry);
  };

  _proto.biError = function biError() {
    return this._biDataItem(this._preset.error.eventId);
  };

  _proto.appName = function appName(_ref) {
    var _appName = _ref.appName,
        isServerSide = _ref.isServerSide;
    return this.dataItem({
      appName: isServerSide ? _appName + '_ssr' : _appName
    });
  };

  _proto.artifact = function artifact(_ref2) {
    var artifactId = _ref2.id,
        artifactVersion = _ref2.version,
        isRollout = _ref2.isRollout;
    return this.dataItem({
      artifactId: artifactId,
      artifactVersion: artifactVersion,
      isRollout: isRollout
    });
  };

  _proto.appContext = function appContext(params) {
    return new __WEBPACK_IMPORTED_MODULE_1__common_bi_app_context_item__["a" /* default */](params);
  };

  _proto.customParams = function customParams(_customParams) {
    return this.dataItem({
      customParams: _customParams
    });
  };

  _proto.duration = function duration(_duration) {
    return new __WEBPACK_IMPORTED_MODULE_3__duration_duration_item__["a" /* default */](_duration);
  };

  _proto.loadingPhaseCollection = function loadingPhaseCollection(phasesOfApp) {
    var phases = JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_4__phases_utils__["b" /* createPhasesCollection */])(phasesOfApp));
    return this.dataItem({
      phases: phases
    });
  };

  _proto.loadingPhaseStart = function loadingPhaseStart(_ref3) {
    var name = _ref3.name;
    return this.dataItem({
      name: name
    });
  };

  _proto.loadingPhaseFinish = function loadingPhaseFinish(_ref4) {
    var name = _ref4.name,
        phaseStartTime = _ref4.phaseStartTime;
    var duration = Object(__WEBPACK_IMPORTED_MODULE_4__phases_utils__["a" /* calcPhaseDuration */])(phaseStartTime);
    return this.dataItem({
      name: name,
      duration: duration
    });
  };

  _proto.resource = function resource() {
    var data = this._asBiEvent(this._preset.resource.eventId);

    return new __WEBPACK_IMPORTED_MODULE_2__resource_resource_item__["a" /* default */](data);
  };

  _proto.dataItem = function dataItem(params) {
    return new __WEBPACK_IMPORTED_MODULE_0__common_data_item__["a" /* default */](params);
  };

  _proto._biDataItem = function _biDataItem(eventId) {
    var data = this._asBiEvent(eventId);

    return this.dataItem(data);
  };

  _proto._asBiEvent = function _asBiEvent(evid) {
    return {
      src: this._preset.src,
      evid: evid,
      session_id: this._sessionId,
      _: new Date().getTime() // cache buster

    };
  };

  return DataItems;
}();

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BiAppContextDataItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_item__ = __webpack_require__(41);
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }



var BiAppContextDataItem = /*#__PURE__*/function (_DataItem) {
  _inheritsLoose(BiAppContextDataItem, _DataItem);

  function BiAppContextDataItem(_ref) {
    var _this;

    var appId = _ref.appId,
        widgetId = _ref.widgetId,
        isServerSide = _ref.isServerSide,
        widgetArray = _ref.widgetArray;
    _this = _DataItem.call(this) || this;
    _this.data = _this._filterUndefined({
      appId: appId,
      widgetId: widgetId,
      isServerSide: isServerSide,
      widgetArray: widgetArray
    });
    return _this;
  }

  var _proto = BiAppContextDataItem.prototype;

  _proto._filterUndefined = function _filterUndefined(contextData) {
    var definedValues = {};
    Object.keys(contextData).forEach(function (key) {
      if (contextData[key]) {
        definedValues[key] = contextData[key];
      }
    });
    return definedValues;
  };

  return BiAppContextDataItem;
}(__WEBPACK_IMPORTED_MODULE_0__data_item__["a" /* default */]);



/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResourceDataItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_data_item__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_app_data_location__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__performance_performance__ = __webpack_require__(26);
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var RESOURCES_TYPES = {
  xmlhttprequest: {
    count: 'countXhr',
    unsupported: 'unsprtXhr',
    duration: 'timeXhr',
    total: 'sizeXhr',
    longest: 'longXhr',
    http2: 'h2Xhr'
  },
  script: {
    count: 'countJs',
    unsupported: 'unsprtJs',
    duration: 'timeJs',
    total: 'sizeJs',
    cached: 'cachedJs',
    http2: 'h2Js'
  },
  link: {
    // css
    count: 'countCss',
    unsupported: 'unsprtCss',
    duration: 'timeCss',
    total: 'sizeCss',
    cached: 'cachedCss',
    http2: 'h2Css'
  },
  img: {
    count: 'countImg',
    unsupported: 'unsprtImg',
    duration: 'timeImg',
    total: 'sizeImg',
    cached: 'cachedImages',
    http2: 'h2Images'
  }
};
var CUSTOM_VALIDATORS = {
  link: function link(resource) {
    return /(.\.css$|.\.css?.)/g.test(resource.name);
  }
};

var durationOf = function durationOf(item) {
  return item.responseEnd - item.startTime;
};

function filterResourcesByType(resources, type) {
  var validator = CUSTOM_VALIDATORS[type];
  return resources.filter(function (r) {
    return type === r.initiatorType && (validator ? validator(r) : true);
  });
}

function calculateTotalSizeOfResource(resources) {
  return resources.reduce(function (totalSize, resource) {
    return totalSize + resource.transferSize;
  }, 0);
}

function calculateResourceLoadLongestDuration(resources) {
  if (resources.length === 0) {
    return 0;
  }

  var longest = resources.reduce(function (acc, cur) {
    return durationOf(cur) >= durationOf(acc) ? cur : acc;
  });
  return durationOf(longest);
}

function calculateResourceLoadDuration(resources) {
  if (resources.length === 0) {
    return 0;
  }

  var loadStartStop = {
    startTime: Infinity,
    responseEnd: 0
  };
  resources.forEach(function (r) {
    if (loadStartStop.startTime > r.startTime) {
      loadStartStop.startTime = r.startTime;
    }

    if (loadStartStop.responseEnd < r.responseEnd) {
      loadStartStop.responseEnd = r.responseEnd;
    }
  });
  return loadStartStop.responseEnd - loadStartStop.startTime;
}

function calculatePercentageOfUnsupportedResources(resources) {
  var totalCount = resources.length;

  if (totalCount === 0) {
    return 0;
  }

  var unsupportedCount = resources.filter(isResourceUnsupported).length;
  return Math.round(unsupportedCount / totalCount * 100);
}

function calculateCachedResourcesPercentage(resources) {
  if (resources.length === 0) {
    return 0;
  }

  var cached = resources.filter(function (r) {
    return r.transferSize === 0;
  });
  return Math.round(cached.length / resources.length * 100);
}

function calculatePercentageOfHttp2(resources) {
  if (resources.length === 0) {
    return 0;
  }

  var supported = false;
  var res = Math.round(resources.filter(function (r) {
    supported = supported || 'nextHopProtocol' in r;
    return r.nextHopProtocol === 'h2';
  }).length / resources.length * 100);
  return supported ? res : NaN;
}

function isResourceRelevant(resource) {
  return !resource.name.match(/http(s)?:\/\/frog.wix.com\//);
}

function isResourceUnsupported(resource) {
  return isCORS(resource.name) && resource.transferSize === 0 && resource.requestStart === 0;
}

function isCORS(resourceName) {
  var host = __WEBPACK_IMPORTED_MODULE_1__global_app_data_location__["a" /* default */].getHost();
  return host && resourceName.indexOf(host) === -1;
}

function normalizeValues(analysis) {
  return Object.keys(analysis).reduce(function (result, key) {
    var n = parseInt(analysis[key]);

    if (!isNaN(n) && typeof n === 'number') {
      result[key] = n;
    }

    return result;
  }, {});
}

function countAllResourcesByType(resources) {
  var supportedResources = resources.filter(function (r) {
    return !isResourceUnsupported(r);
  });
  return Object.keys(RESOURCES_TYPES).reduce(function (result, currentType) {
    var allSameTypeResources = filterResourcesByType(resources, currentType);
    var supportedSameTypeResources = filterResourcesByType(supportedResources, currentType);
    var type = RESOURCES_TYPES[currentType];
    result[type.count] = supportedSameTypeResources.length;
    result[type.duration] = calculateResourceLoadDuration(supportedSameTypeResources);
    result[type.total] = calculateTotalSizeOfResource(supportedSameTypeResources);
    result[type.unsupported] = calculatePercentageOfUnsupportedResources(allSameTypeResources);
    result[type.http2] = calculatePercentageOfHttp2(allSameTypeResources);

    if (type.longest) {
      result[type.longest] = calculateResourceLoadLongestDuration(supportedSameTypeResources);
    }

    if (type.cached) {
      result[type.cached] = calculateCachedResourcesPercentage(supportedSameTypeResources);
    }

    return result;
  }, {});
}

function extractResourceMetrics(resource) {
  return {
    url: resource.name,
    downloadDuration: resource.responseEnd - resource.startTime,
    bytesTransferred: resource.transferSize,
    isHTTP2: resource.nextHopProtocol === 'h2'
  };
}

function getResourcesBreakdown(resources) {
  var resourcesPartition = resources.reduce(function (result, r) {
    if (isResourceUnsupported(r)) {
      result.unsupported.push(r);
    } else {
      result.supported.push(r);
    }

    return result;
  }, {
    supported: [],
    unsupported: []
  });
  return Object.keys(RESOURCES_TYPES).reduce(function (result, currentType) {
    result[currentType] = {};
    result[currentType].supported = filterResourcesByType(resourcesPartition.supported, currentType).map(function (r) {
      return extractResourceMetrics(r);
    });
    result[currentType].unsupported = filterResourcesByType(resourcesPartition.unsupported, currentType).map(function (r) {
      return extractResourceMetrics(r);
    });
    return result;
  }, {});
}

var ResourceDataItem = /*#__PURE__*/function (_DataItem) {
  _inheritsLoose(ResourceDataItem, _DataItem);

  function ResourceDataItem() {
    return _DataItem.apply(this, arguments) || this;
  }

  var _proto = ResourceDataItem.prototype;

  _proto.performNetworkAnalysis = function performNetworkAnalysis(resources) {
    if (resources.length === 0) {
      return null;
    }

    var t0 = __WEBPACK_IMPORTED_MODULE_2__performance_performance__["a" /* default */].now();
    var resourcesToHandle = resources.filter(isResourceRelevant);
    var analysis = countAllResourcesByType(resourcesToHandle);
    analysis.overhead = __WEBPACK_IMPORTED_MODULE_2__performance_performance__["a" /* default */].now() - t0;
    var result = normalizeValues(analysis);

    if (console.debug && __WEBPACK_IMPORTED_MODULE_1__global_app_data_location__["a" /* default */].isFedopsDev()) {
      var resourcesBreakdown = getResourcesBreakdown(resourcesToHandle);
      console.debug("[fedops network analysis] [bytes analysis]\n" + JSON.stringify(result, null, 4));
      console.debug("[fedops network analysis] [resources breakdown]\n", resourcesBreakdown);
    }

    return result;
  };

  return ResourceDataItem;
}(__WEBPACK_IMPORTED_MODULE_0__common_data_item__["a" /* default */]);



/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__(17);


var location = function location() {
  return typeof Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])() !== 'undefined' && Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().location;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getHost: function getHost() {
    return location() && Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().location.host;
  },
  isFedopsDev: function isFedopsDev() {
    var q = (location() || {}).search || '';
    return q.indexOf("fedops=dev") > -1;
  }
});

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DurationDataItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_data_item__ = __webpack_require__(41);
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }



var DurationDataItem = /*#__PURE__*/function (_DataItem) {
  _inheritsLoose(DurationDataItem, _DataItem);

  function DurationDataItem(duration) {
    return _DataItem.call(this, {
      duration: duration
    }) || this;
  }

  var _proto = DurationDataItem.prototype;

  _proto.setFirstRequestDuration = function setFirstRequestDuration(firstRequestDuration) {
    this.data.frd = firstRequestDuration;
    return this;
  };

  return DurationDataItem;
}(__WEBPACK_IMPORTED_MODULE_0__common_data_item__["a" /* default */]);



/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createPhasesCollection;
/* harmony export (immutable) */ __webpack_exports__["a"] = calcPhaseDuration;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__performance_performance__ = __webpack_require__(26);
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } it = o[Symbol.iterator](); return it.next.bind(it); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


function createPhasesCollection(phasesOfApp) {
  var phases = {};

  for (var _iterator = _createForOfIteratorHelperLoose(phasesOfApp), _step; !(_step = _iterator()).done;) {
    var phase = _step.value;
    deleteIndexFrom(phase);
    phases = Object.assign(phases, phase);
  }

  return phases;
}
function calcPhaseDuration(phaseStartTime) {
  return Math.floor(__WEBPACK_IMPORTED_MODULE_0__performance_performance__["a" /* default */].now() - phaseStartTime);
}

function deleteIndexFrom(phase) {
  delete phase[Object.getOwnPropertyNames(phase)[0]].index;
}

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__(17);

/**
 * env().performance wrappers
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  getNavigation: function getNavigation() {
    return typeof Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])() !== 'undefined' && Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().performance ? Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().performance.navigation : {};
  },

  /**
   * get all loaded resources
   */
  getResources: function getResources() {
    var emptyVal = [];

    try {
      return Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])() && Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().performance && Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().performance.getEntriesByType && Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().performance.getEntriesByType('resource') || emptyVal;
    } catch (e) {
      return emptyVal;
    }
  },
  getTiming: function getTiming() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])() && Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().performance ? Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().performance.timing : {};
  },
  clearResourceTimings: function clearResourceTimings() {
    Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])() && Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().performance && Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().performance.clearResourceTimings && Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().performance.clearResourceTimings();
  },

  /**
   * Duration relative to navigation start (env().performance.timing.navigationStart)
   * fallback to: performance.now -> now (nodejs) -> getTime()
   */
  now: function now() {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])() && Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().performance && Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().performance.now) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().performance.now();
    } else if (typeof performance !== 'undefined' && performance && performance.now) {
      return performance.now();
    }

    return new Date().getTime();
  },

  /**
   * Duration from fetch start to response end
   */
  responseEndTime: function responseEndTime() {
    if (typeof performance !== 'undefined' && performance && performance.timing && performance.timing.responseEnd && performance.timing.fetchStart) {
      return performance.timing.responseEnd - performance.timing.fetchStart;
    }
  },

  /**
   * Create a performance timestamp
   */
  mark: function mark(name) {
    Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])() && Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().performance && Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().performance.mark && Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().performance.mark(name);
  },

  /**
   * Record a performance measurement
   */
  measure: function measure(name, startMark, endMark) {
    Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])() && Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().performance && Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().performance.measure && Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().performance.measure(name, startMark, endMark);
  }
});

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ 279:
/***/ (function(module, exports) {

module.exports = {"app_name":"restaurants-socialbar","notifications":{"slack_channels":["restaurants-urgent"]},"deploy_annotations":["restaurants-socialbar-ssr"],"interactions":{},"app_ipm_scale":3,"lighthouse_links":["https://jonnybordo.wixsite.com/speedy"]}

/***/ }),

/***/ 28:
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(27);
var IE8_DOM_DEFINE = __webpack_require__(140);
var toPrimitive = __webpack_require__(106);
var dP = Object.defineProperty;

exports.f = __webpack_require__(20) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultCommonConfig = exports.DefaultConsentPolicy = exports.BrandToHostMap = exports.DefaultBrand = exports.EventContextMap = exports.LoggerVersion = void 0;
exports.LoggerVersion = '2.0.875';
var EventContextMap;
(function (EventContextMap) {
    EventContextMap["msid"] = "_msid";
    EventContextMap["clientId"] = "_client_id";
    EventContextMap["uuid"] = "_uuid";
    EventContextMap["visitorId"] = "_visitorId";
    EventContextMap["siteMemberId"] = "_siteMemberId";
    EventContextMap["brandId"] = "_brandId";
})(EventContextMap = exports.EventContextMap || (exports.EventContextMap = {}));
exports.DefaultBrand = 'wix';
exports.BrandToHostMap = {
    wix: 'wix',
    editorx: 'editorx',
};
exports.DefaultConsentPolicy = {
    functional: true,
    analytics: true,
};
exports.DefaultCommonConfig = {
    brand: exports.DefaultBrand,
};
//# sourceMappingURL=constants.js.map

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(147);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(191);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataItem; });
var DataItem = /*#__PURE__*/function () {
  function DataItem(data) {
    if (data === void 0) {
      data = undefined;
    }

    this.data = data;
  }

  var _proto = DataItem.prototype;

  _proto.isActive = function isActive() {
    return true;
  };

  _proto["export"] = function _export() {
    return this.data;
  };

  return DataItem;
}();



/***/ }),

/***/ 42:
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ 43:
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(78),
    getRawTag = __webpack_require__(212),
    objectToString = __webpack_require__(213);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 46:
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(35);
var createDesc = __webpack_require__(71);
module.exports = __webpack_require__(20) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(108);
var defined = __webpack_require__(87);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.readCookie = exports.sendBeacon = exports.getWindowSize = exports.getDesktopSize = exports.now = void 0;
function now() {
    return typeof performance !== 'undefined' && performance && performance.now
        ? performance.now()
        : -1;
}
exports.now = now;
function getDesktopSize(window) {
    var width = (window.screen && window.screen.width) || 0;
    var height = (window.screen && window.screen.height) || 0;
    return width + "x" + height;
}
exports.getDesktopSize = getDesktopSize;
function getWindowSize(window) {
    var width = 0;
    var height = 0;
    if (window.innerWidth) {
        width = window.innerWidth;
        height = window.innerHeight;
    }
    else if (window.document) {
        if (window.document.documentElement &&
            window.document.documentElement.clientWidth) {
            width = window.document.documentElement.clientWidth;
            height = window.document.documentElement.clientHeight;
        }
        else if (window.document.body && window.document.body.clientWidth) {
            width = window.document.body.clientWidth;
            height = window.document.body.clientHeight;
        }
    }
    return width + "x" + height;
}
exports.getWindowSize = getWindowSize;
function sendBeacon(url, data) {
    if (typeof navigator === 'undefined' || !navigator || !navigator.sendBeacon) {
        return false;
    }
    return navigator.sendBeacon(url, data);
}
exports.sendBeacon = sendBeacon;
function readCookie(cookieName) {
    if (typeof document === 'undefined') {
        return null;
    }
    var cookies = document.cookie.split(';');
    for (var _i = 0, cookies_1 = cookies; _i < cookies_1.length; _i++) {
        var cookie = cookies_1[_i];
        var pair = cookie.split('=');
        var name_1 = pair[0];
        var value = pair[1];
        while (name_1[0] === ' ') {
            name_1 = name_1.substr(1);
        }
        if (name_1 === cookieName) {
            return value;
        }
    }
    return '';
}
exports.readCookie = readCookie;
//# sourceMappingURL=browser.js.map

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(87);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(89);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(45),
    isObjectLike = __webpack_require__(46);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 7:
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ 70:
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ 71:
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(141);
var enumBugKeys = __webpack_require__(110);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ 73:
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssertionError = function (_Error) {
  _inherits(AssertionError, _Error);

  function AssertionError(message) {
    _classCallCheck(this, AssertionError);

    var _this = _possibleConstructorReturn(this, (AssertionError.__proto__ || Object.getPrototypeOf(AssertionError)).call(this, message));

    _this.name = _this.constructor.name;
    return _this;
  }

  return AssertionError;
}(Error);

function assertDefined(target, message) {
  if (target === undefined) {
    throw new AssertionError(message);
  }
}

function assertObject(target, message) {
  if (target !== undefined && ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) !== 'object' || Array.isArray(target) || target === null)) {
    throw new AssertionError(message);
  }
}

function assertOk(target, message) {
  if (!target) {
    throw new AssertionError(message);
  }
}

function assertFunc(target, message) {
  if (target !== undefined && typeof target !== 'function') {
    throw new AssertionError(message);
  }
}

module.exports.defined = assertDefined;
module.exports.object = assertObject;
module.exports.ok = assertOk;
module.exports.func = assertFunc;
module.exports.AssertionError = AssertionError;
//# sourceMappingURL=assert.js.map

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.guid = exports.buildBiUrl = exports.getCookies = void 0;
var browser_1 = __webpack_require__(55);
var env_1 = __webpack_require__(15);
var cacheKillerCounter = 0;
function getCookies(params) {
    return Object.keys(params).reduce(function (res, param) {
        var _a = typeof params[param] === 'string'
            ? { name: params[param] }
            : params[param], name = _a.name, _b = _a.transform, transform = _b === void 0 ? function (x) { return x; } : _b;
        var value = transform(browser_1.readCookie(name));
        if (value) {
            res[param] = value;
        }
        return res;
    }, {});
}
exports.getCookies = getCookies;
function buildBiUrl(_a, params, context) {
    var _b = _a.host, host = _b === void 0 ? '' : _b, _c = _a.endpoint, endpoint = _c === void 0 ? '' : _c;
    if (context === void 0) { context = {}; }
    host = typeof host === 'function' ? host() : host;
    host = host || env_1.getHost();
    endpoint = context.endpoint || endpoint;
    if (!context.useBatch) {
        params._ = '' + new Date().getTime() + cacheKillerCounter++;
    }
    var pairs = context.useBatch
        ? []
        : Object.keys(params).map(function (key) {
            return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
        }, []);
    return ["//" + host + "/" + endpoint]
        .concat(pairs.length ? pairs.join('&') : [])
        .join('?');
}
exports.buildBiUrl = buildBiUrl;
function guid() {
    /*eslint-disable */
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0;
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
    /*eslint-enable */
}
exports.guid = guid;
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.APINotSupportedError = exports.AssertionError = void 0;
var AssertionError = /** @class */ (function (_super) {
    __extends(AssertionError, _super);
    function AssertionError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = _this.constructor.name;
        return _this;
    }
    return AssertionError;
}(Error));
exports.AssertionError = AssertionError;
var APINotSupportedError = /** @class */ (function (_super) {
    __extends(APINotSupportedError, _super);
    function APINotSupportedError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = _this.constructor.name;
        return _this;
    }
    return APINotSupportedError;
}(Error));
exports.APINotSupportedError = APINotSupportedError;
//# sourceMappingURL=errors.js.map

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Errors = exports.EventCategories = exports.PublishMethods = void 0;
var PublishMethods;
(function (PublishMethods) {
    PublishMethods["Auto"] = "auto";
    PublishMethods["PostMessage"] = "postMessage";
})(PublishMethods = exports.PublishMethods || (exports.PublishMethods = {}));
var EventCategories;
(function (EventCategories) {
    EventCategories["Essential"] = "essential";
    EventCategories["Functional"] = "functional";
    EventCategories["Analytics"] = "analytics";
})(EventCategories = exports.EventCategories || (exports.EventCategories = {}));
var Errors;
(function (Errors) {
    Errors[Errors["Unsupported"] = 0] = "Unsupported";
})(Errors = exports.Errors || (exports.Errors = {}));
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(37);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 8:
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initializeFedops */
/* unused harmony export initializeApp */
/* harmony export (immutable) */ __webpack_exports__["b"] = initializeGlobal;
/* harmony export (immutable) */ __webpack_exports__["a"] = getLoadStartTime;
/* harmony export (immutable) */ __webpack_exports__["c"] = setLoadStartTime;
/* harmony export (immutable) */ __webpack_exports__["d"] = setSessionId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__(17);


function getAppData(appName) {
  return ((Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().fedops || {}).apps || {})[appName];
}

function initializeFedops() {
  Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().fedops = Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().fedops || {};
  Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().fedops.apps = Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().fedops.apps || {};
}
function initializeApp(appName) {
  Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().fedops.apps[appName] = Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().fedops.apps[appName] || {};
}
function initializeGlobal(appName) {
  initializeFedops();
  initializeApp(appName);
}
function getLoadStartTime(appName) {
  return (getAppData(appName) || {}).startLoadTime || 0;
}
function setLoadStartTime(appName, startLoadTime) {
  return (getAppData(appName) || {}).startLoadTime = startLoadTime;
}
function setSessionId(sessionId) {
  return (Object(__WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */])().fedops || {}).sessionId = sessionId;
}

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ 88:
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ 89:
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ 90:
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ 92:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 93:
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ })

/******/ });


// WEBPACK FOOTER //
// viewer.bundle.min.js